export interface IEmpresas {
  id_empresa_carbono: string
  id_empresa: string
  id_tipo_empresa: string
  nombre_empresa: string
  id_rol: string
  tipo_sociedad?: string
  id_pais: string
  relacion_proyecto: Array<string>
  // rol?: string
  // pais?: string
  // ciudad?: string
  perfil_es?: string
  perfil_en?: string
  perfil_pt?: string
}
// export const Empresas: IEmpresas[] = [
//   {
//     id_empresa: '12.028.178/0001-20',
//     id_empresa_carbono: 'BR0001EM',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR1654VER',
//       'BR2508VER',
//       'BR2539VER',
//       'BR3002VER',
//       'BR3055VER',
//       'BR3324VER',
//       'BR3601VER',
//       'BR4671VER',
//       'BR4681VER',
//       'BR4857VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4876VER',
//       'BR4886VER',
//     ],
//   },
//   {
//     id_empresa: '19.763.569/0001-37',
//     id_empresa_carbono: 'BR0002EM',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Porto Alegre',
//     departamento: 'RS',
//     relacion_proyecto: ['BR4886VER'],
//   },
//   {
//     id_empresa: '13.046.954/0001-87',
//     id_empresa_carbono: 'BR0003EM',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Porto Alegre',
//     departamento: 'RS',
//     relacion_proyecto: ['BR4886VER'],
//   },
//   {
//     id_empresa: '19.666.030/0001-60',
//     id_empresa_carbono: 'BR0004EM',
//     nombre_empresa: 'PACER INOVACAO LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4876VER'],
//   },
//   {
//     id_empresa: '04.129.037/0001-75',
//     id_empresa_carbono: 'BR0005EM',
//     nombre_empresa: 'MARCOS ANTONIO MATANA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresário (Individual)',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Ji-Paraná',
//     departamento: 'RO',
//     relacion_proyecto: ['BR4865VER'],
//   },
//   {
//     id_empresa: '03.472.750/0001-54',
//     id_empresa_carbono: 'BR0006EM',
//     nombre_empresa: 'AGROPECUARIA CHAPADA DOS GUIMARAES S A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Araçatuba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4867VER'],
//   },
//   {
//     id_empresa: '24.727.505/0001-10',
//     id_empresa_carbono: 'BR0007EM',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rondonópolis',
//     departamento: 'MT',
//     relacion_proyecto: ['BR4867VER'],
//   },
//   {
//     id_empresa: '03.486.071/0001-34',
//     id_empresa_carbono: 'BR0008EM',
//     nombre_empresa:
//       'Associação dos Remanescentes de Quilombos de Gurupá - ARQMG ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Gurupá',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4857VER'],
//   },
//   {
//     id_empresa: '42.161.900/0001-60',
//     id_empresa_carbono: 'BR0009EM',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA ',
//     rol: 'mediador',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4681VER', 'BR4857VER'],
//   },
//   {
//     id_empresa: '39.693.526/0001-30',
//     id_empresa_carbono: 'BR0010EM',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR2551VER',
//       'BR4042VER',
//       'BR4542VER',
//       'BR4542VER',
//       'BR4850VER',
//     ],
//   },
//   {
//     id_empresa: '46.590.622/0001-18',
//     id_empresa_carbono: 'BR0011EM',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vilhena',
//     departamento: 'RO',
//     relacion_proyecto: ['BR4850VER'],
//   },
//   {
//     id_empresa: '23.831.247/0001-55',
//     id_empresa_carbono: 'BR0012EM',
//     nombre_empresa: 'Ituxi Administração e Participação LTDA',
//     rol: 'desenvolvedor/proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Porto Velho',
//     departamento: 'RO',
//     relacion_proyecto: [
//       'BR2508VER',
//       'BR2539VER',
//       'BR3816VER',
//       'BR4633VER',
//       'BR4825VER',
//       '',
//       '',
//       '',
//       '',
//       '',
//       '',
//       '',
//       '',
//       '',
//     ],
//   },
//   {
//     id_empresa: '45.879.260/0001-17',
//     id_empresa_carbono: 'BR0013EM',
//     nombre_empresa: 'Pau Brasil Assessoria Florestal',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vila Velha',
//     departamento: 'ES',
//     relacion_proyecto: ['BR4633VER', 'BR4825VER'],
//   },
//   {
//     id_empresa: '09.720.550/0001-50',
//     id_empresa_carbono: 'BR0014EM',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR1115VER',
//       'BR1329VER',
//       'BR1503VER',
//       'BR1571VER',
//       'BR1811VER',
//       'BR3430VER',
//       'BR3590VER',
//       'BR4034VER',
//       'BR4615VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4747VER',
//     ],
//   },
//   {
//     id_empresa: '42.551.951/0001-07',
//     id_empresa_carbono: 'BR0015EM',
//     nombre_empresa: 'Instituto Taquari Vivo - ITV',
//     rol: 'mediador',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Campo Grande',
//     departamento: 'MS',
//     relacion_proyecto: ['BR4747VER'],
//   },
//   {
//     id_empresa: '44.181.146/0001-56',
//     id_empresa_carbono: 'BR0016EM',
//     nombre_empresa: 'Restaura Consultoria Ambiental e Treinamentos LTDA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Campo Grande',
//     departamento: 'MS',
//     relacion_proyecto: ['BR4747VER'],
//   },
//   {
//     id_empresa: '10.658.609/0001-06',
//     id_empresa_carbono: 'BR0017EM',
//     nombre_empresa:
//       'STA Soluções Técnicas e Serviços de Engenharia Ambiental Ltda',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3590VER', 'BR4687VER', 'BR4747VER'],
//   },
//   {
//     id_empresa: '10.245.529/0001-29',
//     id_empresa_carbono: 'BR0018EM',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Simples Pura',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4747VER'],
//   },
//   {
//     id_empresa: '51.840.317/0001-77',
//     id_empresa_carbono: 'BR0019EM',
//     nombre_empresa: 'Associação Aliança 5P',
//     rol: 'mediador',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Campo Grande',
//     departamento: 'MS',
//     relacion_proyecto: ['BR4747VER'],
//   },
//   {
//     id_empresa: '04.737.144/0001-86',
//     id_empresa_carbono: 'BR0020EM',
//     nombre_empresa: 'Brascomp Compensados do Brasil S.A.',
//     rol: 'proprietária',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Ananindeua',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4687VER'],
//   },
//   {
//     id_empresa: '07.336.695/0001-26',
//     id_empresa_carbono: 'BR0021EM',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Palmas',
//     departamento: 'TO',
//     relacion_proyecto: ['BR4142VER', 'BR4689VER'],
//   },
//   {
//     id_empresa: '01.852.356/0001-16',
//     id_empresa_carbono: 'BR0022EM',
//     nombre_empresa: 'Ambiens Soluções Ambientais',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4034VER', 'BR4689VER'],
//   },
//   {
//     id_empresa: '02.650.035/0001-00',
//     id_empresa_carbono: 'BR0023EM',
//     nombre_empresa: 'Instituto Peabiru',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4034VER', 'BR4689VER'],
//   },
//   {
//     id_empresa: '03.705.896/0001-00',
//     id_empresa_carbono: 'BR0024EM',
//     nombre_empresa: 'Biodendro Consultoria Florestal LTDA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4034VER', 'BR4689VER'],
//   },
//   {
//     id_empresa: '51.504.594/0001-09',
//     id_empresa_carbono: 'BR0025EM',
//     nombre_empresa: 'COOPERCARBON – Cooperativa ',
//     rol: 'representante legal dos assentados',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Cooperativa',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4681VER'],
//   },
//   {
//     id_empresa: '22.694.956/0001-73',
//     id_empresa_carbono: 'BR0026EM',
//     nombre_empresa: 'GEOMASTER GEOTECNOLOGIA AMBIENTAL LTDA',
//     rol: 'suporte local para georreferenciamento e monitoramento',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4681VER'],
//   },
//   {
//     id_empresa: '10.203.779/0001-04',
//     id_empresa_carbono: 'BR0027EM',
//     nombre_empresa: 'Arthur Chiarotto Penteado',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Produtor Rural (Pessoa Física)',
//     id_tipo_empresa: 'pf',
//     pais: 'Brasil',
//     ciudad: 'Cravinhos',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4671VER'],
//   },
//   {
//     id_empresa: '08.430.917/0001-38',
//     id_empresa_carbono: 'BR0028EM',
//     nombre_empresa: 'Arthur Junqueira Ferreira Penteado ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Produtor Rural (Pessoa Física)',
//     id_tipo_empresa: 'pf',
//     pais: 'Brasil',
//     ciudad: 'Cravinhos',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4671VER'],
//   },
//   {
//     id_empresa: '44.947.794/0001-70',
//     id_empresa_carbono: 'BR0029EM',
//     nombre_empresa: 'FAZENDA CONTINENTAL LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Indianópolis',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4671VER'],
//   },
//   {
//     id_empresa: '74.502.550/0001-45',
//     id_empresa_carbono: 'BR0030EM',
//     nombre_empresa: 'Fundação Jari',
//     rol: '',
//     id_rol: '',
//     tipo_sociedad: 'Fundação Privada',
//     id_tipo_empresa: 'fundacion_privada',
//     pais: 'Brasil',
//     ciudad: 'Almeirim',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4615VER'],
//   },
//   {
//     id_empresa: '17.919.786/0001-48',
//     id_empresa_carbono: 'BR0031EM',
//     nombre_empresa: 'GRUPO JARI S.A EM RECUPERACAO JUDICIAL',
//     rol: '',
//     id_rol: '',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Barueri',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4615VER'],
//   },
//   {
//     id_empresa: '46.831.892/0001-73',
//     id_empresa_carbono: 'BR0032EM',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     rol: '',
//     id_rol: '',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vilhena',
//     departamento: 'RO',
//     relacion_proyecto: ['BR4542VER'],
//   },
//   {
//     id_empresa: '04.193.033/0001-56',
//     id_empresa_carbono: 'BR0033EM',
//     nombre_empresa: 'Mil Madeiras Preciosas LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Itacoatiara',
//     departamento: 'AM',
//     relacion_proyecto: ['BR4542VER'],
//   },
//   {
//     id_empresa: '47.457.033/0001-29',
//     id_empresa_carbono: 'BR0034EM',
//     nombre_empresa: 'Infrapar Sustainability Ltda. ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belo Horizonte',
//     departamento: 'MG',
//     relacion_proyecto: ['BR4391VER', 'BR4497VER'],
//   },
//   {
//     id_empresa: '04.310.918/0001-98',
//     id_empresa_carbono: 'BR0035EM',
//     nombre_empresa: 'BR ARBO Gestão Florestal ',
//     rol: 'desenvolvedor, proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Porto Alegre',
//     departamento: 'RS',
//     relacion_proyecto: ['BR4485VER'],
//   },
//   {
//     id_empresa: '11.090.267/0001-33',
//     id_empresa_carbono: 'BR0036EM',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Ribeirão Preto',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3281VER', 'BR4461VER'],
//   },
//   {
//     id_empresa: '42.475.587/0001-35',
//     id_empresa_carbono: 'BR0037EM',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4461VER'],
//   },
//   {
//     id_empresa: '41.131.748/0001-00',
//     id_empresa_carbono: 'BR0038EM',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4461VER'],
//   },
//   {
//     id_empresa: '17.610.393/0001-58',
//     id_empresa_carbono: 'BR0039EM',
//     nombre_empresa: 'Terra Vista Gestora de Recursos Ltd',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3816VER', 'BR4165VER', 'BR4221VER', 'BR4394VER'],
//   },
//   {
//     id_empresa: '48.258.048/0001-20',
//     id_empresa_carbono: 'BR0040EM',
//     nombre_empresa: 'Seringal São Miguel SPE Ltda.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4394VER'],
//   },
//   {
//     id_empresa: '34.808.431/0001-09',
//     id_empresa_carbono: 'BR0041EM',
//     nombre_empresa: 'GUAXINIM Environmental Solutions Ltda. ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Guarujá',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4394VER'],
//   },
//   {
//     id_empresa: '33.837.198/0001-11',
//     id_empresa_carbono: 'BR0042EM',
//     nombre_empresa:
//       'Amazonia Agroflorestal Comercializacao de Produtos Agroflorestais Ltda',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Manaus',
//     departamento: 'AM',
//     relacion_proyecto: ['BR4265VER'],
//   },
//   {
//     id_empresa: '07.339.438/0001-48',
//     id_empresa_carbono: 'BR0043EM',
//     nombre_empresa:
//       'Instituto de Conservação E Desenvolvimento Sustentável da Amazonia - Idesam',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Manaus',
//     departamento: 'AM',
//     relacion_proyecto: ['BR1118VER', 'BR4265VER'],
//   },
//   {
//     id_empresa: '04.815.734/0001-80',
//     id_empresa_carbono: 'BR0044EM',
//     nombre_empresa: 'Jari Celulose S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'ALMEIRIM',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1115VER', 'BR1811VER'],
//   },
//   {
//     id_empresa: '25.227.501/0001-36',
//     id_empresa_carbono: 'BR0045EM',
//     nombre_empresa: 'BRGEO SERVICOS DE CONSULTORIA LTDA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1811VER'],
//   },
//   {
//     id_empresa: '03.491.393/0001-71',
//     id_empresa_carbono: 'BR0046EM',
//     nombre_empresa: 'CASA DA FLORESTA AMBIENTAL LTDA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR1811VER'],
//   },
//   {
//     id_empresa: '20.454.046/0001-98',
//     id_empresa_carbono: 'BR0047EM',
//     nombre_empresa: 'Harmonia Socioambiental',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Santarém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1811VER', 'BR3141VER'],
//   },
//   {
//     id_empresa: '09.502.811/0001-65',
//     id_empresa_carbono: 'BR0048EM',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1811VER'],
//   },
//   {
//     id_empresa: '26.396.649/0001-67',
//     id_empresa_carbono: 'BR0050EM',
//     nombre_empresa: 'Brazil Agfor LLC ',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Guarulhos',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2252VER'],
//   },
//   {
//     id_empresa: '00.000.000/0001-91',
//     id_empresa_carbono: 'BR0051EM',
//     nombre_empresa: 'Banco do Brasil S/A',
//     rol: 'parceiro',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade de Economia Mista',
//     id_tipo_empresa: 'empresa_mista',
//     pais: 'Brasil',
//     ciudad: 'Brasília',
//     departamento: 'DF',
//     relacion_proyecto: ['BR4165VER', 'BR4221VER'],
//   },
//   {
//     id_empresa: '43.688.286/0001-52',
//     id_empresa_carbono: 'BR0052EM',
//     nombre_empresa: 'Future Carbon Holding S.A.',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR2878VER',
//       'BR3049VER',
//       'BR3306VER',
//       'BR3451VER',
//       'BR3666VER',
//       'BR4068VER',
//       'BR4069VER',
//       'BR4082VER',
//       'BR4084VER',
//       'BR4089VER',
//       'BR4094VER',
//       'BR4095VER',
//       'BR4141VER',
//       'BR4142VER',
//       'BR4143VER',
//       'BR4263VER',
//     ],
//   },
//   {
//     id_empresa: '15.009.178/0001-70',
//     id_empresa_carbono: 'BR0053EM',
//     nombre_empresa: 'Usinas Itamarati S/A ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Nova Olímpia',
//     departamento: 'MT',
//     relacion_proyecto: ['BR4141VER'],
//   },
//   {
//     id_empresa: '03.587.881/0001-87',
//     id_empresa_carbono: 'BR0054EM',
//     nombre_empresa: 'VALE VERDE PROPRIEDADES AGRÍCOLAS S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio de Janeiro',
//     departamento: 'RJ',
//     relacion_proyecto: ['BR4142VER'],
//   },
//   {
//     id_empresa: '03.676.931/0001-00',
//     id_empresa_carbono: 'BR0055EM',
//     nombre_empresa: 'VALE SERENO PROPRIEDADES AGRÍCOLAS S.A. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio de Janeiro',
//     departamento: 'RJ',
//     relacion_proyecto: ['BR4142VER'],
//   },
//   {
//     id_empresa: '17.198.500/0001-82',
//     id_empresa_carbono: 'BR0056EM',
//     nombre_empresa:
//       'SB FUNDO DE INVESTIMENTO NAS CADEIAS PRODUTIVAS AGROINDUSTRIAIS – FIAGRO',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Clube/Fundo de Investimento',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Pinheiros',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4142VER'],
//   },
//   {
//     id_empresa: '09.047.829/0001-14',
//     id_empresa_carbono: 'BR0057EM',
//     nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vira Rica',
//     departamento: 'MT',
//     relacion_proyecto: ['BR4143VER'],
//   },
//   {
//     id_empresa: '04.960.233/0001-97',
//     id_empresa_carbono: 'BR0058EM',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vira Rica',
//     departamento: 'MT',
//     relacion_proyecto: ['BR4143VER'],
//   },
//   {
//     id_empresa: '20.481.986/0001-76',
//     id_empresa_carbono: 'BR0059EM',
//     nombre_empresa: 'ECCON Soluções Ambientais',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4117VER', 'BR4905VER'],
//   },
//   {
//     id_empresa: '45.034.188/0001-27',
//     id_empresa_carbono: 'BR0060EM',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Dracena',
//     departamento: 'SP',
//     relacion_proyecto: ['BR4117VER'],
//   },
//   {
//     id_empresa: '01.991.834/0001-79',
//     id_empresa_carbono: 'BR0061EM',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Miranda',
//     departamento: 'MS',
//     relacion_proyecto: ['BR4117VER'],
//   },
//   {
//     id_empresa: '07.615.618/0001-05',
//     id_empresa_carbono: 'BR0062EM',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vilhena',
//     departamento: 'RO',
//     relacion_proyecto: ['BR4069VER'],
//   },
//   {
//     id_empresa: '09.256.139/0001-75',
//     id_empresa_carbono: 'BR0063EM',
//     nombre_empresa: 'Floraplac MDF LTDA ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4042VER'],
//   },
//   {
//     id_empresa: '34.597.658/0001-44',
//     id_empresa_carbono: 'BR0064EM',
//     nombre_empresa: 'FLORAPLAC INDUSTRIAL LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4042VER'],
//   },
//   {
//     id_empresa: '83.277.400/0001-76',
//     id_empresa_carbono: 'BR0065EM',
//     nombre_empresa: 'EXPAMA EXPORTADORA PARAGOMINAS DE MADEIRAS LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4042VER'],
//   },
//   {
//     id_empresa: '04.345.294/0001-44',
//     id_empresa_carbono: 'BR0066EM',
//     nombre_empresa: 'RIO CONCREM INDUSTRIAL LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Dom Eliseu',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4042VER'],
//   },
//   {
//     id_empresa: '04.102.265/0001-51',
//     id_empresa_carbono: 'BR0067EM',
//     nombre_empresa: 'AGROPALMA S/A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Tailândia',
//     departamento: 'PA',
//     relacion_proyecto: ['BR4034VER'],
//   },
//   {
//     id_empresa: '22.524.415/0001-05',
//     id_empresa_carbono: 'BR0068EM',
//     nombre_empresa: 'Systemica (MYS E JLFL TREINAMENTO GERENCIAL LTDA)',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3738VER', 'BR4016VER'],
//   },
//   {
//     id_empresa: '29.225.906/0001-96',
//     id_empresa_carbono: 'BR0069EM',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     rol: 'assessoria jurídica',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Simples Pura',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3738VER', 'BR4016VER'],
//   },
//   {
//     id_empresa: '16.434.241/0001-89',
//     id_empresa_carbono: 'BR0070EM',
//     nombre_empresa: 'Avix Engenharia e Estudos Técnicos Ltd.',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2508VER', 'BR2539VER', 'BR3816VER', 'BR875VER'],
//   },
//   {
//     id_empresa: '46.881.535/0001-10',
//     id_empresa_carbono: 'BR0071EM',
//     nombre_empresa: 'BYBLOS AGRONEGÓCIO HOLDING LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Marabá',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3738VER'],
//   },
//   {
//     id_empresa: '43.608.949/0001-81',
//     id_empresa_carbono: 'BR0072EM',
//     nombre_empresa: 'SANTA MARIA PECUARIA E AGRONEGOCIO LTDA. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Marabá',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3738VER'],
//   },
//   {
//     id_empresa: '46.443.235/0001-59',
//     id_empresa_carbono: 'BR0073EM',
//     nombre_empresa: 'IACO AMBIENTAL LTDA.',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Londrina',
//     departamento: 'PR',
//     relacion_proyecto: ['BR3631VER'],
//   },
//   {
//     id_empresa: '08.294.685/0001-38',
//     id_empresa_carbono: 'BR0074EM',
//     nombre_empresa: 'WayCarbon Soluções Ambientais e Projetos de Carbono LTDA ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belo Horizonte',
//     departamento: 'MG',
//     relacion_proyecto: ['BR3631VER'],
//   },
//   {
//     id_empresa: '38.384.085/0001-21',
//     id_empresa_carbono: 'BR0075EM',
//     nombre_empresa: 'Catraia Soluções Ambientais LTDA ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR3631VER'],
//   },
//   {
//     id_empresa: '40.968.597/0001-87',
//     id_empresa_carbono: 'BR0076EM',
//     nombre_empresa: 'Roma Participações S/S LTDA',
//     rol: 'parceiro do desenvolvedor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Simples Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Londrina',
//     departamento: 'PR',
//     relacion_proyecto: ['BR3631VER'],
//   },
//   {
//     id_empresa: '45.424.948/0001-02',
//     id_empresa_carbono: 'BR0077EM',
//     nombre_empresa: 'Guanabara Ambiental LTDA.',
//     rol: 'parceiro do desenvolvedor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Londrina',
//     departamento: 'PR',
//     relacion_proyecto: ['BR3631VER'],
//   },
//   {
//     id_empresa: '06.161.839/0001-98',
//     id_empresa_carbono: 'BR0078EM',
//     nombre_empresa: 'Matogrosso Participações Ltda',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3601VER'],
//   },
//   {
//     id_empresa: '18.311.727/0001-55',
//     id_empresa_carbono: 'BR0079EM',
//     nombre_empresa: 'Dunorte Agroflorestal Ltda',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Ipixuna do Pará',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3601VER'],
//   },
//   {
//     id_empresa: '21.774.398/0001-93',
//     id_empresa_carbono: 'BR0080EM',
//     nombre_empresa: 'Instituto Manguezal',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3601VER'],
//   },
//   {
//     id_empresa: '41.764.351/0001-56',
//     id_empresa_carbono: 'BR0081EM',
//     nombre_empresa: 'GRUPO SWAT INTERNACIONAL',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Curitiba',
//     departamento: 'PR',
//     relacion_proyecto: ['BR3601VER'],
//   },
//   {
//     id_empresa: '43.214.055/0001-07',
//     id_empresa_carbono: 'BR0082EM',
//     nombre_empresa: 'ARMAZENS MARTINS',
//     rol: 'desenvolvedor/proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Uberlândia',
//     departamento: 'MG',
//     relacion_proyecto: ['BR3590VER'],
//   },
//   {
//     id_empresa: '28.542.812/0001-88',
//     id_empresa_carbono: 'BR0083EM',
//     nombre_empresa: 'Casa da Floresta Ambiental Ltda. ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3590VER'],
//   },
//   {
//     id_empresa: '34.891.085/0001-67',
//     id_empresa_carbono: 'BR0084EM',
//     nombre_empresa: 'IMAZON - Instituto do Homem e Meio Ambiente da Amazônia ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3590VER'],
//   },
//   {
//     id_empresa: '44.120.168/0001-06',
//     id_empresa_carbono: 'BR0085EM',
//     nombre_empresa:
//       'Carbon Asset (Carbon Asset Management Projetos Ambientais LTDA) ',
//     rol: 'comerciante de créditos de carbono',
//     id_rol: 'comerciante',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2878VER', 'BR3049VER', 'BR3451VER'],
//   },
//   {
//     id_empresa: '02.257.256/0001-04',
//     id_empresa_carbono: 'BR0087EM',
//     nombre_empresa: 'Amazônia Agroindústria EIRELI',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Cruzeiro do Sul',
//     departamento: 'AC',
//     relacion_proyecto: ['BR3430VER'],
//   },
//   {
//     id_empresa: '22.417.044/0001-54',
//     id_empresa_carbono: 'BR0088EM',
//     nombre_empresa: 'AMBIENTAL AMAZÔNIA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR3430VER'],
//   },
//   {
//     id_empresa: '36.634.796/0001-81',
//     id_empresa_carbono: 'BR0089EM',
//     nombre_empresa: 'LAVRADO SOLUÇÕES AMBIENTAIS ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Boa Vista',
//     departamento: 'RR',
//     relacion_proyecto: ['BR3430VER'],
//   },
//   {
//     id_empresa: '13.331.592/0001-76',
//     id_empresa_carbono: 'BR0090EM',
//     nombre_empresa: 'GESTAO E RESULTADOS CONSULTORES ASSOCIADOS ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR3430VER'],
//   },
//   {
//     id_empresa: '07.746.411/0001-70',
//     id_empresa_carbono: 'BR0091EM',
//     nombre_empresa: 'CARBONO FÁCIL — PROJETOS E SISTEMAS DE CERTIFICAÇÃO',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3430VER'],
//   },
//   {
//     id_empresa: '43.192.338/0001-03',
//     id_empresa_carbono: 'BR0092EM',
//     nombre_empresa: 'REDDA Projetos Ambientais Sociedade Ltda.  ',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '07.472.782/0001-00',
//     id_empresa_carbono: 'BR0093EM',
//     nombre_empresa:
//       'ATAIG-PA – Associação dos trabalhadores agroextrativistas da Ilha Grande do Pacajaí Assentamento Pai do Governo Federal ',
//     rol: 'associação de trabalhadores',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Portel',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '08.885.776/0001-48',
//     id_empresa_carbono: 'BR0094EM',
//     nombre_empresa:
//       'ATAGROCAMP - Associação dos trabalhadores agroextrativistas do Alto Camarapí',
//     rol: 'associação de trabalhadores',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Portel',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '26.318.791/0001-96',
//     id_empresa_carbono: 'BR0095EM',
//     nombre_empresa:
//       'ASMOGAC - Associação dos moradores agroextrativistas do assentamento PEAEX Acangatá ',
//     rol: 'associação de trabalhadores',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Portel',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '20.150.825/0001-08',
//     id_empresa_carbono: 'BR0096EM',
//     nombre_empresa:
//       'ARQUICOSTT - Associação Remanescentes de Quilombos da comunidade São Tomé Tauçú ',
//     rol: 'associação de trabalhadores',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Portel',
//     departamento: 'PA',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '09.448.003/0001-67',
//     id_empresa_carbono: 'BR0097EM',
//     nombre_empresa: 'ZX Participações S/A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Ponte Alta do Bom Jesus',
//     departamento: 'TO',
//     relacion_proyecto: ['BR3306VER'],
//   },
//   {
//     id_empresa: '24.535.210/0001-42',
//     id_empresa_carbono: 'BR0098EM',
//     nombre_empresa: 'Nigrum Capital Assessoria e Gestão de Negócios LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2980VER', 'BR3304VER'],
//   },
//   {
//     id_empresa: '02.405.151/0002-36',
//     id_empresa_carbono: 'BR0099EM',
//     nombre_empresa: 'Ecológica Assessoria LTDA.',
//     rol: 'consultor/desenvolvedor',
//     id_rol: 'consultor/desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Palmas',
//     departamento: 'TO',
//     relacion_proyecto: [
//       'BR1686VER',
//       'BR2373VER',
//       'BR2482VER',
//       'BR2558VER',
//       'BR2709VER',
//       'BR2870VER',
//       'BR2871VER',
//       'BR2980VER',
//       'BR3152VER',
//       'BR3304VER',
//     ],
//   },
//   {
//     id_empresa: '32.224.430/0001-83',
//     id_empresa_carbono: 'BR0100EM',
//     nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Coronel Vivida',
//     departamento: 'PR',
//     relacion_proyecto: ['BR3304VER'],
//   },
//   {
//     id_empresa: '00.309.708/0001-29',
//     id_empresa_carbono: 'BR0101EM',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Cuiabá',
//     departamento: 'MT',
//     relacion_proyecto: ['BR3152VER'],
//   },
//   {
//     id_empresa: '44.212.107/0001-79',
//     id_empresa_carbono: 'BR0102EM',
//     nombre_empresa: 'Carbon Credits Consulting SRL',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Manaus',
//     departamento: 'AM',
//     relacion_proyecto: ['BR3141VER'],
//   },
//   {
//     id_empresa: '41.253.379/0001-29',
//     id_empresa_carbono: 'BR0103EM',
//     nombre_empresa: 'OnePlanet Ltda',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR3050VER'],
//   },
//   {
//     id_empresa: '20.277.095/0001-00',
//     id_empresa_carbono: 'BR0104EM',
//     nombre_empresa: 'NEO GREEN CONSULTORIA AMBIENTAL LTDA',
//     rol: 'consultor/desenvolvedor',
//     id_rol: 'consultor/desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Joinville',
//     departamento: 'SC',
//     relacion_proyecto: ['BR2950VER', 'BR3050VER'],
//   },
//   {
//     id_empresa: '27.899.023/0001-36',
//     id_empresa_carbono: 'BR0105EM',
//     nombre_empresa: 'Sparta Participações Societárias S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Cuiabá',
//     departamento: 'MT',
//     relacion_proyecto: ['BR3049VER'],
//   },
//   {
//     id_empresa: '10.199.645/0005-82',
//     id_empresa_carbono: 'BR0106EM',
//     nombre_empresa: 'Universal Timber Resource do Brasil (UTRB)',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Bernardo do Campo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2980VER'],
//   },
//   {
//     id_empresa: '20.949.082/0001-22',
//     id_empresa_carbono: 'BR0107EM',
//     nombre_empresa: 'Uezu Planejamento Ambiental S/S LTDA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Simples Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Nazaré Paulista',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR2373VER',
//       'BR2482VER',
//       'BR2558VER',
//       'BR2709VER',
//       'BR2870VER',
//       'BR2980VER',
//     ],
//   },
//   {
//     id_empresa: '75.045.120/0001-04',
//     id_empresa_carbono: 'BR0108EM',
//     nombre_empresa: 'Limeira Indústria e Comércio S/A',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Curitiba',
//     departamento: 'PR',
//     relacion_proyecto: ['BR2950VER'],
//   },
//   {
//     id_empresa: '17.855.575/0001-99',
//     id_empresa_carbono: 'BR0109EM',
//     nombre_empresa: 'Grupo Rovema  ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Porto Velho',
//     departamento: 'RO',
//     relacion_proyecto: ['BR2878VER'],
//   },
//   {
//     id_empresa: '04.975.356/0001-00',
//     id_empresa_carbono: 'BR0110EM',
//     nombre_empresa: 'Gairova Agropecus Ltda',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Juara',
//     departamento: 'MT',
//     relacion_proyecto: ['BR2870VER'],
//   },
//   {
//     id_empresa: '09.510.073/0001-06',
//     id_empresa_carbono: 'BR0111EM',
//     nombre_empresa: 'Sustainable Carbon Projetos Ambientais Ltda',
//     rol: 'comerciante de créditos de carbono',
//     id_rol: 'comerciante',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: [
//       'BR1094VER',
//       'BR2373VER',
//       'BR2482VER',
//       'BR2558VER',
//       'BR2709VER',
//       'BR2870VER',
//       'BR2871VER',
//     ],
//   },
//   {
//     id_empresa: '01.380.468/0001-11',
//     id_empresa_carbono: 'BR0112EM',
//     nombre_empresa: 'Arca S/A Agropecuaria',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Tangara da Serra',
//     departamento: 'MT',
//     relacion_proyecto: ['BR2871VER'],
//   },
//   {
//     id_empresa: '39.879.582/0001-63',
//     id_empresa_carbono: 'BR0113EM',
//     nombre_empresa: 'Amigos dos Ribeirinhos',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Portel',
//     departamento: 'PA',
//     relacion_proyecto: ['BR2620VER'],
//   },
//   {
//     id_empresa: '11.388.008/0001-93',
//     id_empresa_carbono: 'BR0114EM',
//     nombre_empresa: 'Radicle',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2586VER', 'BR2587VER'],
//   },
//   {
//     id_empresa: '16.575.853/0001-91',
//     id_empresa_carbono: 'BR0115EM',
//     nombre_empresa: 'Instituto Homem Pantaneiro',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Corumbá',
//     departamento: 'MS',
//     relacion_proyecto: ['BR2566VER'],
//   },
//   {
//     id_empresa: '32.983.785/0001-56',
//     id_empresa_carbono: 'BR0116EM',
//     nombre_empresa: 'ECOTRÓPICA - FUNDAÇÃO DE APOIO A VIDA NOS TRÓPICOS',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Cuiabá',
//     departamento: 'MT',
//     relacion_proyecto: ['BR2566VER'],
//   },
//   {
//     id_empresa: '20.722.575/0001-25',
//     id_empresa_carbono: 'BR0117EM',
//     nombre_empresa: 'ABC Agropecuária Brasil Norte S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR2558VER'],
//   },
//   {
//     id_empresa: '22.839.815/0001-00',
//     id_empresa_carbono: 'BR0118EM',
//     nombre_empresa: 'BATISTA E CIA LTDA ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Vilhena',
//     departamento: 'RO',
//     relacion_proyecto: ['BR2551VER'],
//   },
//   {
//     id_empresa: '19.942.166/0003-17',
//     id_empresa_carbono: 'BR0119EM',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Itu',
//     departamento: 'SP',
//     relacion_proyecto: ['BR2482VER'],
//   },
//   {
//     id_empresa: '02.609.742/0001-44',
//     id_empresa_carbono: 'BR0120EM',
//     nombre_empresa: 'Grupo Dacko ',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Erval Grande',
//     departamento: 'RS',
//     relacion_proyecto: ['BR1953VER'],
//   },
//   {
//     id_empresa: '19.848.073/0001-66',
//     id_empresa_carbono: 'BR0121EM',
//     nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Manoel Urbano',
//     departamento: 'AC',
//     relacion_proyecto: ['BR1686VER'],
//   },
//   {
//     id_empresa: '12.045.953/0001-55',
//     id_empresa_carbono: 'BR0122EM',
//     nombre_empresa: 'T.A.O Consultoria Ambiental Ltda',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Novo Hamburgo',
//     departamento: 'RS',
//     relacion_proyecto: ['BR1686VER'],
//   },
//   {
//     id_empresa: '10.411.029/0001-10',
//     id_empresa_carbono: 'BR0123EM',
//     nombre_empresa: 'Agência Verde - Tamoios Tecnologia e Consultoria Ltda',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR1094VER', 'BR1686VER'],
//   },
//   {
//     id_empresa: '49.460.034/0001-58',
//     id_empresa_carbono: 'BR0124EM',
//     nombre_empresa: 'Geowiki Engenharia Ltda',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Itajubá',
//     departamento: 'MG',
//     relacion_proyecto: ['BR1654VER'],
//   },
//   {
//     id_empresa: '14.436.003/0001-87',
//     id_empresa_carbono: 'BR0125EM',
//     nombre_empresa: 'CO2X Conservação de Florestas Ltda',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR1147VER'],
//   },
//   {
//     id_empresa: '12.132.277/0001-57',
//     id_empresa_carbono: 'BR0126EM',
//     nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Curitiba',
//     departamento: 'PR',
//     relacion_proyecto: ['BR1147VER'],
//   },
//   {
//     id_empresa: '22.858.310/0001-84',
//     id_empresa_carbono: 'BR0128EM',
//     nombre_empresa: 'Metareilá do Povo Indígena Suruí',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Cacoal',
//     departamento: 'RO',
//     relacion_proyecto: ['BR1118VER'],
//   },
//   {
//     id_empresa: '09.351.359/0001-88',
//     id_empresa_carbono: 'BR0129EM',
//     nombre_empresa: 'Fundação Amazonas Sustentável - FAS',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Fundação Privada',
//     id_tipo_empresa: 'fundacion_privada',
//     pais: 'Brasil',
//     ciudad: 'Manaus',
//     departamento: 'AM',
//     relacion_proyecto: ['BR1596VER'],
//   },
//   {
//     id_empresa: '05.562.326/0001-26',
//     id_empresa_carbono: 'BR0130EM',
//     nombre_empresa: 'Secretaria de Estado do Meio Ambiente - Sema',
//     rol: 'supervisor',
//     id_rol: 'consultor',
//     tipo_sociedad:
//       'Órgão Público do Poder Executivo Estadual ou do Distrito Federal',
//     id_tipo_empresa: 'organismo_publico',
//     pais: 'Brasil',
//     ciudad: 'Manaus',
//     departamento: 'AM',
//     relacion_proyecto: ['BR1596VER'],
//   },
//   {
//     id_empresa: '11.453.128/0001-27',
//     id_empresa_carbono: 'BR0131EM',
//     nombre_empresa: 'C3-Floresta, Meio Ambiente & Energia ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR1596VER'],
//   },
//   {
//     id_empresa: '84.639.632/0001-90',
//     id_empresa_carbono: 'BR0132EM',
//     nombre_empresa: 'Manoa Sustentável, Exploração e Serviços Florestais Ltda ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'CUJUBIM',
//     departamento: 'RO',
//     relacion_proyecto: ['BR1571VER'],
//   },
//   {
//     id_empresa: '04.418.943/0001-90',
//     id_empresa_carbono: 'BR0133EM',
//     nombre_empresa: 'UNIR Fundação Universidade Federal de Rondônia',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Fundação Pública de Direito Público Federal',
//     id_tipo_empresa: 'fundacion_publica',
//     pais: 'Brasil',
//     ciudad: 'Porto Velho',
//     departamento: 'RO',
//     relacion_proyecto: ['BR1571VER'],
//   },
//   {
//     id_empresa: '06.066.768/0001-44',
//     id_empresa_carbono: 'BR0134EM',
//     nombre_empresa: 'Florestal Santa Maria ',
//     rol: 'desenvolvedor/proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR1571VER'],
//   },
//   {
//     id_empresa: '05.321.358/0001-30',
//     id_empresa_carbono: 'BR0135EM',
//     nombre_empresa: 'PLANT Inteligência Ambiental Ltda',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Piracicaba',
//     departamento: 'SP',
//     relacion_proyecto: ['BR875VER'],
//   },
//   {
//     id_empresa: '07.712.535/0001-34',
//     id_empresa_carbono: 'BR0136EM',
//     nombre_empresa: 'BUNGE ALIMENTOS PARTICIPACOES LTDA.',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR875VER'],
//   },
//   {
//     id_empresa: '60.613.478/0001-19',
//     id_empresa_carbono: 'BR0137EM',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Simples Pura',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR875VER'],
//   },
//   {
//     id_empresa: '05.086.970/0001-75',
//     id_empresa_carbono: 'BR0138EM',
//     nombre_empresa: 'Ecomapuá Conservação Ltda. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belém',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1094VER'],
//   },
//   {
//     id_empresa: '04.611.106/0001-82',
//     id_empresa_carbono: 'BR0139EM',
//     nombre_empresa:
//       'Associação dos Moradores da Reserva Extrativista Rio Preto Jacundá e Riberinhos do Rio Machado – ASMOREX',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Machadinho',
//     departamento: 'RO',
//     relacion_proyecto: ['BR1503VER'],
//   },
//   {
//     id_empresa: '03.721.311/0001-38',
//     id_empresa_carbono: 'BR0140EM',
//     nombre_empresa:
//       'CENTRO DE ESTUDOS DA CULTURA E DO MEIO AMBIENTE DA AMAZONIA-RIO TERRA',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Porto Velho',
//     departamento: 'RO',
//     relacion_proyecto: ['BR1503VER'],
//   },
//   {
//     id_empresa: '10.758.301/0001-32',
//     id_empresa_carbono: 'BR0141EM',
//     nombre_empresa: 'Moura e Rosa Empreendimentos Imobiliários LTDA',
//     rol: 'gestor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR963VER'],
//   },
//   {
//     id_empresa: '04.199.086/0001-84',
//     id_empresa_carbono: 'BR0142EM',
//     nombre_empresa: 'TECMAN ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR1382VER', 'BR963VER'],
//   },
//   {
//     id_empresa: '04.071.106/0001-37',
//     id_empresa_carbono: 'BR0143EM',
//     nombre_empresa: 'Universidade Federal do Acre',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Fundação Pública de Direito Público Federal',
//     id_tipo_empresa: 'fundacion_publica',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR1382VER', 'BR963VER'],
//   },
//   {
//     id_empresa: '00.348.003/0068-28',
//     id_empresa_carbono: 'BR0144EM',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Empresa Pública',
//     id_tipo_empresa: 'empresa_publica',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR963VER'],
//   },
//   {
//     id_empresa: '08.164.340/0001-60',
//     id_empresa_carbono: 'BR0145EM',
//     nombre_empresa: 'Instituto Chico Mendes ',
//     rol: 'contato local',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Xapuri',
//     departamento: 'AC',
//     relacion_proyecto: ['BR963VER'],
//   },
//   {
//     id_empresa: '04.378.099/0001-10',
//     id_empresa_carbono: 'BR0146EM',
//     nombre_empresa: 'SERVICO NACIONAL DE APRENDIZAGEM RURAL',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Serviço Social Autônomo',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR963VER'],
//   },
//   {
//     id_empresa: '03.501.232/0004-64',
//     id_empresa_carbono: 'BR0147EM',
//     nombre_empresa: 'CKVB Florestal Ltda',
//     rol: 'desenvolvedor/proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Paragominas ',
//     departamento: 'PA',
//     relacion_proyecto: ['BR832VER'],
//   },
//   {
//     id_empresa: '11.313.775/0001-33',
//     id_empresa_carbono: 'BR0148EM',
//     nombre_empresa: 'JR AGROPECUARIA E EMPREENDIMENTOS LTDA',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Rio Branco',
//     departamento: 'AC',
//     relacion_proyecto: ['BR1382VER'],
//   },
//   {
//     id_empresa: '04.138.913/0001-20',
//     id_empresa_carbono: 'BR0149EM',
//     nombre_empresa: 'Maísa-Moju Agroindustrial Ltda',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Moju',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1329VER'],
//   },
//   {
//     id_empresa: '04.363.966/0001-44',
//     id_empresa_carbono: 'BR0150EM',
//     nombre_empresa: 'Sipasa-Seringa Industrial do Pará S.A. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Moju',
//     departamento: 'PA',
//     relacion_proyecto: ['BR1329VER'],
//   },
//   {
//     id_empresa: '36.411.161/0001-15',
//     id_empresa_carbono: 'BR0151EM',
//     nombre_empresa: 'ASSOCIACAO INDIGENA MANTINO',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Novo Progresso',
//     departamento: 'PA',
//     relacion_proyecto: ['BR133ECO', 'BR134ECO', 'BR135ECO', 'BR136ECO'],
//   },
//   {
//     id_empresa: '01.444.198/0001-65',
//     id_empresa_carbono: 'BR0152EM',
//     nombre_empresa: 'ORGANIZACAO DO POVO INDIGENA PARINTINTIN DO AMAZONAS',
//     rol: 'coordenador geral',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Humaitá',
//     departamento: 'AM',
//     relacion_proyecto: ['BR125ECO', 'BR144ECO'],
//   },
//   {
//     id_empresa: '08.916.233/0001-40',
//     id_empresa_carbono: 'BR0153EM',
//     nombre_empresa: 'ASSOCIACAO DO POVO INDIGENA CINTA LARGA - ETEREPUYA',
//     rol: 'coordenador geral',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Juína',
//     departamento: 'MT',
//     relacion_proyecto: ['BR139ECO', 'BR140ECO', 'BR141ECO', 'BR142ECO'],
//   },
//   {
//     id_empresa: '09.330.691/0001-66',
//     id_empresa_carbono: 'BR0154EM',
//     nombre_empresa:
//       'PATJAMAAJ - COORDENACAO DAS ORGANIZACOES INDIGENAS DO POVO CINTA LARGA',
//     rol: 'coordenador geral',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Novo Cacoal',
//     departamento: 'RO',
//     relacion_proyecto: ['BR143ECO'],
//   },
//   {
//     id_empresa: '10.221.125/0001-03',
//     id_empresa_carbono: 'BR0155EM',
//     nombre_empresa: 'ASSOCIACAO INDIGENA PUSURU',
//     rol: 'coordenador geral',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Associação Privada',
//     id_tipo_empresa: 'asociacion',
//     pais: 'Brasil',
//     ciudad: 'Jacareacanga',
//     departamento: 'PA',
//     relacion_proyecto: [
//       'BR128ECO',
//       'BR129ECO',
//       'BR130ECO',
//       'BR131ECO',
//       'BR132ECO',
//     ],
//   },
//   {
//     id_empresa: '32.019.169/0001-80',
//     id_empresa_carbono: 'BR0156EM',
//     nombre_empresa:
//       'COOPERATIVA DE PRODUCAO E DESENVOLVIMENTO DO POVO INDIGENA CINTA LARGA - RO/MT',
//     rol: 'coordenador geral',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Cooperativa',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Pimenta Bueno',
//     departamento: 'RO',
//     relacion_proyecto: ['BR137ECO', 'BR138ECO'],
//   },
//   {
//     id_empresa: '35.716.805/0001-10',
//     id_empresa_carbono: 'BR0157EM',
//     nombre_empresa: 'Canopée Gestão Ambiental e Florestal S/A,',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR172ECO', 'BR189ECO'],
//   },
//   {
//     id_empresa: '23.628.450/0001-29',
//     id_empresa_carbono: 'BR0158EM',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR172ECO', 'BR189ECO'],
//   },
//   {
//     id_empresa: '06.089.113/0001-91',
//     id_empresa_carbono: 'BR0159EM',
//     nombre_empresa: 'Ixtis Informática e Participações Ltda. ',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Cotia',
//     departamento: 'SP',
//     relacion_proyecto: ['BR172ECO', 'BR189ECO'],
//   },
//   {
//     id_empresa: '23.799.842/0001-50',
//     id_empresa_carbono: 'BR0160EM',
//     nombre_empresa: 'DREAM LTDA. ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Sena Madureira',
//     departamento: 'AC',
//     relacion_proyecto: ['BR172ECO'],
//   },
//   {
//     id_empresa: '72.368.012/0002-65',
//     id_empresa_carbono: 'BR0161EM',
//     nombre_empresa: 'Bureau Veritas S. A.',
//     rol: 'verificador',
//     id_rol: 'verificador',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR172ECO'],
//   },
//   {
//     id_empresa: '09.077.252/0001-93',
//     id_empresa_carbono: 'BR0162EM',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Anônima Fechada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'São Paulo',
//     departamento: 'SP',
//     relacion_proyecto: ['BR5044VER'],
//   },
//   {
//     id_empresa: '47.858.323/0001-84',
//     id_empresa_carbono: 'BR0163EM',
//     nombre_empresa: 'BOCALON AGROPECUARIA LTDA',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Araguari',
//     departamento: 'MG',
//     relacion_proyecto: ['BR5044VER'],
//   },
//   {
//     id_empresa: '27.784.327/0001-58',
//     id_empresa_carbono: 'BR0164EM',
//     nombre_empresa: 'ORGANICA CONSULTORIA LTDA',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Fortaleza',
//     departamento: 'CE',
//     relacion_proyecto: ['BR4956VER', 'BR5025VER'],
//   },
//   {
//     id_empresa: '44.749.580/0001-90',
//     id_empresa_carbono: 'BR0165EM',
//     nombre_empresa: 'Urupolpas ',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Urucará',
//     departamento: 'AM',
//     relacion_proyecto: ['BR4956VER'],
//   },
//   {
//     id_empresa: '04.394.176/0001-26',
//     id_empresa_carbono: 'BR0166EM',
//     nombre_empresa: 'AGROFRUT',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Cooperativa',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Urucará',
//     departamento: 'AM',
//     relacion_proyecto: ['BR4956VER'],
//   },
//   {
//     id_empresa: '08.389.641/0001-91',
//     id_empresa_carbono: 'BR0167EM',
//     nombre_empresa: 'Nat’Organico',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresario Individual ',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Fortaleza',
//     departamento: 'CE',
//     relacion_proyecto: ['BR4956VER'],
//   },
//   {
//     id_empresa: '19.235.736/0001-77',
//     id_empresa_carbono: 'BR0168EM',
//     nombre_empresa: 'Global Serviços de Engenharia',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belo Horizonte',
//     departamento: 'MG',
//     relacion_proyecto: ['BR1561VER', 'BR3332VER', 'BR3380VER'],
//   },
//   {
//     id_empresa: '17.573.498/0001-84',
//     id_empresa_carbono: 'BR0168EN',
//     nombre_empresa: 'BVRio ',
//     rol: 'supervisão ambiental e desenvolvimento de PD',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Reino Unido',
//     ciudad: 'Oxford',
//     departamento: 'Oxfordshire',
//     relacion_proyecto: ['BR3332VER', 'BR3380VER'],
//   },
//   {
//     id_empresa: '07.580.775/0001-22',
//     id_empresa_carbono: 'BR0169EM',
//     nombre_empresa: 'Interconexión Eléctrica S.A. E.S.P ISA',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa Domiciliada no Exterior',
//     id_tipo_empresa: 'empresa',
//     pais: 'Colômbia',
//     ciudad: 'Medelín',
//     departamento: 'Antioquia',
//     relacion_proyecto: ['BR2566VER'],
//   },
//   {
//     id_empresa: '21.838.332/0001-10',
//     id_empresa_carbono: 'BR0170EM',
//     nombre_empresa: 'WMF Energy S/A',
//     rol: 'proponente',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Sociedade Empresária Limitada',
//     id_tipo_empresa: 'empresa',
//     pais: 'Brasil',
//     ciudad: 'Belo Horizonte',
//     departamento: 'MG',
//     relacion_proyecto: ['BR1561VER', 'BR189ECO'],
//   },
//   {
//     id_empresa: '33.568.357/0001-20',
//     id_empresa_carbono: 'BR0171EM',
//     nombre_empresa: 'Companhia ASF Brasil',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa Domiciliada no Exterior',
//     id_tipo_empresa: 'empresa',
//     pais: 'Reino Unido',
//     ciudad: 'Londres',
//     departamento: 'Grande Londres',
//     relacion_proyecto: ['BR2566VER'],
//   },
//   {
//     id_empresa: '900305399-8',
//     id_empresa_carbono: 'CO0086EM',
//     nombre_empresa: 'Panthera Colombia',
//     rol: 'proprietário',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Colômbia',
//     ciudad: 'Cali',
//     departamento: 'Valle del Cauca',
//     relacion_proyecto: ['BR4391VER', 'BR4497VER'],
//   },
//   {
//     id_empresa: '52.356.116/0001-61',
//     id_empresa_carbono: 'EX0006EM',
//     nombre_empresa: 'Amazon Partners 20',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa Domiciliada no Exterior',
//     id_tipo_empresa: 'empresa',
//     pais: 'Estados Unidos',
//     ciudad: 'Cheyenne',
//     departamento: 'Wyoming',
//     relacion_proyecto: ['BR981VER'],
//   },
//   {
//     id_empresa: 'CMP52223',
//     id_empresa_carbono: 'EX0010EM',
//     nombre_empresa: 'Avoided Deforestation Project (Manaus) Limited (ADPML)',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa',
//     id_tipo_empresa: 'empresa',
//     pais: 'Guernsey',
//     ciudad: 'Saint Peter Port',
//     departamento: 'Guernsey',
//     relacion_proyecto: ['BR977VER', 'BR981VER'],
//   },
//   {
//     id_empresa: 'varios',
//     id_empresa_carbono: 'EX0011EM',
//     nombre_empresa: 'Ecosystem Services LLC',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Charlottesville',
//     departamento: 'Virginia',
//     relacion_proyecto: ['BR977VER'],
//   },
//   {
//     id_empresa: '13.033.229/0001-74',
//     id_empresa_carbono: 'EX0012EM',
//     nombre_empresa: 'RMDLT Property Group Ltd ',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Canadá',
//     ciudad: 'Kelowna',
//     departamento: '',
//     relacion_proyecto: ['BR3332VER', 'BR3380VER'],
//   },
//   {
//     id_empresa: '13816396',
//     id_empresa_carbono: 'EX0015EM',
//     nombre_empresa: 'SIMFlor Ltd ',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Reino Unido',
//     ciudad: 'Oxford',
//     departamento: 'Oxfordshire',
//     relacion_proyecto: ['BR3332VER', 'BR3380VER'],
//   },
//   {
//     id_empresa: '996958',
//     id_empresa_carbono: 'EX0016EM',
//     nombre_empresa: 'Ecosecurities',
//     rol: 'supervisão ambiental e desenvolvimento de PD',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Suíça',
//     ciudad: 'Genebra',
//     departamento: 'Não encontrado',
//     relacion_proyecto: ['BR3380VER'],
//   },
//   {
//     id_empresa: '11263566',
//     id_empresa_carbono: 'EX0017EM',
//     nombre_empresa: 'Sustainable Investment Management Ltd (SIM)',
//     rol: 'supervisão e análise ambiental',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Reino Unido',
//     ciudad: 'Oxford',
//     departamento: 'Oxfordshire',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '43.500.617/0001-89',
//     id_empresa_carbono: 'EX0018EM',
//     nombre_empresa: 'Para REDD Projects Ltd',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa Domiciliada no Exterior',
//     id_tipo_empresa: 'empresa',
//     pais: 'Emirados Árabes Unidos',
//     ciudad: 'Dubai',
//     departamento: 'Não encontrado',
//     relacion_proyecto: ['BR3334VER'],
//   },
//   {
//     id_empresa: '1000028234',
//     id_empresa_carbono: 'EX0019EM',
//     nombre_empresa: 'Clearblue Asset Management Ltd.',
//     rol: 'consultor',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Canadá',
//     ciudad: 'Vaughan',
//     departamento: 'Ontario',
//     relacion_proyecto: ['BR2586VER'],
//   },
//   {
//     id_empresa: '2020-000908045',
//     id_empresa_carbono: 'EX0020EM',
//     nombre_empresa: '413 Environmental, LCC',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Cheyenne',
//     departamento: 'Wyoming',
//     relacion_proyecto: ['BR2587VER'],
//   },
//   {
//     id_empresa: '2019-000866893',
//     id_empresa_carbono: 'EX0021EM',
//     nombre_empresa: 'Zero Carbon Holdings, LLC',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Nova York',
//     departamento: 'Nova York',
//     relacion_proyecto: ['BR2566VER'],
//   },
//   {
//     id_empresa: 'Não encontrado',
//     id_empresa_carbono: 'EX0022EM',
//     nombre_empresa: 'South Pole Carbon Asset Management  ',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Zurique',
//     ciudad: 'Suíça ',
//     departamento: 'Não encontrado',
//     relacion_proyecto: ['BR1953VER'],
//   },
//   {
//     id_empresa: 'Não encontrado',
//     id_empresa_carbono: 'EX0023EM',
//     nombre_empresa: 'Amazon Reforestation Consortium',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Não encontrado',
//     ciudad: 'Não encontrado',
//     departamento: 'Não encontrado',
//     relacion_proyecto: ['BR1112VER', 'BR1113VER', 'BR1382VER', 'BR963VER'],
//   },
//   {
//     id_empresa: 'Não encontrado',
//     id_empresa_carbono: 'EX0025EM',
//     nombre_empresa: 'CarbonCo, LLC',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Nova York',
//     departamento: 'Nova York',
//     relacion_proyecto: ['BR1113VER', 'BR1382VER', 'BR963VER'],
//   },
//   {
//     id_empresa: 'L08000049566',
//     id_empresa_carbono: 'EX0026EM',
//     nombre_empresa: 'Freitas International Group, LLC (Carbon Securities) ',
//     rol: 'facilitador',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Miami',
//     departamento: 'Flórida',
//     relacion_proyecto: ['BR1382VER', 'BR832VER', 'BR963VER'],
//   },
//   {
//     id_empresa: '2040549',
//     id_empresa_carbono: 'EX0028EM',
//     nombre_empresa: 'TerraCarbon LLC',
//     rol: 'Não informado',
//     id_rol: 'não informado',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Estados Unidos',
//     ciudad: 'Peoria',
//     departamento: 'Illinois',
//     relacion_proyecto: ['BR832VER'],
//   },
//   {
//     id_empresa: 'Não encontrado',
//     id_empresa_carbono: 'EX0029EM',
//     nombre_empresa: '33 Forest Capital',
//     rol: 'parceiro financeiro e técnico',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Países Baixos',
//     ciudad: 'Haia',
//     departamento: 'Holanda do Sul',
//     relacion_proyecto: ['BR1027VER'],
//   },
//   {
//     id_empresa: 'Não encontrado',
//     id_empresa_carbono: 'EX0030EM',
//     nombre_empresa: 'International Wood Corporation (IWC)',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Dinamarca',
//     ciudad: 'Copenhague',
//     departamento: '',
//     relacion_proyecto: [
//       'BR128ECO',
//       'BR129ECO',
//       'BR132ECO',
//       'BR133ECO',
//       'BR134ECO',
//       'BR135ECO',
//       'BR136ECO',
//       'BR138ECO',
//       'BR140ECO',
//       'BR141ECO',
//       'BR142ECO',
//     ],
//   },
//   {
//     id_empresa: '6916690',
//     id_empresa_carbono: 'EX0031EM',
//     nombre_empresa: 'Indigenous Carbon LLC',
//     rol: 'desenvolvedor',
//     id_rol: 'desenvolvedor',
//     tipo_sociedad: 'Empresa',
//     id_tipo_empresa: 'empresa',
//     pais: 'Estados Unidos',
//     ciudad: 'Wilmington',
//     departamento: 'Delaware',
//     relacion_proyecto: [
//       'BR133ECO',
//       'BR128ECO',
//       'BR129ECO',
//       'BR132ECO',
//       'BR142ECO',
//     ],
//   },
//   {
//     id_empresa: '9010001119400',
//     id_empresa_carbono: 'EX0032EM',
//     nombre_empresa: 'AXELSPACE Corporation',
//     rol: 'soluções de imagens de satélite',
//     id_rol: 'consultor',
//     tipo_sociedad: '',
//     id_tipo_empresa: '',
//     pais: 'Japão',
//     ciudad: 'Tóquio',
//     departamento: '',
//     relacion_proyecto: ['BR5044VER'],
//   },
// ]

const empresasBR: IEmpresas[] = [
  {
    id_empresa: 'KVK 52226212',
    id_empresa_carbono: 'PAI0002EM',
    nombre_empresa: '33 Forest Capital B.V.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'paises_baixos',
    relacion_proyecto: ['BR832VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '2020-000908045',
    id_empresa_carbono: 'USA0011EM',
    nombre_empresa: '413 Environmental LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR2586VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.722.575/0001-25',
    id_empresa_carbono: 'BRA0110EM',
    nombre_empresa: 'ABC Agropecuária Brasil Norte S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2558VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.411.029/0001-10',
    id_empresa_carbono: 'BRA0073EM',
    nombre_empresa: 'Agência Verde - Tamoios Tecnologia e Consultoria Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1094VER', 'BR1686VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '19.848.073/0001-66',
    id_empresa_carbono: 'BRA0104EM',
    nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1686VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.033.451/0001-86',
    id_empresa_carbono: 'BRA0022EM',
    nombre_empresa: 'Agroflorestal Novo Horizonte Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5295VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.102.265/0001-51',
    id_empresa_carbono: 'BRA0023EM',
    nombre_empresa: 'AGROPALMA S/A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4034VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '24.727.505/0001-10',
    id_empresa_carbono: 'BRA0123EM',
    nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4867VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.472.750/0001-54',
    id_empresa_carbono: 'BRA0014EM',
    nombre_empresa: 'AGROPECUARIA CHAPADA DOS GUIMARAES S A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4867VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.336.695/0001-26',
    id_empresa_carbono: 'BRA0047EM',
    nombre_empresa: 'AgroSB Agropecuária S.A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4142VER', 'BR4689VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'CH-020-3901396-9',
    id_empresa_carbono: 'NAN0003EM',
    nombre_empresa: 'Allcot AG',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'suica',
    relacion_proyecto: ['BR977VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '22.858.310/0001-84',
    id_empresa_carbono: 'BRA0196EM',
    nombre_empresa: 'Amazon Conservation Team',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1118VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '52.356.116/0001-61',
    id_empresa_carbono: 'USA0013EM',
    nombre_empresa: 'Amazon Partners 20 LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR4391VER', 'BR4497VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'NAN0002EM',
    nombre_empresa: 'Amazon Reforestation Consortium',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'no_disponible',
    relacion_proyecto: ['BR1953VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'ICC20220677',
    id_empresa_carbono: 'EMI0002EM',
    nombre_empresa: 'AMAZONAS REDD Projects Ltd',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'emirados_arabes',
    relacion_proyecto: ['BR4452VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '33.837.198/0001-11',
    id_empresa_carbono: 'BRA0138EM',
    nombre_empresa:
      'Amazonia Agroflorestal Comercializacao de Produtos Agroflorestais Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4265VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '02.257.256/0001-04',
    id_empresa_carbono: 'BRA0010EM',
    nombre_empresa: 'Amazônia Agroindústria EIRELI',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4834VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '01.852.356/0001-16',
    id_empresa_carbono: 'BRA0007EM',
    nombre_empresa: 'Ambiens Soluções Ambientais',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4034VER', 'BR4689VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '22.417.044/0001-54',
    id_empresa_carbono: 'BRA0114EM',
    nombre_empresa: 'Ambiental Amazônia / AR SERVICOS LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '39.879.582/0001-63',
    id_empresa_carbono: 'BRA0148EM',
    nombre_empresa: 'Amigos dos Ribeirinhos',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2620VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.742.116/0001-34',
    id_empresa_carbono: 'BRA0171EM',
    nombre_empresa: 'Angelim Participações S.A. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4802VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '01.380.468/0001-11',
    id_empresa_carbono: 'BRA0005EM',
    nombre_empresa: 'Arca S/A Agropecuaria',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2871VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '43.214.055/0001-07',
    id_empresa_carbono: 'BRA0160EM',
    nombre_empresa: 'ARMAZENS MARTINS',
    id_rol: 'des_prop',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3590VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.150.825/0001-08',
    id_empresa_carbono: 'BRA0106EM',
    nombre_empresa:
      'ARQUICOSTT - Associação Remanescentes de Quilombos da comunidade São Tomé Tauçú ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.203.779/0001-04',
    id_empresa_carbono: 'BRA0070EM',
    nombre_empresa: 'Arthur Chiarotto Penteado',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4671VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.430.917/0001-38',
    id_empresa_carbono: 'BRA0056EM',
    nombre_empresa: 'Arthur Junqueira Ferreira Penteado ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4671VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '26.318.791/0001-96',
    id_empresa_carbono: 'BRA0126EM',
    nombre_empresa:
      'ASMOGAC - Associação dos moradores agroextrativistas do assentamento PEAEX Acangatá ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.766.804/0001-45',
    id_empresa_carbono: 'BRA0053EM',
    nombre_empresa: 'Associação Agroextrativista Aripuanã/Guariba (Asaga)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4452VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '51.840.317/0001-77',
    id_empresa_carbono: 'BRA0187EM',
    nombre_empresa: 'Associação Aliança 5P',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4747VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '27.471.082/0001-09',
    id_empresa_carbono: 'BRA0129EM',
    nombre_empresa: 'Associação do Povo Ãwa Brasil (APAWA)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR123CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.916.233/0001-40',
    id_empresa_carbono: 'BRA0058EM',
    nombre_empresa: 'Associação do Povo Indígena Cinta Larga – Eterepuya',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR139CER', 'BR140CER', 'BR141CER', 'BR142CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.611.106/0001-82',
    id_empresa_carbono: 'BRA0034EM',
    nombre_empresa:
      'Associação dos Moradores da Reserva Extrativista Rio Preto Jacundá e Riberinhos do Rio Machado – ASMOREX',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1503VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.486.071/0001-34',
    id_empresa_carbono: 'BRA0015EM',
    nombre_empresa:
      'Associação dos Remanescentes de Quilombos de Gurupá - ARQMG ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4857VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '36.411.161/0001-15',
    id_empresa_carbono: 'BRA0144EM',
    nombre_empresa: 'Associação Indígena Mantino - AIM',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR133CER', 'BR134CER', 'BR135CER', 'BR136CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '49.626.386/0001-30',
    id_empresa_carbono: 'BRA0184EM',
    nombre_empresa: 'Associação Indígena Paranatinga Parakana (Paranatinga)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5200VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.221.125/0001-03',
    id_empresa_carbono: 'BRA0071EM',
    nombre_empresa: 'Associação Indígena Pusuru - AIP',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR128CER',
      'BR129CER',
      'BR130CER',
      'BR131CER',
      'BR132CER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '24.030.384/0001-53',
    id_empresa_carbono: 'BRA0121EM',
    nombre_empresa: 'Associação Onçafari',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4802VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.885.776/0001-48',
    id_empresa_carbono: 'BRA0057EM',
    nombre_empresa:
      'ATAGROCAMP - Associação dos trabalhadores agroextrativistas do Alto Camarapí',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.472.782/0001-00',
    id_empresa_carbono: 'BRA0049EM',
    nombre_empresa:
      'ATAIG-PA – Associação dos trabalhadores agroextrativistas da Ilha Grande do Pacajaí Assentamento Pai do Governo Federal ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '16.434.241/0001-89',
    id_empresa_carbono: 'BRA0093EM',
    nombre_empresa: 'Avix Engenharia e Estudos Técnicos Ltd.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2508VER', 'BR2539VER', 'BR3816VER', 'BR875VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'CMP52223',
    id_empresa_carbono: 'GUE0001EM',
    nombre_empresa: 'Avoided Deforestation Project (Manaus) Limited (“ADPML”)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'guernnsey',
    relacion_proyecto: ['BR981VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '9010001119400',
    id_empresa_carbono: 'JAP0001EM',
    nombre_empresa: 'Axelspace Corporation',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'japao',
    relacion_proyecto: ['BR5044VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '00.000.000/0001-91',
    id_empresa_carbono: 'BRA0001EM',
    nombre_empresa: 'Banco do Brasil S/A',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'agencia_estaod',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4165VER', 'BR4221VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.043.260/0001-19',
    id_empresa_carbono: 'BRA0059EM',
    nombre_empresa: 'Batisflor Florestal Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1686VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '22.839.815/0001-00',
    id_empresa_carbono: 'BRA0117EM',
    nombre_empresa: 'Batista e Cia Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2551VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '06.954.773/0001-93',
    id_empresa_carbono: 'BRA0046EM',
    nombre_empresa: 'Bella Aliança Agropecuária Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3002VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.705.896/0001-00',
    id_empresa_carbono: 'BRA0020EM',
    nombre_empresa: 'Biodendro Consultoria Florestal LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4034VER', 'BR4689VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.720.550/0001-50',
    id_empresa_carbono: 'BRA0068EM',
    nombre_empresa: 'Biofílica Ambipar Environment Investments',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR1115VER',
      'BR1329VER',
      'BR1503VER',
      'BR1571VER',
      'BR1811VER',
      'BR3430VER',
      'BR3590VER',
      'BR4034VER',
      'BR4142VER',
      'BR4615VER',
      'BR4687VER',
      'BR4689VER',
      'BR4747VER',
      'BR4834VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '46.190.652/0001-37',
    id_empresa_carbono: 'BRA0173EM',
    nombre_empresa: 'Biofix Consultoria Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR123CER', 'BR5087VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '47.858.323/0001-84',
    id_empresa_carbono: 'BRA0181EM',
    nombre_empresa: 'Bocalon Agropecuaria Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5044VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.310.918/0001-98',
    id_empresa_carbono: 'BRA0028EM',
    nombre_empresa: 'BR ARBO Gestão Florestal ',
    id_rol: 'des_prop',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4485VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.737.144/0001-86',
    id_empresa_carbono: 'BRA0035EM',
    nombre_empresa: 'Brascomp Compensados do Brasil S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4687VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '26.396.649/0001-67',
    id_empresa_carbono: 'BRA0127EM',
    nombre_empresa: 'Brazil Agfor LLC ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2252VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '39.693.526/0001-30',
    id_empresa_carbono: 'BRA0147EM',
    nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR2551VER',
      'BR4042VER',
      'BR4542VER',
      'BR4552VER',
      'BR4850VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '25.227.501/0001-36',
    id_empresa_carbono: 'BRA0125EM',
    nombre_empresa: 'BRGEO SERVICOS DE CONSULTORIA LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1811VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.712.535/0001-34',
    id_empresa_carbono: 'BRA0051EM',
    nombre_empresa: 'BUNGE ALIMENTOS PARTICIPACOES LTDA.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR875VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '14.563.354/0001-59',
    id_empresa_carbono: 'REI0002EM',
    nombre_empresa: 'BVRio',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3332VER', 'BR3380VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '46.881.535/0001-10',
    id_empresa_carbono: 'BRA0177EM',
    nombre_empresa: 'BYBLOS AGRONEGÓCIO HOLDING LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3738VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.453.128/0001-27',
    id_empresa_carbono: 'BRA0080EM',
    nombre_empresa: 'C3-Floresta, Meio Ambiente & Energia ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1596VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '42.161.900/0001-60',
    id_empresa_carbono: 'BRA0155EM',
    nombre_empresa:
      'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4681VER', 'BR4857VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '35.716.805/0001-10',
    id_empresa_carbono: 'BRA0143EM',
    nombre_empresa: 'Canopée Gestão Ambiental e Florestal S/A,',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR172CER', 'BR189CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },

  {
    id_empresa: '44.120.168/0001-06',
    id_empresa_carbono: 'BRA0163EM',
    nombre_empresa:
      'Carbon Asset (Carbon Asset Management Projetos Ambientais LTDA) ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2878VER', 'BR3049VER', 'BR3451VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '44.212.107/0001-79',
    id_empresa_carbono: 'BRA0165EM',
    nombre_empresa: 'Carbon Credits Consulting SRL',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3141VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '4940265',
    id_empresa_carbono: 'USA0005EM',
    nombre_empresa: 'CarbonCo, LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR1112VER', 'BR1113VER', 'BR1382VER', 'BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '12.028.178/0001-20',
    id_empresa_carbono: 'BRA0082EM',
    nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR1654VER',
      'BR2508VER',
      'BR2539VER',
      'BR3002VER',
      'BR3055VER',
      'BR3324VER',
      'BR3601VER',
      'BR4671VER',
      'BR4681VER',
      'BR4857VER',
      'BR4865VER',
      'BR4867VER',
      'BR4876VER',
      'BR4886VER',
      'BR832VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.746.411/0001-70',
    id_empresa_carbono: 'BRA0052EM',
    nombre_empresa:
      'Carbono Fácil - Projetos e Sistemas De Certificação Ambiental Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.491.393/0001-71',
    id_empresa_carbono: 'BRA0016EM',
    nombre_empresa: 'CASA DA FLORESTA AMBIENTAL LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1811VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '28.542.812/0001-88',
    id_empresa_carbono: 'BRA0133EM',
    nombre_empresa: 'Casa da Floresta Ambiental Ltda. ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3590VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '38.384.085/0001-21',
    id_empresa_carbono: 'BRA0146EM',
    nombre_empresa: 'Catraia Soluções Ambientais LTDA ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3631VER', 'BR4802VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.721.311/0001-38',
    id_empresa_carbono: 'BRA0021EM',
    nombre_empresa:
      'Centro de Estudos da Cultura e do Meio Ambiente da Amazônia – RIO TERRA',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1503VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '42.321.390/0001-41',
    id_empresa_carbono: 'BRA0156EM',
    nombre_empresa: 'Cipó Engenharia e Tecnologia de Biomassa LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5343VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.501.232/0004-64',
    id_empresa_carbono: 'BRA0017EM',
    nombre_empresa: 'CKVB Florestal Ltda',
    id_rol: 'des_prop',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR832VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '1000028234',
    id_empresa_carbono: 'CAN0001EM',
    nombre_empresa: 'Clearblue Asset Management Ltd.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'canada',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '14.436.003/0001-87',
    id_empresa_carbono: 'BRA0090EM',
    nombre_empresa: 'CO2X Conservação de Florestas Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1147VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.034.188/0001-27',
    id_empresa_carbono: 'BRA0168EM',
    nombre_empresa: 'Coimma Incorporações Imobiliárias Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4117VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '15.023.243/0001-12',
    id_empresa_carbono: 'BRA0092EM',
    nombre_empresa: 'Colorado Empreendimentos Sustentáveis Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5391VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '33.568.357/0001-20',
    id_empresa_carbono: 'REI0004EM',
    nombre_empresa: 'Companhia ASF Brasil',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'reino_unido',
    relacion_proyecto: ['BR189CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.953.646/0001-44',
    id_empresa_carbono: 'BRA0037EM',
    nombre_empresa:
      'Conselho das Organizações Indígenas do Povo Javaé da Ilha do Bananal (Conjaba)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR123CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '35.191.757/0001-94',
    id_empresa_carbono: 'BRA0142EM',
    nombre_empresa:
      'Conselho Supremo de Caciques e Lideranças da Terra Indígena Cana Brava Guajajara',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5087VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.394.176/0001-26',
    id_empresa_carbono: 'BRA0032EM',
    nombre_empresa:
      'Cooperativa Agrofrutiferas Dos Produtores de Urucará (Agrofrut)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4956VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '32.019.169/0001-80',
    id_empresa_carbono: 'BRA0135EM',
    nombre_empresa:
      'Cooperativa de Produção e Desenvolvimento do Povo Indígena Cinta Larga – RO/MT (COOPERBRAVO)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR137CER', 'BR138CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '51.504.594/0001-09',
    id_empresa_carbono: 'BRA0186EM',
    nombre_empresa:
      'Cooperativa dos Produtores de Crédito de Carbono do Pará e da Amazônia - COOPERBARBON',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4681VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '47.561.721/0001-34',
    id_empresa_carbono: 'BRA0180EM',
    nombre_empresa: 'Cooperativa Mista Taapep Kaamaj do Povo Cinta',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR138CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'NAN0004EM',
    nombre_empresa: 'Copacabana Agropecuária Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3002VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '23.799.842/0001-50',
    id_empresa_carbono: 'BRA0119EM',
    nombre_empresa: 'DREAM LTDA. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR172CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '18.311.727/0001-55',
    id_empresa_carbono: 'BRA0100EM',
    nombre_empresa: 'Dunorte Agroflorestal Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3601VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.481.986/0001-76',
    id_empresa_carbono: 'BRA0109EM',
    nombre_empresa: 'ECCON Soluções Ambientais Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4117VER', 'BR4905VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '02.405.151/0002-36',
    id_empresa_carbono: 'BRA0011EM',
    nombre_empresa: 'Ecológica Assessoria LTDA.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR1686VER',
      'BR2373VER',
      'BR2482VER',
      'BR2558VER',
      'BR2709VER',
      'BR2870VER',
      'BR2871VER',
      'BR2980VER',
      'BR3152VER',
      'BR3304VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '05.086.970/0001-75',
    id_empresa_carbono: 'BRA0040EM',
    nombre_empresa: 'Ecomapuá Conservação Ltda. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1094VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'CHE-116.115.135',
    id_empresa_carbono: 'SUI0001EM',
    nombre_empresa: 'Ecosecurities Holdings SA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'suica',
    relacion_proyecto: ['BR3332VER', 'BR3380VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'USA0014EM',
    nombre_empresa: 'Ecosystem Services LLC',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR977VER', 'BR981VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '32.983.785/0001-56',
    id_empresa_carbono: 'BRA0137EM',
    nombre_empresa: 'ECOTRÓPICA - FUNDAÇÃO DE APOIO A VIDA NOS TRÓPICOS',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2566VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '23.628.450/0001-29',
    id_empresa_carbono: 'BRA0118EM',
    nombre_empresa: 'Elio Tecnologia Ltda.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR172CER', 'BR189CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '00.348.003/0068-28',
    id_empresa_carbono: 'BRA0003EM',
    nombre_empresa: 'EMBRAPA - ACRE',
    id_rol: 'consultor',
    id_tipo_empresa: 'agencia_estaod',
    id_pais: 'brasil',
    relacion_proyecto: ['BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '12.132.277/0001-57',
    id_empresa_carbono: 'BRA0084EM',
    nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1147VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '83.277.400/0001-76',
    id_empresa_carbono: 'BRA0193EM',
    nombre_empresa: 'EXPAMA - Exportadora Paragominas de Madeiras Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4042VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '01.991.834/0001-79',
    id_empresa_carbono: 'BRA0008EM',
    nombre_empresa: 'Fazenda Bodoquena Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4117VER', 'BR4905VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '44.947.794/0001-70',
    id_empresa_carbono: 'BRA0167EM',
    nombre_empresa: 'FAZENDA CONTINENTAL LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4671VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '34.597.658/0001-44',
    id_empresa_carbono: 'BRA0139EM',
    nombre_empresa: 'Floraplac Industrial Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4042VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.256.139/0001-75',
    id_empresa_carbono: 'BRA0062EM',
    nombre_empresa: 'Floraplac MDF LTDA ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4042VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.502.811/0001-65',
    id_empresa_carbono: 'BRA0066EM',
    nombre_empresa:
      'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1811VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '06.066.768/0001-44',
    id_empresa_carbono: 'BRA0043EM',
    nombre_empresa: 'Florestal Santa Maria ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR875VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '993044',
    id_empresa_carbono: 'USA0001EM',
    nombre_empresa: 'Forest Trends',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'usa',
    relacion_proyecto: ['BR1118VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'L08000049566',
    id_empresa_carbono: 'USA0016EM',
    nombre_empresa: 'Freitas International Group, LLC (Carbon Securities) ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR1112VER', 'BR1113VER', 'BR1382VER', 'BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.615.618/0001-05',
    id_empresa_carbono: 'BRA0050EM',
    nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4069VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.351.359/0001-88',
    id_empresa_carbono: 'BRA0064EM',
    nombre_empresa: 'Fundação Amazonas Sustentável - FAS',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'fundacion_privada',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1596VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '74.502.550/0001-45',
    id_empresa_carbono: 'BRA0190EM',
    nombre_empresa: 'Fundação Jari',
    id_rol: 'consultor',
    id_tipo_empresa: 'fundacion_privada',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1811VER', 'BR4615VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '43.688.286/0001-52',
    id_empresa_carbono: 'BRA0162EM',
    nombre_empresa: 'Future Carbon Holding S.A.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR2878VER',
      'BR3049VER',
      'BR3306VER',
      'BR3451VER',
      'BR3666VER',
      'BR4068VER',
      'BR4069VER',
      'BR4082VER',
      'BR4084VER',
      'BR4089VER',
      'BR4094VER',
      'BR4095VER',
      'BR4141VER',
      'BR4142VER',
      'BR4143VER',
      'BR4263VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.975.356/0001-00',
    id_empresa_carbono: 'BRA0039EM',
    nombre_empresa: 'Gairova Agropecus Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2870VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '22.694.956/0001-73',
    id_empresa_carbono: 'BRA0116EM',
    nombre_empresa: 'GEOMASTER GEOTECNOLOGIA AMBIENTAL LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4681VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '49.460.034/0001-58',
    id_empresa_carbono: 'BRA0183EM',
    nombre_empresa: 'Geowiki Engenharia Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1654VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13.331.592/0001-76',
    id_empresa_carbono: 'BRA0088EM',
    nombre_empresa: 'Gestao e Resultados Consultores Associados',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '19.235.736/0001-77',
    id_empresa_carbono: 'BRA0101EM',
    nombre_empresa: 'Global Serviços de Engenharia',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1561VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '90769759',
    id_empresa_carbono: 'PAI0001EM',
    nombre_empresa: 'Green Musk B.V.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'paises_baixos',
    relacion_proyecto: ['BR5200VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '02.609.742/0001-44',
    id_empresa_carbono: 'BRA0012EM',
    nombre_empresa: 'Grupo Dacko ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1953VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '17.919.786/0001-48',
    id_empresa_carbono: 'BRA0099EM',
    nombre_empresa: 'GRUPO JARI S.A EM RECUPERACAO JUDICIAL',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4615VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'NAN0005EM',
    nombre_empresa: 'Grupo Progresso',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '17.855.575/0001-99',
    id_empresa_carbono: 'BRA0098EM',
    nombre_empresa: 'Grupo Rovema  ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2878VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '41.764.351/0001-56',
    id_empresa_carbono: 'BRA0154EM',
    nombre_empresa: 'GRUPO SWAT INTERNACIONAL',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3601VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.424.948/0001-02',
    id_empresa_carbono: 'BRA0170EM',
    nombre_empresa: 'Guanabara Ambiental LTDA.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3631VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '34.808.431/0001-09',
    id_empresa_carbono: 'BRA0140EM',
    nombre_empresa: 'GUAXINIM Environmental Solutions Ltda. ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4394VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.454.046/0001-98',
    id_empresa_carbono: 'BRA0108EM',
    nombre_empresa:
      'Harmonia Consultoria Ltda (Harmonia Consultoria Socio Ambiental)',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1811VER', 'BR3141VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '24.773.840/0001-55',
    id_empresa_carbono: 'BRA0124EM',
    nombre_empresa: 'Harpia Soluções Sustentáveis Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5295VER', 'BR5391VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.104.900/0001-03',
    id_empresa_carbono: 'BRA0077EM',
    nombre_empresa: 'HDOM Consultoria Ambiental',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1147VER', 'BR1503VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '06.200.153/0001-69',
    id_empresa_carbono: 'BRA0045EM',
    nombre_empresa: 'I.S.R.C. Investimentos e Acessoria LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1112VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '46.443.235/0001-59',
    id_empresa_carbono: 'BRA0174EM',
    nombre_empresa: 'IACO AMBIENTAL LTDA.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3631VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '34.891.085/0001-67',
    id_empresa_carbono: 'BRA0141EM',
    nombre_empresa: 'IMAZON - Instituto do Homem e Meio Ambiente da Amazônia ',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3590VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '26.773.121/0001-60',
    id_empresa_carbono: 'BRA0128EM',
    nombre_empresa: 'Impacto Plus Consultoria e Produções Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '46.590.622/0001-18',
    id_empresa_carbono: 'BRA0175EM',
    nombre_empresa: 'Incorporadora Manicoré LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4850VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '6916690',
    id_empresa_carbono: 'USA0006EM',
    nombre_empresa: 'Indigenous Carbon LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: [
      'BR125CER',
      'BR128CER',
      'BR129CER',
      'BR130CER',
      'BR131CER',
      'BR132CER',
      'BR133CER',
      'BR134CER',
      'BR135CER',
      'BR136CER',
      'BR137CER',
      'BR138CER',
      'BR139CER',
      'BR140CER',
      'BR141CER',
      'BR142CER',
      'BR143CER',
      'BR144CER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '47.457.033/0001-29',
    id_empresa_carbono: 'BRA0178EM',
    nombre_empresa: 'Infrapar Sustainability Ltda. ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4391VER', 'BR4497VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.339.438/0001-48',
    id_empresa_carbono: 'BRA0048EM',
    nombre_empresa:
      'Instituto de Conservação e Desenvolvimento Sustentável da Amazônia – IDESAM',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1118VER', 'BR4265VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '40.839.769/0001-12',
    id_empresa_carbono: 'BRA0149EM',
    nombre_empresa:
      'Instituto dos Caciques e Povos Indígenas da Ilha do Bananal (Icapib)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR123CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '16.575.853/0001-91',
    id_empresa_carbono: 'BRA0094EM',
    nombre_empresa: 'Instituto Homem Pantaneiro',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2566VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '21.774.398/0001-93',
    id_empresa_carbono: 'BRA0112EM',
    nombre_empresa: 'Instituto Manguezal',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3601VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '02.650.035/0001-00',
    id_empresa_carbono: 'BRA0013EM',
    nombre_empresa: 'Instituto Peabiru',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4034VER', 'BR4689VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '42.551.951/0001-07',
    id_empresa_carbono: 'BRA0158EM',
    nombre_empresa: 'Instituto Taquari Vivo - ITV',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4747VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '41.184.943/0001-07',
    id_empresa_carbono: 'BRA0152EM',
    nombre_empresa: 'Instituto Wirapyna Awaete (IWA)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5200VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '07.580.775/0001-22',
    id_empresa_carbono: 'COL0002EM',
    nombre_empresa: 'Interconexión Eléctrica S.A. E.S.P ISA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['BR2566VER', 'PE1882VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: 'F12000004217',
    id_empresa_carbono: 'USA0015EM',
    nombre_empresa: 'International Wood Corporation (IWC)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR1027VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'BRA0195EM',
    nombre_empresa: 'Ipanema Agropecuária Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3002VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '23.831.247/0001-55',
    id_empresa_carbono: 'BRA0120EM',
    nombre_empresa: 'Ituxi Administração e Participação LTDA',
    id_rol: 'des_prop',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR2508VER',
      'BR2539VER',
      'BR3816VER',
      'BR4633VER',
      'BR4825VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '06.089.113/0001-91',
    id_empresa_carbono: 'BRA0044EM',
    nombre_empresa: 'Ixtis Informática e Participações Ltda. ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR172CER', 'BR189CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.398.265/0001-28',
    id_empresa_carbono: 'NAN0001EM',
    nombre_empresa: 'J O Cruz & O B Oliveira Participações Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5055VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '32.224.430/0001-83',
    id_empresa_carbono: 'BRA0136EM',
    nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3304VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.815.734/0001-80',
    id_empresa_carbono: 'BRA0036EM',
    nombre_empresa: 'Jari Celulose S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1115VER', 'BR1811VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '00.950.724/0001-04',
    id_empresa_carbono: 'BRA0004EM',
    nombre_empresa: 'Jari Florestal S.A. em recuperação judicial',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1115VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.313.775/0001-33',
    id_empresa_carbono: 'BRA0078EM',
    nombre_empresa: 'JR AGROPECUARIA E EMPREENDIMENTOS LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1382VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '00.309.708/0001-29',
    id_empresa_carbono: 'BRA0002EM',
    nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3152VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '36.634.796/0001-81',
    id_empresa_carbono: 'BRA0145EM',
    nombre_empresa: 'Lavrado Soluções Ambientais',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '12.308.347/0001-85',
    id_empresa_carbono: 'BRA0085EM',
    nombre_empresa: 'Leblon Agropecuária Ltda (Fazenda Leblon)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3002VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '75.045.120/0001-04',
    id_empresa_carbono: 'BRA0191EM',
    nombre_empresa: 'Limeira Indústria e Comércio S/A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2950VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.138.913/0001-20',
    id_empresa_carbono: 'BRA0025EM',
    nombre_empresa: 'Maísa-Moju Agroindustrial Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1329VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '84.639.632/0001-90',
    id_empresa_carbono: 'BRA0194EM',
    nombre_empresa: 'Manoa Sustentável, Exploração e Serviços Florestais Ltda ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1571VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.129.037/0001-75',
    id_empresa_carbono: 'BRA0024EM',
    nombre_empresa: 'MARCOS ANTONIO MATANA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4865VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.090.267/0001-33',
    id_empresa_carbono: 'BRA0076EM',
    nombre_empresa:
      'Mata Nativa BR (Mata Nativa do Brasil Assessoria e Consultoria Ambiental Ltda)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3281VER', 'BR4461VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '06.161.839/0001-98',
    id_empresa_carbono: 'BRA0197EM',
    nombre_empresa: 'Matogrosso Participações Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3601VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13.262.248/0001-72',
    id_empresa_carbono: 'BRA0087EM',
    nombre_empresa: 'Midiageo Grupo Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2586VER', 'BR2587VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.193.033/0001-56',
    id_empresa_carbono: 'BRA0026EM',
    nombre_empresa: 'Mil Madeiras Preciosas LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4542VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.245.529/0001-29',
    id_empresa_carbono: 'BRA0072EM',
    nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4747VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.758.301/0001-32',
    id_empresa_carbono: 'BRA0075EM',
    nombre_empresa: 'Moura e Rosa Empreendimentos Imobiliários LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '42.475.587/0001-35',
    id_empresa_carbono: 'BRA0157EM',
    nombre_empresa: 'MYCARBON3 LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4461VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.389.641/0001-91',
    id_empresa_carbono: 'BRA0055EM',
    nombre_empresa: 'Nat’Organico',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4956VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.257.875/0001-01',
    id_empresa_carbono: 'BRA0169EM',
    nombre_empresa: 'Nature Carbon LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5087VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.277.095/0001-00',
    id_empresa_carbono: 'BRA0107EM',
    nombre_empresa: 'NEO GREEN CONSULTORIA AMBIENTAL LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2950VER', 'BR3050VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '24.535.210/0001-42',
    id_empresa_carbono: 'BRA0122EM',
    nombre_empresa: 'Nigrum Capital Assessoria e Gestão de Negócios LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2980VER', 'BR3304VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '01.996.724/0001-08',
    id_empresa_carbono: 'BRA0009EM',
    nombre_empresa: 'Norwest S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1027VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.077.252/0001-93',
    id_empresa_carbono: 'BRA0061EM',
    nombre_empresa:
      'NovaAgri Infra-Estrutura De Armazenagem e Escoamento Agricola S.A.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5044VER', 'BR5430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '19.942.166/0003-17',
    id_empresa_carbono: 'BRA0105EM',
    nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2482VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '41.253.379/0001-29',
    id_empresa_carbono: 'BRA0153EM',
    nombre_empresa: 'OnePlanet Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3050VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '27.784.327/0001-58',
    id_empresa_carbono: 'BRA0130EM',
    nombre_empresa: 'Organica Consultoria Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4956VER', 'BR5025VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '01.444.198/0001-65',
    id_empresa_carbono: 'BRA0006EM',
    nombre_empresa:
      'Organização do Povo Indígena Parintintin do Amazonas - OPIPAM',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR125CER', 'BR144CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '19.666.030/0001-60',
    id_empresa_carbono: 'BRA0102EM',
    nombre_empresa: 'PACER INOVACAO LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4876VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '900305399-8',
    id_empresa_carbono: 'COL0033EM',
    nombre_empresa: 'Panthera Colombia',
    id_rol: 'proprietario',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['BR2566VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '43.500.617/0001-89',
    id_empresa_carbono: 'EMI0001EM',
    nombre_empresa: 'Para REDD Projects Ltd',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'emirados_arabes',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.330.691/0001-66',
    id_empresa_carbono: 'BRA0063EM',
    nombre_empresa:
      'Patjamaaj - Coordenação das Organizações Indigenas do Povo Cinta Larga',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR138CER', 'BR140CER', 'BR142CER', 'BR143CER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '45.879.260/0001-17',
    id_empresa_carbono: 'BRA0172EM',
    nombre_empresa: 'Pau Brasil Assessoria Florestal',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4633VER', 'BR4825VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '60.613.478/0001-19',
    id_empresa_carbono: 'BRA0188EM',
    nombre_empresa: 'Pinheiro Neto Advogados',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR875VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '05.321.358/0001-30',
    id_empresa_carbono: 'BRA0041EM',
    nombre_empresa: 'PLANT Inteligência Ambiental Ltda (PlantBR)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR875VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.388.008/0001-93',
    id_empresa_carbono: 'BRA0079EM',
    nombre_empresa: 'Radicle',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2586VER', 'BR2587VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '51.255.064/0001-74',
    id_empresa_carbono: 'BRA0185EM',
    nombre_empresa:
      'Redd Parakana Sustentabilidade Spe Ltda (Apsis Carbon Company)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5200VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '43.192.338/0001-03',
    id_empresa_carbono: 'BRA0159EM',
    nombre_empresa: 'REDDA Projetos Ambientais Ltda.',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3334VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13.991.850/0001-40',
    id_empresa_carbono: 'BRA0089EM',
    nombre_empresa: 'Renascer Desenvolvimento Humano',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1147VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '44.181.146/0001-56',
    id_empresa_carbono: 'BRA0164EM',
    nombre_empresa: 'Restaura Consultoria Ambiental e Treinamentos LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4747VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '29.225.906/0001-96',
    id_empresa_carbono: 'BRA0134EM',
    nombre_empresa: 'Ricci e Santos Advogados',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3738VER', 'BR4016VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.345.294/0001-44',
    id_empresa_carbono: 'BRA0029EM',
    nombre_empresa: 'Rio Concrem Industrial Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4042VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13.033.229/0001-74',
    id_empresa_carbono: 'CAN0004EM',
    nombre_empresa: 'RMDLT Property Group Ltd ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'canada',
    relacion_proyecto: ['BR977VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '40.968.597/0001-87',
    id_empresa_carbono: 'BRA0150EM',
    nombre_empresa: 'Roma Participações S/S LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3631VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '41.131.748/0001-00',
    id_empresa_carbono: 'BRA0151EM',
    nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4461VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '43.608.949/0001-81',
    id_empresa_carbono: 'BRA0161EM',
    nombre_empresa: 'SANTA MARIA PECUARIA E AGRONEGOCIO LTDA. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3738VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '17.198.500/0001-82',
    id_empresa_carbono: 'BRA0095EM',
    nombre_empresa:
      'SB Fundo de Investimento nas Cadeias Produtivas Agroindustriais – FIAGRO',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4142VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '48.258.048/0001-20',
    id_empresa_carbono: 'BRA0182EM',
    nombre_empresa: 'Seringal São Miguel SPE Ltda.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4394VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.378.099/0001-10',
    id_empresa_carbono: 'BRA0031EM',
    nombre_empresa: 'SERVICO NACIONAL DE APRENDIZAGEM RURAL',
    id_rol: 'consultor',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'brasil',
    relacion_proyecto: ['BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13816396',
    id_empresa_carbono: 'REI0003EM',
    nombre_empresa: 'SIMFlor Ltd ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'reino_unido',
    relacion_proyecto: ['BR3380VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.363.966/0001-44',
    id_empresa_carbono: 'BRA0030EM',
    nombre_empresa: 'Sipasa-Seringa Industrial do Pará S.A. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1329VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '13.046.954/0001-87',
    id_empresa_carbono: 'BRA0086EM',
    nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4886VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '19.763.569/0001-37',
    id_empresa_carbono: 'BRA0103EM',
    nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4886VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '27.899.023/0001-36',
    id_empresa_carbono: 'BRA0132EM',
    nombre_empresa: 'Sparta Participações Societárias S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3049VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.658.609/0001-06',
    id_empresa_carbono: 'BRA0074EM',
    nombre_empresa:
      'STA Soluções Técnicas e Serviços de Engenharia Ambiental Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3590VER', 'BR4687VER', 'BR4747VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '47.545.292/0001-01',
    id_empresa_carbono: 'BRA0179EM',
    nombre_empresa: 'Stock Capital Holding LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5343VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.510.073/0001-06',
    id_empresa_carbono: 'BRA0067EM',
    nombre_empresa: 'Sustainable Carbon Projetos Ambientais Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR1094VER',
      'BR2373VER',
      'BR2482VER',
      'BR2558VER',
      'BR2709VER',
      'BR2870VER',
      'BR2871VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11263566',
    id_empresa_carbono: 'REI0001EM',
    nombre_empresa: 'Sustainable Investment Management Limited (SIM)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'reino_unido',
    relacion_proyecto: ['BR3332VER', 'BR3380VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '22.524.415/0001-05',
    id_empresa_carbono: 'BRA0115EM',
    nombre_empresa: 'Systemica (MYS E JLFL TREINAMENTO GERENCIAL LTDA)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3738VER', 'BR4016VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '12.045.953/0001-55',
    id_empresa_carbono: 'BRA0083EM',
    nombre_empresa: 'T.A.O Consultoria Ambiental Ltda',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1686VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.199.086/0001-84',
    id_empresa_carbono: 'BRA0027EM',
    nombre_empresa: 'TECMAN ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1382VER', 'BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '17.610.393/0001-58',
    id_empresa_carbono: 'BRA0097EM',
    nombre_empresa: 'Terra Vista Gestora de Recursos Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR3816VER',
      'BR4165VER',
      'BR4221VER',
      'BR4394VER',
      'BR5055VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '2040549',
    id_empresa_carbono: 'USA0003EM',
    nombre_empresa: 'TerraCarbon LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR1382VER', 'BR832VER', 'BR963VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.047.829/0001-14',
    id_empresa_carbono: 'BRA0060EM',
    nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda. ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4143VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '11.514.646/0001-03',
    id_empresa_carbono: 'BRA0081EM',
    nombre_empresa: 'Transmaranata Transportes Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2587VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '75.059.857/0001-86',
    id_empresa_carbono: 'BRA0192EM',
    nombre_empresa: 'Triângulo Pisos e Paineis Ltda',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1571VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20.949.082/0001-22',
    id_empresa_carbono: 'BRA0111EM',
    nombre_empresa: 'Uezu Planejamento Ambiental S/S LTDA',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: [
      'BR2373VER',
      'BR2482VER',
      'BR2558VER',
      'BR2709VER',
      'BR2870VER',
      'BR2980VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '10.199.645/0005-82',
    id_empresa_carbono: 'BRA0069EM',
    nombre_empresa: 'Universal Timber Resources do Brasil Ltda. (UTRB)',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR2980VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '04.960.233/0001-97',
    id_empresa_carbono: 'BRA0038EM',
    nombre_empresa: 'Urupianga Agro Pecuaria S.A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4143VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '44.749.580/0001-90',
    id_empresa_carbono: 'BRA0166EM',
    nombre_empresa: 'Urupolpas ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4956VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '15.009.178/0001-70',
    id_empresa_carbono: 'BRA0091EM',
    nombre_empresa: 'Usinas Itamarati S/A ',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4141VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.676.931/0001-00',
    id_empresa_carbono: 'BRA0019EM',
    nombre_empresa: 'Vale Sereno Propriedades Agrícolas S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4142VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '03.587.881/0001-87',
    id_empresa_carbono: 'BRA0018EM',
    nombre_empresa: 'Vale Verde Propriedades Agrícolas S.A.',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4142VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '05.449.072/0001-34',
    id_empresa_carbono: 'BRA0042EM',
    nombre_empresa: 'Vasta Insumos da Amazônia Ltda',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4834VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.294.685/0001-38',
    id_empresa_carbono: 'BRA0054EM',
    nombre_empresa: 'WayCarbon Soluções Ambientais e Projetos de Carbono LTDA ',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3631VER', 'BR4802VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '21.838.332/0001-10',
    id_empresa_carbono: 'BRA0113EM',
    nombre_empresa: 'WMF Energy S/A',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR1561VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '46.831.892/0001-73',
    id_empresa_carbono: 'BRA0176EM',
    nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR4552VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'NAN0007EM',
    nombre_empresa: 'ZEG Florestal',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'no_disponible',
    relacion_proyecto: ['BR5415VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '2019-000866893',
    id_empresa_carbono: 'USA0010EM',
    nombre_empresa: 'Zero Carbon Holdings LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'usa',
    relacion_proyecto: ['BR2587VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '08.652.284/0001-02',
    id_empresa_carbono: 'BRA0198EM',
    nombre_empresa: 'SCCON',
    id_rol: 'consultor',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR5430VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '09.448.003/0001-67',
    id_empresa_carbono: 'BRA0065EM',
    nombre_empresa: 'ZX Participações S/A',
    id_rol: 'proprietario',
    id_tipo_empresa: 'empresa',
    id_pais: 'brasil',
    relacion_proyecto: ['BR3306VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
]

const empresasCO: IEmpresas[] = [
  {
    id_empresa: '901191938-1',
    id_empresa_carbono: 'COL0055EM',
    nombre_empresa: 'Allcot Colombia S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO002NA',
      'CO008NA',
      'CO022NA',
      'CO023NA',
      'CO024NA',
      'CO2084VER',
    ],
    perfil_es:
      'Creada en 2018, Allcot Colombia S.A.S. es la filial colombiana de la empresa suiza Allcot AG, que aparecía como su accionista única a agosto de 2023. Esta empresa, registrada en Zurich y con sede en Zug, impulsa distintos proyectos del mercado de carbono, incluyendo Redd+ pero también de aforestación y reforestación, de estufas ecoeficientes y de carbono azul. El fundador, gerente y cabeza visible de ambas empresas es el francés Alexis Ludwig Leroy, que tiene más de una década de trayectoria en el sector de carbono y ha estado vinculado tanto a la Asociación Internacional de Comercio de Emisiones (IETA) como a la Asociación de Mercados e Inversiones Climáticas (CMIA), y que aparecía inicialmente como accionista único de Allcot Colombia. Además de Colombia, Allcot AG tiene oficinas en México, Argentina, Guatemala, Senegal, España y Gran Bretaña y proyectos Redd+ en Senegal, Costa de Marfil y México. En Colombia, el grupo aparece como desarrollador de 6 proyectos Redd+, uno solo de los cuales aparece registrado y en estado de implementación en un estándar de certificación. Es miembro del gremio Asocarbono, que reúne a los actores del mercado de carbono en Colombia, habiéndose retirado citando ""diferencias de visión"" pero sumándose de nuevo en julio de 2024.',
    perfil_en:
      'Created in 2018, Allcot Colombia S.A.S. is the Colombian subsidiary of the Swiss company Allcot AG, which was listed as its sole shareholder as of August 2023. This company, registered in Zurich and headquartered in Zug, promotes different carbon market projects, including Redd+ but also afforestation and reforestation, eco-efficient stoves and blue carbon. The founder, manager and visible head of both companies is the Frenchman Alexis Ludwig Leroy, who has more than a decade of experience in the carbon sector and has been linked to both the International Emissions Trading Association (IETA) and the Climate Markets and Investment Association (CMIA), and who was initially listed as the sole shareholder of Allcot Colombia. In addition to Colombia, Allcot AG has offices in Mexico, Argentina, Guatemala, Senegal, Spain and Great Britain and Redd+ projects in Senegal, Ivory Coast and Mexico. In Colombia, the group is listed as the developer of 6 Redd+ projects, only one of which is registered and in implementation status in a certification standard. It is a member of the Asocarbono guild, which brings together carbon market players in Colombia, having withdrawn citing ""differences of vision"" but joining again in July 2024.',
    perfil_pt:
      'Criada em 2018, a Allcot Colombia S.A.S. é a filial colombiana da empresa suíça Allcot AG, que aparecia como sua única acionista em agosto de 2023. Esta empresa, registrada em Zurique e com sede em Zug, promove diversos projetos do mercado de carbono, incluindo Redd+, mas também de florestamento e reflorestamento, de estufas ecoeficientes e de carbono azul. O fundador, gerente e rosto visível de ambas as empresas é o francês Alexis Ludwig Leroy, que tem mais de uma década de experiência no setor de carbono e esteve vinculado tanto à Associação Internacional de Comércio de Emissões (IETA) quanto à Associação de Mercados e Investimentos Climáticos (CMIA), e que aparecia inicialmente como único acionista da Allcot Colombia. Além da Colômbia, a Allcot AG possui escritórios no México, Argentina, Guatemala, Senegal, Espanha e Grã-Bretanha, e projetos Redd+ no Senegal, Costa do Marfim e México. Na Colômbia, o grupo aparece como desenvolvedor de seis projetos Redd+, dos quais apenas um está registrado e em fase de implementação em um padrão de certificação. É membro da associação comercial Asocarbono, que reúne os atores do mercado de carbono na Colômbia, tendo se retirado alegando “diferenças de visão”, mas voltando a se associar em julho de 2024.',
  },
  {
    id_empresa: '901266201-4',
    id_empresa_carbono: 'COL0063EM',
    nombre_empresa: 'Amazon Carbon Bonds S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO018NA', 'CO030COL', 'CO033COL', 'CO044COL'],
    perfil_es:
      'Empresa fundada en 2019 y registrada en Villavicencio con el objeto ""desarrollar soluciones basadas en la naturaleza"". A marzo de 2021 contaba -según un acta de cámara de comercio- con nueve socios accionistas: su fundador y representante legal Jonathan Núñez Guevara (con 60% de las acciones), Laura Camila Calderón Moreno (con 20%), Germán Javier Díaz Gutiérrez (con 10%), Leonel Bohórquez Bohórquez, Ernesto Moisés Amaya Campos, Eva Yaneth Araque Delgado, Nelson Enrique Cabaneiro Urbano, Didier Enrique Guevara Cárdenas y Diego Armando Núñez Guevara. Lidera tres proyectos en la Amazonia colombiana y uno más en Honduras, en inmediaciones de la Reserva de la Biósfera del Río Plátano en la región de la Mosquitia. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'Company founded in 2019 and registered in Villavicencio with the object ""to develop nature-based solutions"". As of March 2021 it had - according to a chamber of commerce act - nine shareholder partners: its founder and legal representative Jonathan Núñez Guevara (with 60% of the shares), Laura Camila Calderón Moreno (with 20%), Germán Javier Díaz Gutiérrez (with 10%), Leonel Bohórquez Bohórquez, Ernesto Moisés Amaya Campos, Eva Yaneth Araque Delgado, Nelson Enrique Cabaneiro Urbano, Didier Enrique Guevara Cárdenas and Diego Armando Núñez Guevara. He leads three projects in the Colombian Amazon and one more in Honduras, near the Río Plátano Biosphere Reserve in the Mosquitia region. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Empresa fundada em 2019 e registrada em Villavicencio com o objetivo de “desenvolver soluções baseadas na natureza”. Em março de 2021, contava, segundo uma ata da câmara de comércio, com nove sócios acionistas: seu fundador e representante legal Jonathan Núñez Guevara (com 60% das ações), Laura Camila Calderón Moreno (com 20%), Germán Javier Díaz Gutiérrez (com 10%), Leonel Bohórquez Bohórquez, Ernesto Moisés Amaya Campos, Eva Yaneth Araque Delgado, Nelson Enrique Cabaneiro Urbano, Didier Enrique Guevara Cárdenas e Diego Armando Núñez Guevara. Lidera três projetos na Amazônia colombiana e mais um em Honduras, nas proximidades da Reserva da Biosfera do Rio Plátano, na região da Mosquitia. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '901166791-9',
    id_empresa_carbono: 'COL0052EM',
    nombre_empresa: 'Biofix Consultoría S.A.S. BIC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO006BIO',
      'CO007BIO',
      'CO011BIO',
      'CO013BIO',
      'CO022CER',
      'CO060CER',
      'CO061CER',
      'CO102CER',
      'CO117CER',
      'CO148CER',
      'CO2459VER',
      'BR123CER',
    ],
    perfil_es:
      'Empresa fundada en 2018, que a marzo de 2023 era propiedad de la empresa Biofix Group S.A.S. Originalmente fue fundada por Mónica Jiménez Salazar y por Ana Milena Plata Fajardo, una economista con doctorado en economía forestal de la Universidad Federal de Paraná en Brasil que trabajó en la oficina de negocios verdes del Ministerio de Ambiente entre 2016 y 2018, y que durante años fue la gerente y cabeza visible de la empresa (siendo a agosto de 2024 aún su representante legal suplente). La empresa ha cambiado varias veces su estructura accionaria: en mayo de 2019, sus accionistas únicos eran Plata (con el 57% de las acciones) y el abogado Marco González Carantón, actual gerente jurídico y ex representante legal suplente de Biofix (con 43% de las acciones). Luego, en mayo de 2020, Biofix Consultoría pasó a ser propiedad de dos empresas: Econaut S.A.S. con el 57% de las acciones (a su vez propiedad en un 100% de Plata) y Biolegal S.A.S. con el 43% (propiedad en un 100% de González). A partir de noviembre de 2022, quedó registrada como empresa bajo el control de Biofix Group S.A.S., que era a febrero de 2023 propiedad de Plata (con el 57% de las acciones) y González Carantón (con 43% de las acciones), siendo también accionista de la empresa Bosque Vivo S.A.S. Desde 2022 Biofix añadió BIC a su nombre, distintivo de Beneficio e Interés Colectivo (BIC) para empresas que voluntariamente se comprometen con implementar prácticas de sostenibilidad y de conducta empresarial responsable. En Colombia, Biofix BIC aparece como desarrollador de 10 proyectos Redd+ que figuran en estado de implementación, incluyendo uno liderado por la empresa Tángara Forest S.A.S. Zomac en el que Biofix figura como formulador. Además, Biofix lidera desde finales de 2022 dos proyectos en Brasil. Desde febrero de 2024 hasta marzo de 2025, su gerente fue Carolina Jarro, una bióloga que trabajó durante más de una década en Parques Nacionales Naturales, incluyendo como subdirectora. Al menos un proyecto en el que participó Biofix ha estado envuelto en controversias: el proyecto Tángara REDD+ figura como desarrollado en predios privados, pero -como contó una investigación de CLIP y Rutas del Conflicto publicada en marzo de 2025- mapas oficiales muestran que incluye tierras del consejo comunitario Mayorquín y Papayal e incluso se podría traslapar con las tierras de dos más (Raposo y Bracitos y Amazonas). Dos de esas comunidades dicen haber sido excluidas de la iniciativa que tiene lugar parcialmente en su territorio. La empresa desarrolladora Tángara Forest insiste en que los documentos legales acreditan su propiedad de esos predios y que la cadena de posesión privada de esos terrenos se remonta al siglo XIX, argumentando que múltiples entidades públicas así lo han indicado, incluyendo el Ministerio del Interior que certificó, según la interpretación de la empresa, que en dichos predios no había presencia alguna de comunidades étnicas (aunque en realidad éste solo indicó que en su visión, el proyecto no requería consulta previa, libre e informada por tratarse de una iniciativa ambiental, pero no entraba a determinar si allí había comunidades étnicas). Biofix, quien solicitó dicha certificación al Ministerio del Interior, dice que tuvo un acuerdo comercial con Tángara Forest desde mayo de 2018 hasta mayo de 2022, pero que ya no lo tiene. El conflicto entre la empresa y las comunidades locales que dicen no haberse beneficiado del proyecto ya llegó a manos de un juez de restitución de tierras. Biofix BIC es miembro de Asocarbono, el gremio que reúne a los actores del mercado de carbono en Colombia, cuya junta directiva presidió Plata.',
    perfil_en:
      "Company founded in 2018, which as of March 2023 was owned by the company Biofix Group S.A.S. It was originally founded by Mónica Jiménez Salazar and Ana Milena Plata Fajardo, an economist with a PhD in forest economics from the Federal University of Paraná in Brazil who worked in the green business office of the Ministry of Environment between 2016 and 2018, and who for years was the manager and visible head of the company (being as of August 2024 still its alternate legal representative). The company has changed its shareholding structure several times: in May 2019, its sole shareholders were Plata (with 57% of the shares) and the lawyer Marco González Carantón, current legal manager and former alternate legal representative of Biofix (with 43% of the shares). Then, in May 2020, Biofix Consultoría became owned by two companies: Econaut S.A.S. with 57% of the shares (in turn 100% owned by Plata) and Biolegal S.A.S. with 43% (100% owned by González). As of November 2022, it was registered as a company under the control of Biofix Group S.A.S., which as of February 2023 was owned by Plata (with 57% of the shares) and González Carantón (with 43% of the shares), being also a shareholder of the company Bosque Vivo S.A.S. Since 2022 Biofix added BIC to its name, distinctive of Collective Benefit and Interest (BIC) for companies that voluntarily commit to implement sustainability practices and responsible business conduct. In Colombia, Biofix BIC is listed as the developer of 10 Redd+ projects in implementation status, including one led by the company Tángara Forest S.A.S. Zomac in which Biofix is listed as the formulator. In addition, Biofix is leading two projects in Brazil from the end of 2022. From February 2024 to March 2025, its manager was Carolina Jarro, a biologist who worked for more than a decade in National Natural Parks, including as deputy director. At least one project in which Biofix participated has been mired in controversy: the Tángara REDD+ project is listed as being developed on private land, but - as a CLIP and Rutas del Conflicto investigation published in March 2025 reported - official maps show that it includes lands of the Mayorquín and Papayal community councils and may even overlap with the lands of two others (Raposo and Bracitos and Amazonas). Two of these communities say they have been excluded from the initiative, which is partially taking place in their territory. The developer Tángara Forest insists that legal documents accredit its ownership of these lands and that the chain of private possession of these lands dates back to the 19th century, arguing that multiple public entities have so indicated, including the Ministry of the Interior, which certified, according to the company's interpretation, that there was no presence of ethnic communities on these lands (although in reality it only indicated that in its view, the project did not require free, prior and informed consultation because it was an environmental initiative, but did not determine whether there were ethnic communities there). Biofix, who requested such certification from the Ministry of the Interior, says it had a commercial agreement with Tángara Forest from May 2018 to May 2022, but no longer has one. The conflict between the company and local communities who say they have not benefited from the project has already reached the hands of a land restitution judge. Biofix BIC is a member of Asocarbono, the guild that brings together carbon market players in Colombia, whose board of directors Plata chaired.",
    perfil_pt:
      'Empresa fundada em 2018, que em março de 2023 era propriedade da empresa Biofix Group S.A.S. Originalmente foi fundada por Mónica Jiménez Salazar e por Ana Milena Plata Fajardo, economista com doutorado em economia florestal pela Universidade Federal do Paraná, no Brasil, que trabalhou no escritório de negócios verdes do Ministério do Meio Ambiente entre 2016 e 2018 e que durante anos foi gerente e rosto visível da empresa (sendo, em agosto de 2024, ainda sua representante legal suplente). A empresa mudou várias vezes sua estrutura acionária: em maio de 2019, seus únicos acionistas eram Plata (com 57% das ações) e o advogado Marco González Carantón, atual gerente jurídico e ex-representante legal substituto da Biofix (com 43% das ações). Posteriormente, em maio de 2020, a Biofix Consultoría passou a ser propriedade de duas empresas: Econaut S.A.S., com 57% das ações (por sua vez, propriedade de 100% de Plata), e Biolegal S.A.S., com 43% (propriedade de 100% de González). A partir de novembro de 2022, foi registrada como empresa sob o controle da Biofix Group S.A.S., que em fevereiro de 2023 era propriedade de Plata (com 57% das ações) e González Carantón (com 43% das ações), sendo também acionista da empresa Bosque Vivo S.A.S. Desde 2022, a Biofix acrescentou BIC ao seu nome, distintivo de Beneficio e Interés Colectivo (BIC) para empresas que se comprometem voluntariamente a implementar práticas de sustentabilidade e conduta empresarial responsável. Na Colômbia, a Biofix BIC aparece como desenvolvedora de 10 projetos Redd+ que estão em fase de implementação, incluindo um liderado pela empresa Tángara Forest S.A.S. Zomac, no qual a Biofix figura como formuladora. Além disso, a Biofix lidera desde o final de 2022 dois projetos no Brasil. De fevereiro de 2024 a março de 2025, sua gerente foi Carolina Jarro, uma bióloga que trabalhou por mais de uma década em Parques Nacionais Naturais, inclusive como subdiretora. Pelo menos um projeto em que a Biofix participou esteve envolvido em controvérsias: o projeto Tángara REDD+ figura como desenvolvido em propriedades privadas, mas, conforme relatado por uma investigação do CLIP e Rutas del Conflicto publicada em março de 2025, mapas oficiais mostram que ele inclui terras do conselho comunitário de Mayorquín e Papayal e pode até se sobrepor às terras de mais duas (Raposo e Bracitos e Amazonas). Duas dessas comunidades afirmam ter sido excluídas da iniciativa que ocorre parcialmente em seu território. A empresa desenvolvedora Tángara Forest insiste que os documentos legais comprovam sua propriedade dessas terras e que a cadeia de posse privada desses terrenos remonta ao século XIX, argumentando que várias entidades públicas assim o indicaram, incluindo o Ministério do Interior, que certificou, segundo a interpretação da empresa, que nessas propriedades não havia presença de comunidades étnicas (embora, na verdade, ele apenas tenha indicado que, em sua visão, o projeto não exigia consulta prévia, livre e informada por se tratar de uma iniciativa ambiental, mas não determinou se havia comunidades étnicas no local). A Biofix, que solicitou essa certificação ao Ministério do Interior, afirma que tinha um acordo comercial com a Tángara Forest de maio de 2018 a maio de 2022, mas que já não o tem. O conflito entre a empresa e as comunidades locais que afirmam não ter se beneficiado do projeto já chegou às mãos de um juiz de restituição de terras. A Biofix BIC é membro da Asocarbono, a associação comercial que reúne os atores do mercado de carbono na Colômbia, cujo conselho de administração foi presidido por Plata.',
  },
  {
    id_empresa: '900909227-2',
    id_empresa_carbono: 'COL0046EM',
    nombre_empresa: 'Carbo Sostenible S.A.S',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO019BIO',
      'CO020BIO',
      'CO020NA',
      'CO021NA',
      'CO024BIO',
      'CO031BIO',
      'CO035BIO',
      'CO036BIO',
      'CO060BIO',
      'CO061BIO',
      'CO099CER',
      'CO2723VER',
      'BR4761VER',
      'PE001NA',
      'PE5077VER',
      'PER4773VER'
    ],
    perfil_es:
      'Empresa creada en 2015 con el objeto de realizar consultorías en el sector ambiental, originalmente llamada Optim Ambiental y Social S.A.S. hasta 2018. A abril de 2023, contaba con dos accionistas: la empresa Carbo Holding S.A.S. tenía 95% de las acciones (siendo a su vez propiedad en un 100% de Juan Andrés López Silva) y el abogado y actual representante legal José Miguel Correa Salazar con 5%. Su cabeza visible y director general es el administrador de empresas Juan Andrés López Silva, que fue director de cambio climático del programa BIOREDD+ de USAID, que impulsó ocho proyectos de carbono en el Pacífico. Forma parte de la alianza Community Redd con otras cuatro empresas, cada una encargándose de una tarea distinta en varios proyectos del mercado voluntario de carbono, aunque no figuran todas en todos los proyectos: Carbo Sostenible formula los documentos técnicos, Terra Commodities comercializa los bonos, Visso Consultores se ocupa de la parte financiera y Yauto de la social. Carbo Sostenible aparece vinculada a al menos 12 proyectos Redd+ en Colombia, más proyectos en formulación en Brasil y Perú. En dos de sus proyectos, esta alianza periodística ha documentado problemas. Por un lado, CLIP encontró que dos comunidades de las seis que históricamente han formado parte del resguardo de Monochoa y su zona de vigilancia y control, llamadas Aménani y Monochoa, fueron inicialmente excluidas de los proyectos (Monochoa y CRIMA Predio Putumayo) llevados a cabo allí mientras su territorio sí era incluido (situación que fue corregida posterior a la publicación). Por otro lado, Infoamazonia encontró que la alianza Community Redd+ intentó impulsar proyectos en el Alto Solimões, en Brasil, a pesar de las recomendaciones contrarias del órgano indigenista estatal Funai. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      "A company created in 2015 with the purpose of consulting in the environmental sector, originally called Optim Ambiental y Social S.A.S. until 2018. As of April 2023, it had two shareholders: the company Carbo Holding S.A.S. had 95% of the shares (being in turn 100% owned by Juan Andrés López Silva) and the lawyer and current legal representative José Miguel Correa Salazar with 5%. Its visible head and general director is business administrator Juan Andrés López Silva, who was director of climate change for USAID's BIOREDD+ program, which promoted eight carbon projects in the Pacific. He is part of the Community Redd alliance with four other companies, each taking on a different task in several voluntary carbon market projects, although not all of them are involved in all projects: Carbo Sostenible formulates the technical documents, Terra Commodities markets the credits, Visso Consultores handles the financial side, and Yauto handles the social side. Carbo Sostenible is involved in at least 12 Redd+ projects in Colombia, plus projects being formulated in Brazil and Peru. In two of its projects, this journalistic alliance has documented problems. On the one hand, CLIP found that two of the six communities that have historically formed part of the Monochoa reservation and its surveillance and control zone, called Aménani and Monochoa, were initially excluded from the projects (Monochoa and CRIMA Predio Putumayo) carried out there while their territory was included (a situation that was corrected after publication). On the other hand, Infoamazonia found that the Community Redd+ alliance tried to promote projects in Alto Solimões, in Brazil, despite recommendations to the contrary from the state indigenous organization Funai. It is a member of Asocarbono, the guild of carbon market actors in Colombia.",
    perfil_pt:
      'Empresa criada em 2015 com o objetivo de prestar consultoria no setor ambiental, originalmente chamada Optim Ambiental y Social S.A.S. até 2018. Em abril de 2023, contava com dois acionistas: a empresa Carbo Holding S.A.S. detinha 95% das ações (sendo, por sua vez, 100% propriedade de Juan Andrés López Silva) e o advogado e atual representante legal José Miguel Correa Salazar, com 5%. Seu representante e diretor geral é o administrador de empresas Juan Andrés López Silva, que foi diretor de mudança climática do programa BIOREDD+ da USAID, que impulsionou oito projetos de carbono no Pacífico. Faz parte da aliança Community Redd com outras quatro empresas, cada uma responsável por uma tarefa diferente em vários projetos do mercado voluntário de carbono, embora nem todas apareçam em todos os projetos: a Carbo Sostenible formula os documentos técnicos, a Terra Commodities comercializa os créditos, a Visso Consultores cuida da parte financeira e a Yauto da parte social. A Carbo Sostenible está ligada a pelo menos 12 projetos Redd+ na Colômbia, além de outros projetos em fase de formulação no Brasil e no Peru. Em dois de seus projetos, esta aliança jornalística documentou problemas. Por um lado, o CLIP descobriu que duas das seis comunidades que historicamente fazem parte da terra indígena de Monochoa e sua zona de vigilância e controle, chamadas Aménani e Monochoa, foram inicialmente excluídas dos projetos (Monochoa e CRIMA Predio Putumayo) realizados lá, enquanto seu território foi incluído (situação que foi corrigida após a publicação). Por outro lado, a Infoamazonia descobriu que a aliança Community Redd+ tentou impulsionar projetos no Alto Solimões, no Brasil, apesar das recomendações contrárias do órgão indigenista estatal Funai. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '900634522-9',
    id_empresa_carbono: 'COL0040EM',
    nombre_empresa: 'Fundación Cataruben',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO015BIO', 'CO021BIO', 'CO057BIO'],
    perfil_es:
      'Organización sin ánimo de lucro fundada en 2013 por su actual directora María Fernanda Wilches Fonseca y su actual director de proyectos Eduwin Antonio Hincapié Peñaloza, así como por Miguel Andrés Wilches Fonseca y Angie Ferleidy Sanabria Peñaloza, quienes figuraban a 2022 como asociados fundadores de Cataruben. Además de ellos, figuraban como asociados de Cataruben a diciembre de 2022 su actual líder de carbono Sandra Yuribel Duarte Chaparro, su gerente de innovación Y productividad Shirley Yeraldin Rojas Molano y Andrea Fernanda Rodríguez Wilches. Cataruben tiene tres proyectos de carbono en la Orinoquia, que suman casi 300 propiedades privadas y dos de los cuales tuvieron el apoyo económico del programa Riqueza Natural de la agencia de cooperación estadounidense USAID. Fue integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia pero se retiró en 2024.',
    perfil_en:
      'Non-profit organization founded in 2013 by its current director María Fernanda Wilches Fonseca and its current project director Eduwin Antonio Hincapié Peñaloza, as well as Miguel Andrés Wilches Fonseca and Angie Ferleidy Sanabria Peñaloza, who were listed as founding members of Cataruben as of 2022. In addition to them, its current carbon leader Sandra Yuribel Duarte Chaparro, its innovation and productivity manager Shirley Yeraldin Rojas Molano and Andrea Fernanda Rodríguez Wilches were listed as associates of Cataruben as of December 2022. Cataruben has three carbon projects in the Orinoquia, totaling almost 300 private properties and two of which had the financial support of the Natural Wealth program of the U.S. cooperation agency USAID. It was a member of Asocarbono, the guild of carbon market actors in Colombia, but withdrew in 2024.',
    perfil_pt:
      'Organização sem fins lucrativos fundada em 2013 por sua atual diretora, María Fernanda Wilches Fonseca, e seu atual diretor de projetos, Eduwin Antonio Hincapié Peñaloza, bem como por Miguel Andrés Wilches Fonseca e Angie Ferleidy Sanabria Peñaloza, que figuravam em 2022 como sócios fundadores da Cataruben. Além deles, constavam como associados da Cataruben em dezembro de 2022 sua atual líder de carbono, Sandra Yuribel Duarte Chaparro, sua gerente de inovação e produtividade, Shirley Yeraldin Rojas Molano, e Andrea Fernanda Rodríguez Wilches. A Cataruben tem três projetos de carbono na Orinoquia, que somam quase 300 propriedades privadas, dois dos quais tiveram o apoio financeiro do programa Riqueza Natural da agência de cooperação norte-americana USAID. Foi membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia, mas retirou-se em 2024.',
  },
  {
    id_empresa: '900192858-1',
    id_empresa_carbono: 'COL0030EM',
    nombre_empresa: 'Compensation International Progress S.A. (Greenlife)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO001PLA'],
    perfil_es:
      'Empresa creada en 2007, más frecuentemente conocida como CIProgress, CIProgress Greenlife o Greenlife. A diciembre de 2021 contaba con una treintena de accionistas, siendo las más grandes JMBG Green Investing S.A.S. (con 34,32% de las acciones y representada porn Juan Mario Bernal García), según consta en un acta de cámara de comercio. Otros accionistas que poseían entre el 7 y el 2% de las acciones a finales de 2021 incluían a las empresas Biomax Biocombustibles S.A. (con 4,71%), Planeta Limpio S.A. (representada por José Micolta Cabrera), Freeland Construcciones S.A.S. (representada por Abdón Marcelo Andrade Chávez), Gil y Cía Sociedad en Comandita (representada por Luis Ignacio Gil Zuleta) y a las personas naturales José Micolta Cabrera, Omar Alberto Rodríguez Bernal, Carlos Arias Alfaro (quien era representante legal suplente a octubre de 2024), Alicia Micolta Cabrera (quien actualmente es socia y una de las cabezas visibles de Yauto), Germán Bernal Gutiérrez (quien era representante legal a octubre de 2024 y fue integrante de la junta directiva de la petrolera estatal Ecopetrol), Daniel Sebastián Bernal Linares y Juan Sebastián Bernal García. Otras cuatro empresas y 17 personas contaban con menos del 1% de las acciones. Según un acta de la empresa Jayma Holdings S.A.S., cuya propietaria única es Alicia Micolta Cabrera, ésta le transfirió a dicha empresa todas sus acciones de CIProgress.',
    perfil_en:
      'Company created in 2007, more frequently known as CIProgress, CIProgress Greenlife or Greenlife. As of December 2021 it had some thirty shareholders, the largest being JMBG Green Investing S.A.S. (with 34.32% of the shares and represented by Juan Mario Bernal García), according to a chamber of commerce certificate. Other shareholders holding between 7 and 2% of the shares at the end of 2021 included the companies Biomax Biocombustibles S.A. (with 4.71%), Planeta Limpio S.A. (represented by José Micolta Cabrera), Freeland Construcciones S.A.S. (represented by Abdón Marcelo Marcelo Marcelo), Freeland Construcciones S.A.S. (represented by Abdón Marcelo Marcelo Marcelo), and Planeta Limpio S.A. (represented by José Micolta Cabrera). (represented by Abdón Marcelo Andrade Chávez), Gil y Cía Sociedad en Comandita (represented by Luis Ignacio Gil Zuleta) and the natural persons José Micolta Cabrera, Omar Alberto Rodríguez Bernal, Carlos Arias Alfaro (who was alternate legal representative as of October 2024), Alicia Micolta Cabrera (who is currently a partner and one of the visible heads of Yauto), Germán Bernal Gutiérrez (who was the legal representative as of October 2024 and was a member of the board of directors of the state-owned oil company Ecopetrol), Daniel Sebastián Bernal Linares and Juan Sebastián Bernal García. Four other companies and 17 individuals held less than 1% of the shares. According to the minutes of the company Jayma Holdings S.A.S., whose sole owner is Alicia Micolta Cabrera, she transferred all her shares in CIProgress to that company.',
    perfil_pt:
      'Empresa criada em 2007, mais conhecida como CIProgress, CIProgress Greenlife ou Greenlife. Em dezembro de 2021, contava com cerca de trinta acionistas, sendo os maiores JMBG Green Investing S.A.S. (com 34,32% das ações e representada por Juan Mario Bernal García), conforme consta em uma ata da câmara de comércio. Outros acionistas que possuíam entre 7% e 2% das ações no final de 2021 incluíam as empresas Biomax Biocombustibles S.A. (com 4,71%), Planeta Limpio S.A. (representada por José Micolta Cabrera), Freeland Construcciones S.A.S. (representada por Abdón Marcelo Andrade Chávez), Gil y Cía Sociedad en Comandita (representada por Luis Ignacio Gil Zuleta) e as pessoas físicas José Micolta Cabrera, Omar Alberto Rodríguez Bernal, Carlos Arias Alfaro (que era representante legal suplente em outubro de 2024), Alicia Micolta Cabrera (atualmente sócia e uma das principais figuras da Yauto), Germán Bernal Gutiérrez (que era representante legal em outubro de 2024 e foi membro do conselho de administração da petrolífera estatal Ecopetrol), Daniel Sebastián Bernal Linares e Juan Sebastián Bernal García. Outras quatro empresas e 17 pessoas detinham menos de 1% das ações. De acordo com uma ata da empresa Jayma Holdings S.A.S., cuja única proprietária é Alicia Micolta Cabrera, esta transferiu para a referida empresa todas as suas ações da CIProgress.',
  },
  {
    id_empresa: '901245493-8',
    id_empresa_carbono: 'COL0060EM',
    nombre_empresa: 'CO2Cero S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO030COL', 'CO056BIO', 'CO089CER', 'CO114CER'],
    perfil_es:
      'Empresa creada en 2018 para impulsar proyectos ambientales y de comercio de productos renovables y no renovables, que tiene según su página web oficinas en Bogotá, Riohacha, Valledupar y la Ciudad del Saber en Panamá. Actualmente lidera cuatro proyectos Redd+ en Colombia y uno en Panamá (llamado REDD+ Emberá Wounaan, en alianza con B-Terra Corp y ubicado en la provincia del Darién). Como fundadora y accionista única de CO2Cero aparecía a septiembre de 2021 la empresa Ecologic S.A.S., cuyo representante legal Edgar Mauricio Rodríguez Castro es también el gerente y representante legal de CO2Cero. Ecologic, creada en 2011 y registrada en Puerto Gaitán, es una empresa dedicada a impulsar proyectos forestales maderables, fundada por Rodríguez Castro (con 75% de las acciones al momento de la fundación) y Federico López Arana (con el 25% al momento de la fundación), pero que a marzo de 2019 contaba un total de 27 accionistas, liderados por la empresa Pervivir S.A.S. con 43%, SG-Corp S.A.S. con 14% y Ecosuites S.A.S. con 12%. Rodríguez Castro, el representante legal tanto de CO2Cero como de Ecologic, es un ingeniero industrial con experiencia en el sector maderero, fue uno de los fundadores y presidente de la junta directiva de Asocarbono, el gremio que reúne a los actores del mercado de carbono en Colombia y del que la empresa es integrante.',
    perfil_en:
      'Company created in 2018 to promote environmental projects and trade of renewable and non-renewable products, which has according to its website offices in Bogota, Riohacha, Valledupar and the City of Knowledge in Panama. It currently leads four Redd+ projects in Colombia and one in Panama (called REDD+ Emberá Wounaan, in alliance with B-Terra Corp and located in the Darién province). As founder and sole shareholder of CO2Cero as of September 2021 was Ecologic S.A.S., whose legal representative Edgar Mauricio Rodríguez Castro is also the manager and legal representative of CO2Cero. Ecologic, created in 2011 and registered in Puerto Gaitán, is a company dedicated to promoting timber forestry projects, founded by Rodríguez Castro (with 75% of the shares at the time of founding) and Federico López Arana (with 25% at the time of founding), but which as of March 2019 had a total of 27 shareholders, led by the company Pervivir S.A.S. with 43%, SG-Corp S.A.S. with 14% and Ecosuites S.A.S. with 12%. Rodríguez Castro, the legal representative of both CO2Cero and Ecologic, is an industrial engineer with experience in the timber sector and was one of the founders and president of the board of directors of Asocarbono, the association that brings together the actors of the carbon market in Colombia and of which the company is a member.',
    perfil_pt:
      'Empresa criada em 2018 para promover projetos ambientais e de comércio de produtos renováveis e não renováveis, que, segundo seu site, possui escritórios em Bogotá, Riohacha, Valledupar e na Cidade do Conhecimento, no Panamá. Atualmente, lidera quatro projetos Redd+ na Colômbia e um no Panamá (chamado REDD+ Emberá Wounaan, em parceria com a B-Terra Corp e localizado na província de Darién). Como fundadora e única acionista da CO2Cero, em setembro de 2021 figurava a empresa Ecologic S.A.S., cujo representante legal, Edgar Mauricio Rodríguez Castro, é também gerente e representante legal da CO2Cero. A Ecologic, criada em 2011 e registrada em Puerto Gaitán, é uma empresa dedicada a promover projetos florestais madeireiros, fundada por Rodríguez Castro (com 75% das ações no momento da fundação) e Federico López Arana (com 25% no momento da fundação), mas que em março de 2019 contava com um total de 27 acionistas, liderados pela empresa Pervivir S.A.S. com 43%, SG-Corp S.A.S. com 14% e Ecosuites S.A.S. com 12%. Rodríguez Castro, representante legal tanto da CO2Cero quanto da Ecologic, é engenheiro industrial com experiência no setor madeireiro, foi um dos fundadores e presidente do conselho diretor da Asocarbono, a associação comercial que reúne os atores do mercado de carbono na Colômbia e do qual a empresa é integrante.',
  },
  {
    id_empresa: '830041970-6',
    id_empresa_carbono: 'COL0011EM',
    nombre_empresa:
      'Conservation International Foundation (Conservación Internacional Colombia)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2290VER'],
    perfil_es:
      'Oficina en Colombia de la organización ambiental internacional Conservación Internacional, fundada en Washington en 1987 y conocida como una de las más grandes del sector ambiental. Su director ejecutivo en Colombia desde hace más de una década es el biólogo marino Fabio Arjona, tras haber sido viceministro del Ministerio de Ambiente y director de la autoridad ambiental regional Corporación Autónoma de los Valles del Sinú y San Jorge (CVS).',
    perfil_en:
      'Office in Colombia of the international environmental organization Conservation International, founded in Washington in 1987 and known as one of the largest in the environmental sector. Its executive director in Colombia for more than a decade has been marine biologist Fabio Arjona, after serving as vice minister of the Ministry of the Environment and director of the regional environmental authority Corporación Autónoma de los Valles del Sinú y San Jorge (CVS).',
    perfil_pt:
      'Escritório na Colômbia da organização ambiental internacional Conservação Internacional, fundada em Washington em 1987 e conhecida como uma das maiores do setor ambiental. Seu diretor executivo na Colômbia há mais de uma década é o biólogo marinho Fabio Arjona, após ter sido vice-ministro do Ministério do Meio Ambiente e diretor da autoridade ambiental regional Corporación Autónoma de los Valles del Sinú y San Jorge (CVS).',
  },
  {
    id_empresa: '901232867-2',
    id_empresa_carbono: 'COL0058EM',
    nombre_empresa: 'Fundación Ecotropics Colombia',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO047CER'],
    perfil_es:
      'Fundación creada en Bogotá en 2018 para promover iniciativas de mitigación y adaptación al cambio climático, incluidos proyectos Redd+. Fue fundada por cinco personas (el ingeniero civil y presidente de la fundación Eric Jussef Cardozo Matta, el ecólogo tropical José Arturo Restrepo Aristizábal, Luz Stella Restrepo Martínez, Antonio Zambrano Delgadillo y Verónica Liliana Uribe Uribe), además de la organización sin ánimo de lucro estadounidense Applied Ecology for Tropical Resources Programs Inc., más conocida como EcoTropics. Restrepo Aristizábal, quien también aparece como fundador de EcoTropics en Estados Unidos, fue director de bosques, biodiversidad y servicios ecosistémicos del Ministerio de Ambiente durante el primer gobierno de Juan Manuel Santos y anteriormente había sido coordinador de sostenibilidad de CCX, la empresa minera de carbón del magnate brasilero Eike Batista.',
    perfil_en:
      'Foundation created in Bogota in 2018 to promote climate change mitigation and adaptation initiatives, including Redd+ projects. It was founded by five people (civil engineer and foundation president Eric Jussef Cardozo Matta, tropical ecologist José Arturo Restrepo Aristizábal, Luz Stella Restrepo Martínez, Antonio Zambrano Delgadillo and Verónica Liliana Uribe Uribe), plus the U.S. nonprofit Applied Ecology for Tropical Resources Programs Inc. better known as EcoTropics. Restrepo Aristizábal, who is also listed as founder of EcoTropics in the United States, was director of forests, biodiversity and ecosystem services at the Ministry of Environment during the first government of Juan Manuel Santos and had previously been sustainability coordinator for CCX, the coal mining company of Brazilian tycoon Eike Batista.',
    perfil_pt:
      'Fundação criada em Bogotá em 2018 para promover iniciativas de mitigação e adaptação às mudanças climáticas, incluindo projetos Redd+. Foi fundada por cinco pessoas (o engenheiro civil e presidente da fundação Eric Jussef Cardozo Matta, o ecologista tropical José Arturo Restrepo Aristizábal, Luz Stella Restrepo Martínez, Antonio Zambrano Delgadillo e Verónica Liliana Uribe Uribe), além da organização sem fins lucrativos norte-americana Applied Ecology for Tropical Resources Programs Inc., mais conhecida como EcoTropics. Restrepo Aristizábal, que também aparece como fundador da EcoTropics nos Estados Unidos, foi diretor de florestas, biodiversidade e serviços ecossistêmicos do Ministério do Meio Ambiente durante o primeiro governo de Juan Manuel Santos e, anteriormente, havia sido coordenador de sustentabilidade da CCX, empresa de mineração de carvão do magnata brasileiro Eike Batista.',
  },
  {
    id_empresa: '900977065-6',
    id_empresa_carbono: 'COL0048EM',
    nombre_empresa: 'Fundación Amé (Fundame.col)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO008BIO'],
    perfil_es:
      'Organización ambiental sin ánimo de lucro fundada en 2016 y cuyo nombre significa árbol en el lenguaje de los indígenas pijao, con el objetivo de hacer paisajismo, silvicultura e investigación. Fue fundada por cinco personas: Pedro Jahaziel Amaya, Alicia Ríos Hurtado, Herman Arias Gaviria, Rafael Vargas Ríos y Rosven Libardo Arévalo. Los últimos dos fueron ex decanos de la facultad de ingeniería forestal de la Universidad del Tolima con la que la Fundación Amé comparte participación en el Proyecto de compensación de emisiones Conservación del Bosque Galilea-Amé en el suroriente del Tolima y Vargas Ríos fue además representante legal de la Fundación. La ONG figura como “entidad proponente y responsable del desarrollo” del proyecto Bosque Galilea-Amé, pero también -según el documento de diseño del proyecto (o PDD)- como administradora de otros 124 predios de terceros en Galilea que forman parte del proyecto, cuya identidad no revela, y co-propietaria con la Universidad del Tolima de otros 14 predios, sin que sea claro en qué proporción son propiedad de cada uno ni por qué existe ese esquema compartido en esa tenencia de la tierra. Como reveló una investigación de CLIP y Rutas del Conflicto publicada en febrero de 2024, una veintena campesinos que han vivido en esa zona del Bosque Galilea desde la década de 1950 dicen haber quedado por fuera del proyecto y sus preguntas motivaron que la Contraloría Departamental del Tolima convocara una audiencia pública en febrero de 2023. La ex representante legal y ex vicepresidenta de Amé, Luz Ángela Palacios Campuzano, ha sido también directiva en otras empresas vinculadas al proyecto en Galilea, como reveló la investigación del CLIP y Rutas del Conflicto: fue representante legal y accionista de Ecocarbono S.A.S. Zomac (encargada de desarrollar los proyectos y actividades de conservación), gerente y miembro suplente de la junta directiva de Grupo Seratta (grupo de restaurantes que fueron los primeres compradores de bonos de carbono del proyecto Galilea) y subgerente e integrante de la junta directiva de El Cielo Construcciones S.A.S. (que representa el fondo fiduciario al que pertenecen los propietarios de 139 predios firmaron acuerdos de conservación con la Fundación Amé). Hasta al menos febrero de 2024, Palacios figuraba públicamente como directora de la fundación, como consta en una entrevista que hizo con el ex ministro Juan Lozano en su programa Mujeres de Ataque en el canal NTN24. Amé es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'Non-profit environmental organization founded in 2016 and whose name means tree in the language of the Pijao indigenous people, with the objective of landscaping, forestry and research. It was founded by five people: Pedro Jahaziel Amaya, Alicia Ríos Hurtado, Herman Arias Gaviria, Rafael Vargas Ríos and Rosven Libardo Arévalo. The last two were former deans of the forestry engineering faculty of the University of Tolima with which the Amé Foundation shares participation in the Emissions Offsetting Project Conservation of the Galilea-Amé Forest in southeastern Tolima and Vargas Ríos was also the legal representative of the Foundation. The NGO is listed as the ""entity proposing and responsible for the development"" of the Galilea-Amé Forest project, but also - according to the project design document (or PDD) - as the administrator of 124 other properties owned by third parties in Galilea that are part of the project, whose identity is not disclosed, and co-owner with the University of Tolima of another 14 properties, without it being clear in what proportion they are owned by each and why there is such a shared land tenure scheme. As revealed in an investigation by CLIP and Rutas del Conflicto published in February 2024, a group of small-scale farmers who have lived in that area of the Galilea Forest since the 1950s claim to have been left out of the project and their questions prompted the Tolima Departmental Comptroller\'s Office to call a public hearing in February 2023. The former legal representative and former vice president of Amé, Luz Ángela Palacios Campuzano, has also been a director in other companies linked to the Galilea project, as revealed by CLIP and Rutas del Conflicto\'s investigation: she was the legal representative and shareholder of Ecocarbono S.A.S. Zomac (in charge of developing the conservation projects and activities), manager and alternate board member of Grupo Seratta (a group of restaurants that were the first buyers of carbon credits from the Galilea project) and assistant manager and board member of El Cielo Construcciones S.A.S. (which represents the trust fund to which the owners of 139 properties signed conservation agreements with the Amé Foundation belong). Until at least February 2024, Palacios was publicly listed as director of the foundation, as stated in an interview she did with former minister Juan Lozano in his program Mujeres de Ataque on NTN24 channel. Amé is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Organização ambiental sem fins lucrativos fundada em 2016 e cujo nome significa árvore na língua dos indígenas pijao, com o objetivo de fazer paisagismo, silvicultura e pesquisa. Foi fundada por cinco pessoas: Pedro Jahaziel Amaya, Alicia Ríos Hurtado, Herman Arias Gaviria, Rafael Vargas Ríos e Rosven Libardo Arévalo. Os dois últimos foram ex-reitores da faculdade de engenharia florestal da Universidade de Tolima, com a qual a Fundação Amé compartilha participação no Projeto de compensação de emissões Conservação da Floresta Galilea-Amé, no sudeste de Tolima, e Vargas Ríos também foi representante legal da Fundação. A ONG figura como “entidade proponente e responsável pelo desenvolvimento” do projeto Bosque Galilea-Amé, mas também – de acordo com o documento de desenho do projeto (ou PDD) – como administradora de outras 124 propriedades de terceiros em Galilea que fazem parte do projeto, cuja identidade não revela, e coproprietária com a Universidade de Tolima de outras 14 propriedades, sem que fique claro em que proporção são propriedade de cada um nem por que existe esse esquema compartilhado na posse da terra. Conforme revelou uma investigação do CLIP e Rutas del Conflicto publicada em fevereiro de 2024, cerca de vinte pequenos agricultores que vivem nessa zona da Floresta Galilea desde a década de 1950 afirmam ter sido excluídos do projeto e suas perguntas motivaram a Contraloria Departamental de Tolima a convocar uma audiência pública em fevereiro de 2023. A ex-representante legal e ex-vice-presidente da Amé, Luz Ángela Palacios Campuzano, também foi diretora de outras empresas ligadas ao projeto em Galilea, conforme revelou a investigação do CLIP e Rutas del Conflicto: ela foi representante legal e acionista da Ecocarbono S.A.S. Zomac (responsável pelo desenvolvimento dos projetos e atividades de conservação), gerente e membro suplente do conselho de administração do Grupo Seratta (grupo de restaurantes que foram os primeiros compradores de créditos de carbono do projeto Galilea) e subgerente e membro do conselho de administração da El Cielo Construcciones S.A.S. (que representa o fundo fiduciário ao qual pertencem os proprietários de 139 terrenos que assinaram acordos de conservação com a Fundação Amé). Até pelo menos fevereiro de 2024, Palacios figurava publicamente como diretora da fundação, conforme consta em uma entrevista que concedeu ao ex-ministro Juan Lozano em seu programa Mujeres de Ataque, no canal NTN24. Amé é membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '860404135-0',
    id_empresa_carbono: 'COL0017EM',
    nombre_empresa: 'Fundación Natura',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1657VER'],
    perfil_es:
      'ONG ambiental colombiana creada en 1984 y muy reconocida en el sector. Gran parte de su trabajo ha girado en torno a realizar estudios de base que soportan la declaratoria o ampliación de áreas protegidas o el establecimiento de sus planes de manejo, en parques nacionales como Utría, Guanentá Alto Río Fonce o Chingaza. Su directora es la bióloga Clara Ligia Solano, que ha trabajado en la fundación desde hace casi dos décadas.',
    perfil_en:
      'Colombian environmental NGO created in 1984 and well known in the sector. Much of its work has revolved around conducting baseline studies that support the declaration or expansion of protected areas or the establishment of their management plans, in national parks such as Utría, Guanentá Alto Río Fonce or Chingaza. Its director is biologist Clara Ligia Solano, who has worked at the foundation for almost two decades.',
    perfil_pt:
      'ONG ambiental colombiana criada em 1984 e muito reconhecida no setor. Grande parte do seu trabalho tem se concentrado na realização de estudos básicos que apoiam a declaração ou ampliação de áreas protegidas ou o estabelecimento de seus planos de manejo, em parques nacionais como Utría, Guanentá Alto Río Fonce ou Chingaza. Sua diretora é a bióloga Clara Ligia Solano, que trabalha na fundação há quase duas décadas.',
  },
  {
    id_empresa: '830077866-3',
    id_empresa_carbono: 'COL0012EM',
    nombre_empresa: 'Fondo para la Acción Ambiental y la Niñez (Fondo Acción)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO103BIO',
      'CO1389VER',
      'CO1390VER',
      'CO1391VER',
      'CO1392VER',
      'CO1395VER',
      'CO1396VER',
      'CO1399VER',
      'CO1400VER',
      'CO1806VER',
    ],
    perfil_es:
      'ONG ambiental colombiana, formalmente llamada Fondo para la Acción Ambiental y la Niñez y más comúnmente conocida como Fondo Acción. Creada en 2000 para administrar el primer canje de deuda por conservación de Colombia, firmado con el gobierno de Estados Unidos. Fue la primera organización colombiana en ser acreditada ante el Fondo Verde del Clima de la Convención Marco de Naciones Unidas sobre Cambio Climático (CMNUCC). Figura como co-proponente, en tanto responsable de la formulación y gestión administrativa, del portafolio BioREDD+, un grupo de 8 proyectos REDD+ que fueron estructurados en la región del Pacífico con una donación de 2,2 millones de dólares del programa Páramos y Bosques de USAID, y también participa en otros dos más. Lo dirige la bióloga Natalia Arango Vélez, quien lleva 15 años en Fondo Acción y trabajó anteriormente en el Instituto Humboldt estatal y en la ONG ambiental The Nature Conservancy.',
    perfil_en:
      "Colombian environmental NGO, formally called Fondo para la Acción Ambiental y la Niñez and more commonly known as Fondo Acción. Created in 2000 to administer Colombia's first conservation debt swap, signed with the U.S. government. It was the first Colombian organization to be accredited to the Green Climate Fund of the United Nations Framework Convention on Climate Change (UNFCCC). It is a co-proponent, in charge of the formulation and administrative management, of the BioREDD+ portfolio, a group of 8 REDD+ projects that were structured in the Pacific region with a grant of US$2.2 million from USAID's Páramos y Bosques program, and also participates in two others. It is directed by biologist Natalia Arango Vélez, who has been with Fondo Acción for 15 years and previously worked at the state-run Humboldt Institute and the environmental NGO The Nature Conservancy.",
    perfil_pt:
      'ONG ambiental colombiana, formalmente chamada de Fundo para a Ação Ambiental e a Infância e mais comumente conhecida como Fundo Ação. Criada em 2000 para administrar a primeira troca de dívida por conservação da Colômbia, assinada com o governo dos Estados Unidos. Foi a primeira organização colombiana a ser credenciada junto ao Fundo Verde para o Clima da Convenção-Quadro das Nações Unidas sobre Mudanças Climáticas (CMNUCC). É co-proponente, responsável pela formulação e gestão administrativa, do portfólio BioREDD+, um grupo de 8 projetos REDD+ que foram estruturados na região do Pacífico com uma doação de 2,2 milhões de dólares do programa Páramos y Bosques da USAID, e também participa em outros dois. É dirigida pela bióloga Natalia Arango Vélez, que está há 15 anos no Fondo Acción e trabalhou anteriormente no Instituto Humboldt estatal e na ONG ambiental The Nature Conservancy.',
  },
  {
    id_empresa: '900480115-1',
    id_empresa_carbono: 'COL0036EM',
    nombre_empresa: 'South Pole Carbon Asset Management S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO009BIO',
      'CO031NA',
      'CO035NA',
      'CO049BIO',
      'CO1657VER',
      'CO1695VER',
      'CO2290VER',
      'CO2297VER',
      'CO2317VER',
      'CO2392VER',
      'PE1882VER',
      'BR2566VER'
    ],
    perfil_es:
      'Empresa creada en 2011 en Colombia que a junio de 2024 era propiedad en un 100% de la empresa suiza South Pole Holding AG. Fue fundada y liderada desde 2006 por un grupo de emprendedores suizos que incluyen a su ex director ejecutivo de proyectos globales Christian Danneker (quien figuró como representante legal en Colombia), a su integrante de junta directiva Patrick Bürgi (quien aparecía a junio de 2024 como representante de South Pole Holding AG en actas de South Pole en Colombia) y su antiguo presidente Renat Heuberger y su miembro de junta Christoph Grobbel (que figuraron en el pasado como representantes de South Pole Holding AG en actas de South Pole en Colombia). La directora de proyectos climáticos de South Pole en la región y cara visible es Carolina Jaramillo Aguirrezábal, quien anteriormente fue representante en Colombia del Instituto Global para el Crecimiento Verde (GGGI) intergubernamental y trabajó en el Banco Interamericano de Desarrollo (BID). Dos proyectos en los que ha participado South Pole en América Latina han tenido problemas documentados por esta alianza periodística. En Colombia, una investigación de CLIP y Rutas del Conflicto publicada en febrero de 2024 reveló que el proyecto Bosque de Galilea desarrollado por la Fundación Amé y en cuya formulación participó South Pole alberga un agudo conflicto socio ambiental, con una veintena de campesinos que viven en esa zona forestal en Tolima argumentando haber quedado por fuera del proyecto (del que la empresa suiza dice haberse retirado en 2021 por diferencias de gestión con los otros participantes). Otra investigación de Contracorriente mostró que otro proyecto en los manglares de la Moskitia en Honduras propuesto por la oenegé española Ayuda en Acción y diseñado por South Pole ha sido denunciado por una fracción de la máxima organización de los indígenas miskita que denuncia no haber sido consultada y también despertó preocupaciones en la certificadora estadounidense Verra, que le ha negado hasta ahora la aprobación por dudas sobre la consulta a las comunidades locales y la validez de otros datos contenidos en sus documentos. ',
    perfil_en:
      "Company created in 2011 in Colombia that as of June 2024 was 100% owned by the Swiss company South Pole Holding AG. It was founded and led since 2006 by a group of Swiss entrepreneurs including its former executive director of global projects Christian Danneker (who was listed as legal representative in Colombia), its board member Patrick Bürgi (who was listed as of June 2024 as representative of South Pole Holding AG in South Pole's minutes in Colombia) and its former chairman Renat Heuberger and board member Christoph Grobbel (who were listed in the past as representatives of South Pole Holding AG in South Pole's minutes in Colombia). South Pole's climate project manager in the region and visible face is Carolina Jaramillo Aguirrezábal, who was previously the Colombia representative of the intergovernmental Global Green Growth Institute (GGGI) and worked at the Inter-American Development Bank (IDB). Two projects in which South Pole has been involved in Latin America have had problems documented by this journalistic alliance. In Colombia, an investigation by CLIP and Rutas del Conflicto published in February 2024 revealed that the Bosque de Galilea project developed by the Amé Foundation and in whose formulation South Pole participated harbors an acute socio-environmental conflict, with a group of small-scale farmers living in that forested area in Tolima arguing that they have been left out of the project (from which the Swiss company claims to have withdrawn in 2021 due to management differences with the other participants). Another Contracorriente investigation showed that another project in the Moskitia mangroves in Honduras proposed by the Spanish NGO Ayuda en Acción and designed by South Pole has been denounced by a fraction of the highest Miskito indigenous organization that claims not to have been consulted and also raised concerns in the US certifier Verra, which has so far denied approval due to doubts about the consultation with local communities and the validity of other data contained in its documents.",
    perfil_pt:
      'Empresa criada em 2011 na Colômbia que, em junho de 2024, era 100% propriedade da empresa suíça South Pole Holding AG. Foi fundada e liderada desde 2006 por um grupo de empreendedores suíços que inclui seu ex-diretor executivo de projetos globais, Christian Danneker (que atuou como representante legal na Colômbia), o membro do conselho de administração Patrick Bürgi (que em junho de 2024 figurava como representante da South Pole Holding AG nas atas da South Pole na Colômbia) e seu ex-presidente Renat Heuberger e o membro do conselho Christoph Grobbel (que no passado figuravam como representantes da South Pole Holding AG nas atas da South Pole na Colômbia). A diretora de projetos climáticos da South Pole na região e rosto visível da empresa é Carolina Jaramillo Aguirrezábal, que anteriormente foi representante na Colômbia do Instituto Global para o Crescimento Verde (GGGI) intergovernamental e trabalhou no Banco Interamericano de Desenvolvimento (BID). Dois projetos em que a South Pole participou na América Latina tiveram problemas documentados por esta aliança jornalística. Na Colômbia, uma investigação da CLIP e da Rutas del Conflicto publicada em fevereiro de 2024 revelou que o projeto Bosque de Galilea, desenvolvido pela Fundação Amé e na formulação do qual a South Pole participou, abriga um grave conflito socioambiental, com cerca de vinte pequenos agricultores que vivem nessa zona florestal em Tolima alegando terem sido excluídos do projeto (do qual a empresa suíça afirma ter se retirado em 2021 por diferenças de gestão com os outros participantes). Outra investigação da Contracorriente mostrou que outro projeto nos manguezais da Moskitia, em Honduras, proposto pela ONG espanhola Ayuda en Acción e projetado pela South Pole, foi denunciado por uma fração da principal organização dos indígenas miskita, que alega não ter sido consultada, e também despertou preocupações na certificadora norte-americana Verra, que até agora negou a aprovação devido a dúvidas sobre a consulta às comunidades locais e a validade de outros dados contidos em seus documentos.',
  },
  {
    id_empresa: '811043476-9',
    id_empresa_carbono: 'COL0008EM',
    nombre_empresa:
      'Corporación para el Manejo Sostenible de los Bosques Masbosques',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO028CER',
      'CO052CER',
      'CO053CER',
      'CO055CER',
      'CO056CER',
      'CO065CER',
      'CO100CER',
      'CO118CER',
      'CO155CER',
    ],
    perfil_es:
      'Entidad sin ánimo de lucro creada en 2003 para ejecutar un proyecto de conservación en los bosques del Valle de San Nicolás en el oriente de Antioquia, pero que en años recientes ha ampliado su portafolio de pago por servicios ambientales a buena parte del país y de proyectos del mercado de carbono a la Amazonia. En un inicio su vocación fue netamente local, juntando a actores públicos y privados de la subregión al oriente de Medellín con la idea de que su proyecto forestal vendiera certificados de captura de dióxido de carbono, según dictaba el Mecanismo de Desarrollo Limpio del protocolo de Kioto, el acuerdo climático que antecedió al hoy vigente de París. Cornare, la autoridad ambiental local, aportó 36 millones de pesos (unos 12 700 dólares de la época) para su fundación y siempre ha ocupado un asiento en su junta directiva. A agosto de 2023 contaba con 20 socios, incluyendo a Cornare, nueve alcaldías (El Carmen de Viboral, El Retiro, El Santuario, Guarne, La Ceja, La Unión, Marinilla, Rionegro y San Vicente), la asociación de municipios de la subregión Masora, privados como el gremio floricultor Asocolflores y la Corporación Empresarial del Oriente, educativas como la Universidad Católica de Oriente y CEAM y comunitarias como las asociaciones de juntas de acción comunal (Asocomunal) de Rionegro, Marinilla, El Retiro y San Vicente. En 2013 lanzó BanCO2, un esquema de pago por servicios ambientales en el que empresas como Bancolombia financian a familias campesinas que cuidan bosques y neutralizan así su huella de carbono. Esa iniciativa pronto se convirtió en su proyecto bandera, que extendió a una veintena de departamentos y que Cornare incluso promovió en Perú. Ha sido tan bien recibida que ya han lanzado tres líneas adicionales del esquema, llamadas Bio, Plus y Agua. Llegó en 2015 a la Amazonia, donde ha impulsado al menos siete proyectos Redd+. Al menos dos proyectos de Masbosques han tenido problemas: la Corte Constitucional determinó que el proyecto Baka Rokarire en el Pirá Paraná en Vaupés vulneró los derechos fundamentales de los indígenas, puesto que sus desarrolladores ""no obtuvieron el consentimiento libre, previo e informado mediante un diálogo genuino y de buena fe"", después de que la propuesta nunca fue llevada a la máxima instancia de gobierno interno del territorio y que quien suscribió el contrato era un líder que ya no era representante legal en el momento de la firma, según reveló una investigación del CLIP y aliados publicada en 2022. Masbosques argumentó que acordó el proyecto con las legítimas autoridades del territorio reconocidas por el Gobierno nacional y que siempre actuó “conforme a la realidad jurídica del momento”, con varias de las comunidades del Pirá Paraná respaldando su iniciativa, lo que subraya la fuerte fractura social allí. Sobre Masbosques, la Corte Constitucional dijo que “una organización con presencia permanente en la Amazonia tendría o se inferiría debería tener algún conocimiento sobre pretensiones de las comunidades asociadas al funcionamiento de territorios indígenas”. Otro proyecto, Jocu Bucuro Apuro, incluyó -según otra investigación del CLIP de 2023- un resguardo indígena que ya había sido incluido dentro de otro proyecto activo y que había vendido bonos, en lo que pudo constituir un caso de doble contabilidad. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia. ',
    perfil_en:
      'A non-profit organization created in 2003 to implement a conservation project in the forests of the San Nicolas Valley in eastern Antioquia, but in recent years has expanded its portfolio of payment for environmental services to much of the country and carbon market projects in the Amazon. In the beginning its vocation was purely local, bringing together public and private actors from the subregion east of Medellín with the idea that its forestry project would sell carbon dioxide capture certificates, as dictated by the Clean Development Mechanism of the Kyoto Protocol, the climate agreement that preceded the current Paris agreement. Cornare, the local environmental authority, contributed 36 million pesos (about US$12,700 at the time) to its foundation and has always had a seat on its board of directors. As of August 2023, it had 20 members, including Cornare, nine municipalities (El Carmen de Viboral, El Retiro, El Santuario, Guarne, La Ceja, La Unión, Marinilla, Rionegro and San Vicente), the association of municipalities in the Masora subregion, and private individuals such as the floriculture association, private companies such as the floriculture association Asocolflores and the Corporación Empresarial del Oriente, educational institutions such as the Universidad Católica de Oriente and CEAM, and community organizations such as the associations of community action boards (Asocomunal) of Rionegro, Marinilla, El Retiro and San Vicente. In 2013 he launched BanCO2, a payment for environmental services scheme in which companies such as Bancolombia finance peasant families that take care of forests and thus neutralize their carbon footprint. That initiative soon became its flagship project, which it extended to some twenty departments and which Cornare even promoted in Peru. It has been so well received that they have already launched three additional lines of the scheme, called Bio, Plus and Agua. It arrived in 2015 in the Amazon, where it has promoted at least seven Redd+ projects. At least two Masbosques projects have run into trouble: the Constitutional Court ruled that the Baka Rokarire project in the Pirá Paraná in Vaupés violated the fundamental rights of the indigenous people, since its developers ""did not obtain free, prior and informed consent through genuine dialogue and in good faith,"" after the proposal was never taken to the highest instance of internal governance of the territory and the person who signed the contract was a leader who was no longer a legal representative at the time of signing, as revealed by a CLIP and Allies investigation published in 2022. Masbosques argued that it agreed the project with the legitimate authorities of the territory recognized by the national government and that it always acted ""according to the legal reality of the moment"", with several of the Pirá Paraná communities backing its initiative, which underlines the strong social fracture there. Regarding Masbosques, the Constitutional Court said that ""an organization with a permanent presence in the Amazon would have or would be inferred to have some knowledge of the communities\' claims associated with the operation of indigenous territories"". Another project, Jocu Bucuro Apuro, included - according to another CLIP investigation in 2023 - an indigenous reservation that had already been included within another active project and had sold credits, in what may have constituted a case of double counting. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Entidade sem fins lucrativos criada em 2003 para executar um projeto de conservação nas florestas do Vale de San Nicolás, no leste de Antioquia, mas que nos últimos anos ampliou seu portfólio de pagamento por serviços ambientais para boa parte do país e de projetos do mercado de carbono para a Amazônia. No início, sua vocação era puramente local, reunindo atores públicos e privados da sub-região a leste de Medellín com a ideia de que seu projeto florestal vendesse certificados de captura de dióxido de carbono, de acordo com o Mecanismo de Desenvolvimento Limpo do Protocolo de Quioto, o acordo climático que antecedeu o atual Acordo de Paris. A Cornare, autoridade ambiental local, contribuiu com 36 milhões de pesos (cerca de US$ 12.700 na época) para sua fundação e sempre ocupou um assento em seu conselho diretor. Em agosto de 2023, contava com 20 membros, incluindo a Cornare, nove prefeituras (El Carmen de Viboral, El Retiro, El Santuario, Guarne, La Ceja, La Unión, Marinilla, Rionegro e San Vicente), a associação de municípios da sub-região Masora, entidades privadas como o sindicato de floricultores Asocolflores e a Corporação Empresarial do Oriente, instituições educacionais como a Universidade Católica do Oriente e CEAM e comunitárias como as associações de juntas de ação comunitária (Asocomunal) de Rionegro, Marinilla, El Retiro e San Vicente. Em 2013, lançou o BanCO2, um esquema de pagamento por serviços ambientais no qual empresas como o Bancolombia financiam famílias camponesas que cuidam de florestas e neutralizam assim sua pegada de carbono. Essa iniciativa logo se tornou seu projeto emblemático, que se estendeu a cerca de vinte departamentos e que a Cornare chegou a promover no Peru. Foi tão bem recebida que já foram lançadas três linhas adicionais do esquema, chamadas Bio, Plus e Água. Chegou em 2015 à Amazônia, onde impulsionou pelo menos sete projetos Redd+. Pelo menos dois projetos da Masbosques tiveram problemas: a Corte Constitucional determinou que o projeto Baka Rokarire, no Pirá Paraná, em Vaupés, violou os direitos fundamentais dos indígenas, uma vez que seus desenvolvedores “não obtiveram o consentimento livre, prévio e informado por meio de um diálogo genuíno e de boa fé”, depois que a proposta nunca foi levada à instância máxima do governo interno do território e que quem assinou o contrato era um líder que já não era representante legal no momento da assinatura, conforme revelou uma investigação do CLIP e aliados publicada em 2022. A Masbosques argumentou que acordou o projeto com as autoridades legítimas do território reconhecidas pelo governo nacional e que sempre agiu “de acordo com a realidade jurídica do momento”, com várias das comunidades do Pirá Paraná apoiando sua iniciativa, o que ressalta a forte fratura social na região. Sobre a Masbosques, o Tribunal Constitucional afirmou que “uma organização com presença permanente na Amazônia teria ou se inferiria que deveria ter algum conhecimento sobre as pretensões das comunidades associadas ao funcionamento dos territórios indígenas”. Outro projeto, Jocu Bucuro Apuro, incluía – segundo outra investigação do CLIP de 2023 – uma terra indígena que já havia sido incluída em outro projeto ativo e que havia vendido créditos, no que poderia ter constituído um caso de dupla contabilidade. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '805017493-2',
    id_empresa_carbono: 'COL0006EM',
    nombre_empresa: 'Mediamos F & M S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1566VER'],
    perfil_es:
      "Empresa constituida en Cali en 1999 y liderada por Francisco Quiroga Zea, un ingeniero forestal que fue vicerrector de la Universidad del Valle. A mayo de 2023, contaba con dos accionistas: su director Francisco Quiroga Zea y su coordinadora administrativa Mónica Barragán Salas, cada uno con 50% de las acciones, según actas de cámara de comercio. Una investigación periodística de CLIP y un informe de la organización europea Carbon Market Watch que monitorea los mercados de carbono mostraron en 2021 que el proyecto pudo haber usado una tasa de deforestación proyectada cinco veces mayor a la que Colombia estableció para la Amazonia y que la Convención Marco de Naciones Unidas sobre el Cambio Climático (CMNUCC) aprobó, sugiriendo un riesgo de tala aún mayor al de la realidad y posiblemente permitiéndole vender un número más alto de bonos, algo que en el sector de carbono suele llamarse 'aire caliente'. Mediamos ha defendido su línea base y señala que la tasa de deforestación es más alta porque refleja la amenaza de deforestación que viene creciendo desde Meta y Guaviare en dirección hacia Matavén. Su proyecto de Matavén es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.",
    perfil_en:
      "The company was incorporated in Cali in 1999 and led by Francisco Quiroga Zea, a forestry engineer and former vice-rector of the Universidad del Valle. As of May 2023, it had two shareholders: its director Francisco Quiroga Zea and its administrative coordinator Mónica Barragán Salas, each with 50% of the shares, according to chamber of commerce records. A CLIP journalistic investigation and a report by the European organization Carbon Market Watch that monitors carbon markets showed in 2021 that the project may have used a projected deforestation rate five times higher than the rate Colombia established for the Amazon and that the United Nations Framework Convention on Climate Change (UNFCCC) approved, suggesting an even higher logging risk than in reality and possibly allowing it to sell a higher number of credits, something often referred to in the carbon sector as 'hot air'. Mediamos has defended its baseline and points out that the deforestation rate is higher because it reflects the threat of deforestation growing from Meta and Guaviare towards Matavén. Its Matavén project is a member of Asocarbono, the guild of carbon market actors in Colombia.",
    perfil_pt:
      'Empresa constituída em Cali em 1999 e liderada por Francisco Quiroga Zea, engenheiro florestal que foi vice-reitor da Universidade do Vale. Em maio de 2023, contava com dois acionistas: seu diretor Francisco Quiroga Zea e sua coordenadora administrativa Mónica Barragán Salas, cada um com 50% das ações, de acordo com as atas da Câmara de Comércio. Uma investigação jornalística do CLIP e um relatório da organização europeia Carbon Market Watch, que monitora os mercados de carbono, mostraram em 2021 que o projeto pode ter usado uma taxa de desmatamento projetada cinco vezes maior do que a estabelecida pela Colômbia para a Amazônia e que a Convenção-Quadro das Nações Unidas sobre Mudanças Climáticas (CMNUCC) aprovou, sugerindo um risco de desmatamento ainda maior do que o real e possivelmente permitindo a venda de um número maior de créditos, algo que no setor de carbono costuma ser chamado de ""ar quente"". A Mediamos defendeu sua linha de base e aponta que a taxa de desmatamento é mais alta porque reflete a ameaça de desmatamento que vem crescendo desde Meta e Guaviare em direção a Matavén. Seu projeto em Matavén é parte integrante da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '900361312-6',
    id_empresa_carbono: 'COL0035EM',
    nombre_empresa: 'Permian Colombia S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO009NA',
      'CO010NA',
      'CO011NA',
      'CO012NA',
      'CO013NA',
      'CO014NA',
    ],
    perfil_es:
      'Empresa creada en 2010 en Bogotá, como filial colombiana de la empresa británica Permian Global, que describe su misión como ""canalizar financiación del carbono del sector privado hacia proyectos que protejan bosques tropicales amenazados"". Fundada por el empresario y financista británico Stephen Rumsey en 2007, Permian Global tiene proyectos en Brasil, Perú e Indonesia (como el proyecto Redd+ Katingan Mentaya en Borneo). A marzo de 2024, Permian Colombia era tenía dos accionistas: la empresa luxemburguesa Permian Global Holdings S.A.R.L. (con el 85% de las acciones) y la empresa británica Permian Global Research Limited (con el 15% de las acciones, pero que años atrás había tenido el 100% de éstas). Permian Global Research Limited era controlada a agosto de 2024, según el registro mercantil del Reino Unido (Companies House), por la empresa británica Permian Nominees Limited, donde a su vez figura Stephen Rumsey como persona con control significativo (más del 75%) de sus acciones y derechos de voto. En Colombia, Permian Colombia opera actualmente la Reserva Guayabero Cocodrilo, en inmediaciones del Parque Nacional Serranía de la Macarena, y aparecía en la plataforma gubernamental de iniciativas de mitigación con 6 proyectos Redd+ en esa misma zona entre los parques nacionales de Tinigua y Serranía de la Macarena al norte y Chiribiquete al sur, pero ninguno figura en plataformas de certificación como en curso. Su gerente y representante legal es el británico Edward William Rumsey, quien figura como socio director (""managing partner"") de Permian Globan, mientras su director en Colombia y representante legal suplente es Efraín Eduardo Peña Moreno, un abogado ambiental que trabajó en la Unión Internacional para la Conservación de la Naturaleza (UICN). Hay otra empresa de nombre similar, Permian Global Colombia S.A.S., con Peña Moreno de gerente y representante legal, Edward Rumsey y Gerry Elias (también socio directivo de Permian Global) de representantes legales suplentes. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'The company was created in 2010 in Bogota as the Colombian subsidiary of the British company Permian Global, which describes its mission as ""channeling private sector carbon finance to projects that protect threatened tropical forests"". Founded by British entrepreneur and financier Stephen Rumsey in 2007, Permian Global has projects in Brazil, Peru and Indonesia (such as the Redd+ Katingan Mentaya project in Borneo). As of March 2024, Permian Colombia had two shareholders: the Luxembourg company Permian Global Holdings S.A.R.L. (with 85% of the shares) and the British company Permian Global Research Limited (with 15% of the shares, but which years ago had held 100% of the shares). Permian Global Research Limited was controlled as of August 2024, according to the UK Companies House, by the British company Permian Nominees Limited, where Stephen Rumsey is listed as a person with significant control (more than 75%) of its shares and voting rights. In Colombia, Permian Colombia currently operates the Guayabero Cocodrilo Reserve, in the vicinity of the Serrania de la Macarena National Park, and was listed on the government\'s mitigation initiative platform with 6 Redd+ projects in the same area between the Tinigua and Serrania de la Macarena National Parks to the north and Chiribiquete to the south, but none are listed on certification platforms as ongoing. Its manager and legal representative is the British Edward William Rumsey, who is listed as managing partner of Permian Globan, while its director in Colombia and alternate legal representative is Efraín Eduardo Peña Moreno, an environmental lawyer who worked at the International Union for Conservation of Nature (IUCN). There is another company with a similar name, Permian Global Colombia S.A.S., with Peña Moreno as manager and legal representative, and Edward Rumsey and Gerry Elias (also a managing partner of Permian Global) as alternate legal representatives. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Empresa criada em 2010 em Bogotá, como filial colombiana da empresa britânica Permian Global, que descreve sua missão como “canalizar financiamento de carbono do setor privado para projetos que protejam florestas tropicais ameaçadas”. Fundada pelo empresário e financista britânico Stephen Rumsey em 2007, a Permian Global tem projetos no Brasil, Peru e Indonésia (como o projeto Redd+ Katingan Mentaya em Bornéu). Em março de 2024, a Permian Colombia tinha dois acionistas: a empresa luxemburguesa Permian Global Holdings S.A.R.L. (com 85% das ações) e a empresa britânica Permian Global Research Limited (com 15% das ações, mas que anos atrás detinha 100% delas). A Permian Global Research Limited era controlada em agosto de 2024, de acordo com o registro comercial do Reino Unido (Companies House), pela empresa britânica Permian Nominees Limited, onde Stephen Rumsey figura como pessoa com controle significativo (mais de 75%) de suas ações e direitos de voto. Na Colômbia, a Permian Colombia opera atualmente a Reserva Guayabero Cocodrilo, nas proximidades do Parque Nacional Serranía de la Macarena, e aparecia na plataforma governamental de iniciativas de mitigação com seis projetos Redd+ na mesma zona, entre os parques nacionais de Tinigua e Serranía de la Macarena, ao norte, e Chiribiquete, ao sul, mas nenhum deles figura em plataformas de certificação como em andamento. Seu gerente e representante legal é o britânico Edward William Rumsey, que figura como sócio diretor (“managing partner”) da Permian Globan, enquanto seu diretor na Colômbia e representante legal substituto é Efraín Eduardo Peña Moreno, um advogado ambiental que trabalhou na União Internacional para a Conservação da Natureza (UICN). Há outra empresa com nome semelhante, Permian Global Colombia S.A.S., com Peña Moreno como gerente e representante legal, Edward Rumsey e Gerry Elias (também sócio diretor da Permian Global) como representantes legais suplentes. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '900821114-9',
    id_empresa_carbono: 'COL0044EM',
    nombre_empresa: 'Saving the Amazon',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO029NA'],
    perfil_es:
      'Organización sin ánimo de lucro creada en 2015, cuyo objeto es ""combatir la crisis climática, la conservación de la Amazonia, sembrar y cuidar árboles con las comunidades de la selva húmeda tropical para que superen la pobreza multidimensional, defensa de la biodiversidad y apoyo a las comunidades indígenas"" y cuya página web ofrece la siembra de árboles a cambio de donaciones. A octubre de 2022 contaba con tres fundadores, que son descritos en actas de la fundación como ""miembros hábiles"": Daniel Gutiérrez Patiño, María Jimena Patiño Ocampo y Camilo Gutiérrez Patiño. Su cabeza visible han sido el psicólogo y gestor ambiental Daniel Gutiérrez Patiño, también fundador de Shambala Comunidades Ambientales, y su madre, la psicóloga María Jimena Patiño. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'Non-profit organization created in 2015, whose purpose is ""to combat the climate crisis, conservation of the Amazon, planting and caring for trees with rainforest communities to overcome multidimensional poverty, defense of biodiversity and support for indigenous communities"" and whose website offers tree planting in exchange for donations. As of October 2022 it had three founders, who are described in the foundation\'s minutes as ""active members"": Daniel Gutiérrez Patiño, María Jimena Patiño Ocampo and Camilo Gutiérrez Patiño. Its visible head has been the psychologist and environmental manager Daniel Gutiérrez Patiño, also founder of Shambala Comunidades Ambientales, and his mother, psychologist María Jimena Patiño. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Organização sem fins lucrativos criada em 2015, cujo objetivo é “combater a crise climática, conservar a Amazônia, plantar e cuidar de árvores com as comunidades da floresta tropical úmida para que superem a pobreza multidimensional, defender a biodiversidade e apoiar as comunidades indígenas” e cujo site oferece o plantio de árvores em troca de doações. Em outubro de 2022, contava com três fundadores, descritos nas atas da fundação como ""membros habilitados"": Daniel Gutiérrez Patiño, María Jimena Patiño Ocampo e Camilo Gutiérrez Patiño”. Seus líderes visíveis têm sido o psicólogo e gestor ambiental Daniel Gutiérrez Patiño, também fundador da Shambala Comunidades Ambientales, e sua mãe, a psicóloga María Jimena Patiño. Ele é membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '900241092-6',
    id_empresa_carbono: 'COL0031EM',
    nombre_empresa: 'Terra Commodities S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO019BIO',
      'CO020BIO',
      'CO024BIO',
      'CO031BIO',
      'CO035BIO',
      'CO060BIO',
      'CO061BIO',
      'CO099CER',
      'CO2723VER',
      'BR4761VER',
      'PE001NA',
      'PE5077VER',
      'PER4773VER',
    ],
    perfil_es:
      'Empresa creada en 2008, anteriormente conocida como Terra Commodities Ltda. A abril de 2022, contaba con tres accionistas: Federico José Ortiz Mejía (con 35% de las acciones), Catherine Bridget Cushnan (con 15% de las acciones) y la empresa panameña Terra Commodities S.A. (con 50% de las acciones). Su cabeza visible es el economista Federico José Ortiz Mejía, que aparece como director de Terra Commodities S.A. Forma parte de la alianza Community Redd con otras tres empresas, cada una encargándose de una tarea distinta en sus proyectos del mercado voluntario de carbono: Carbo Sostenible S.A.S. formula los documentos técnicos, Terra Commodities comercializa los bonos, Visso Consultores S.A.S. se ocupa de la parte financiera y Yauto de la social. Terra Commodities aparece vinculada a al menos 9 proyectos Redd+ en Colombia, más proyectos en formulación en Brasil y Perú. En dos de sus proyectos, esta alianza periodística ha documentado problemas. Por un lado, CLIP encontró que dos comunidades de las seis que históricamente han formado parte del resguardo de Monochoa y su zona de vigilancia y control, llamadas Aménani y Monochoa, fueron inicialmente excluidas de los proyectos (Monochoa y CRIMA Predio Putumayo) llevados a cabo allí mientras su territorio sí era incluido (situación que fue corregida posterior a la publicación). Por otro lado, Infoamazonia encontró que la alianza Community Redd+ intentó impulsar proyectos en el Alto Solimões, en Brasil, a pesar de las recomendaciones contrarias del órgano indigenista estatal Funai. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      "Company created in 2008, formerly known as Terra Commodities Ltda. As of April 2022, it had three shareholders: Federico José Ortiz Mejía (with 35% of the shares), Catherine Bridget Cushnan (with 15% of the shares) and the Panamanian company Terra Commodities S.A. (with 50% of the shares). Its visible head is the economist Federico José Ortiz Mejía, who appears as director of Terra Commodities S.A. It is part of the Community Redd alliance with three other companies, each one in charge of a different task in its voluntary carbon market projects: Carbo Sostenible S.A.S. formulates the technical documents, Terra Commodities commercializes the credits, Visso Consultores S.A.S. is in charge of the financial part and Yauto is in charge of the social part. Terra Commodities is involved in at least 9 Redd+ projects in Colombia, plus projects under formulation in Brazil and Peru. In two of its projects, this journalistic alliance has documented problems. On the one hand, CLIP found that two of the six communities that have historically formed part of the Monochoa reservation and its surveillance and control zone, called Aménani and Monochoa, were initially excluded from the projects (Monochoa and CRIMA Predio Putumayo) carried out there while their territory was included (a situation that was corrected after publication). On the other hand, Infoamazonia found that the Community Redd+ alliance tried to promote projects in Alto Solimões, in Brazil, despite recommendations to the contrary from the state indigenous organization Funai. It is a member of Asocarbono, the Colombian carbon market actors' guild.",
    perfil_pt:
      'Empresa criada em 2008, anteriormente conhecida como Terra Commodities Ltda. Em abril de 2022, contava com três acionistas: Federico José Ortiz Mejía (com 35% das ações), Catherine Bridget Cushnan (com 15% das ações) e a empresa panamenha Terra Commodities S.A. (com 50% das ações). Seu representante é o economista Federico José Ortiz Mejía, que aparece como diretor da Terra Commodities S.A. Faz parte da aliança Community Redd com outras três empresas, cada uma responsável por uma tarefa diferente em seus projetos do mercado voluntário de carbono: a Carbo Sostenible S.A.S. formula os documentos técnicos, a Terra Commodities comercializa os créditos, a Visso Consultores S.A.S. cuida da parte financeira e a Yauto da parte social. A Terra Commodities aparece vinculada a pelo menos nove projetos Redd+ na Colômbia, além de outros projetos em fase de formulação no Brasil e no Peru. Em dois de seus projetos, esta aliança jornalística documentou problemas. Por um lado, o CLIP descobriu que duas das seis comunidades que historicamente fazem parte da terra indígena de Monochoa e sua zona de vigilância e controle, chamadas Aménani e Monochoa, foram inicialmente excluídas dos projetos (Monochoa e CRIMA Predio Putumayo) realizados lá, enquanto seu território foi incluído (situação que foi corrigida após a publicação). Por outro lado, a Infoamazonia descobriu que a aliança Community Redd+ tentou impulsionar projetos no Alto Solimões, no Brasil, apesar das recomendações contrárias do órgão indigenista estatal Funai. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '200615210062',
    id_empresa_carbono: 'COL0001EM',
    nombre_empresa: 'Terra Global Capital, LLC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2071VER', 'CO2298VER'],
    perfil_es:
      'Empresa fundada en 2006 y basada en California que se describe a sí misma como ""una empresa social con ánimo de lucro dirigida por mujeres"". Fue fundada por Leslie Durschinger, una contadora y administradora de empresas que venía de trabajar en el sector financiero. Tiene proyectos en 5 otros países, incluyendo en Asia, África y Centroamérica y dos en fase de formulación en Colombia. Participó también con metodologías de percepción remota en la estructuración de 8 proyectos REDD+ en la región del Pacífico con una donación de 2,2 millones de dólares del programa Páramos y Bosques de USAID y con la ong ambiental Fondo Acción como responsable de su formulación y gestión administrativa. Su subsidiaria Terra Global Investment Management LLC (TGIM) aparece mencionada también en varios de los documentos del proyecto. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'A California-based company founded in 2006 that describes itself as ""a for-profit social enterprise run by women"". It was founded by Leslie Durschinger, an accountant and business administrator who came from working in the financial sector. It has projects in 5 other countries, including Asia, Africa and Central America and two in the formulation phase in Colombia. The company also participated with remote sensing methodologies in the structuring of 8 REDD+ projects in the Pacific region with a donation of 2.2 million dollars from USAID\'s Páramos y Bosques program and with the environmental NGO Fondo Acción as responsible for their formulation and administrative management. Its subsidiary Terra Global Investment Management LLC (TGIM) is also mentioned in several of the project documents. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Empresa fundada em 2006 e sediada na Califórnia que se descreve como “uma empresa social com fins lucrativos dirigida por mulheres”. Foi fundada por Leslie Durschinger, uma contadora e administradora de empresas que trabalhava no setor financeiro. Tem projetos em cinco outros países, incluindo Ásia, África e América Central, e dois em fase de formulação na Colômbia. Também participou com metodologias de percepção remota na estruturação de oito projetos REDD+ na região do Pacífico, com uma doação de US$ 2,2 milhões do programa Páramos y Bosques da USAID e com a ONG ambiental Fondo Acción como responsável pela sua formulação e gestão administrativa. Sua subsidiária Terra Global Investment Management LLC (TGIM) também é mencionada em vários documentos do projeto. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '900798924-1',
    id_empresa_carbono: 'COL0043EM',
    nombre_empresa: 'Human Forest S.A.S. (antes Waldrettung S.A.S.)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO001NA',
      'CO003NA',
      'CO004NA',
      'CO005NA',
      'CO006NA',
      'CO007NA',
      'CO015NA',
      'CO016NA',
      'CO017NA',
      'CO026NA',
      'CO027NA',
      'CO028NA',
      'CO052COL',
      'CO064CER',
      'CO146CER',
    ],
    perfil_es:
      "Empresa fundada en 2014, originalmente como O1GA S.A.S., luego como Ediciones Braille Ver S.A.S. y que hasta 2022 era más conocida por sus dos nombres anteriores: Waldrättung S.A.S. (su nombre hasta diciembre de 2021) y Waldrettung S.A.S. (su nombre hasta octubre de 2022, cuando se convirtió en la actual Human Forest). Waldrettung -cuyo nombre significaba 'cuidado del bosque' en alemán- aseguraba ser la filial en Colombia de una empresa alemana llamada Waldrettung GmbH, pero -como reveló una investigación periodística hecha por el CLIP en alianza con Rutas del Conflicto, Mongabay Latam y La Liga contra el Silencio- ésta no aparecía en el registro comercial en Alemania a septiembre de 2022. Su cabeza visible y representante legal ha sido el abogado comercial Helmuth Mauricio Gallego Sánchez, co-fundador y socio del bufete legal Gallego Abogados S.A.S. (que figuraba como accionista única de la empresa en junio de 2019 pasó de llamarse Ediciones Braille Ver a Waldrättung). Dos proyectos de Waldrettung -uno de los cuales está activo y otro al final no se materializó- crearon divisiones al interior de comunidades indígenas en Vaupés y en Guaviare, como contaron esas dos investigaciones periodísticas. En el Gran Resguardo del Vaupés, el segundo más grande de Colombia, varios líderes de asociaciones indígenas denunciaron a mediados de 2022 no haber sido informados de la propuesta de proyecto antes de su puesta en marcha; la empresa se defendió asegurando que celebró el contrato con el representante legal del resguardo como la unidad jurídica que los agrupa a todos, que obtuvo el consentimiento de su asamblea y que tiene formularios de consentimiento firmados por 3.237 de las 4.156 familias que habitan allí. Ha liderado al menos 13 proyectos Redd+ en Colombia, de los cuales dos han sido certificados.",
    perfil_en:
      "The company was founded in 2014, originally as O1GA S.A.S., then as Ediciones Braille Ver S.A.S. and until 2022 was better known by its two previous names: Waldrättung S.A.S. (its name until December 2021) and Waldrettung S.A.S. (its name until October 2022, when it became the current Human Forest). Waldrettung -whose name meant 'forest care' in German- claimed to be the Colombian subsidiary of a German company called Waldrettung GmbH, but -as revealed by a journalistic investigation made by CLIP in alliance with Rutas del Conflicto, Mongabay Latam and La Liga contra el Silencio- it did not appear in the commercial registry in Germany as of September 2022. Its visible head and legal representative has been the commercial lawyer Helmuth Mauricio Gallego Sánchez, co-founder and partner of the law firm Gallego Abogados S.A.S. (which was listed as the sole shareholder of the company in June 2019 changed its name from Ediciones Braille Ver to Waldrättung). Two projects of Waldrettung - one of which is active and another in the end did not materialize - created divisions within indigenous communities in Vaupés and Guaviare, as told by these two journalistic investigations. In the Gran Resguardo del Vaupés, the second largest in Colombia, several leaders of indigenous associations denounced in mid 2022 that they had not been informed of the project proposal before its implementation; the company defended itself by assuring that it signed the contract with the legal representative of the indigenous reservation as the legal unit that groups them all, that it obtained the consent of its assembly and that it has consent forms signed by 3,237 of the 4,156 families that live there. It has led at least 13 Redd+ projects in Colombia, two of which have been certified.",
    perfil_pt:
      'Empresa fundada em 2014, originalmente como O1GA S.A.S., depois como Ediciones Braille Ver S.A.S. e que até 2022 era mais conhecida pelos seus dois nomes anteriores: Waldrättung S.A.S. (seu nome até dezembro de 2021) e Waldrettung S.A.S. (seu nome até outubro de 2022, quando se tornou a atual Human Forest). Waldrettung — cujo nome significava “cuidado da floresta” em alemão — afirmava ser a filial na Colômbia de uma empresa alemã chamada Waldrettung GmbH, mas — como revelou uma investigação jornalística feita pelo CLIP em parceria com Rutas del Conflicto, Mongabay Latam e La Liga contra el Silencio — esta não constava no registro comercial na Alemanha em setembro de 2022. Seu representante legal e figura visível era o advogado comercial Helmuth Mauricio Gallego Sánchez, cofundador e sócio do escritório de advocacia Gallego Abogados S.A.S. (que figurava como único acionista da empresa em junho de 2019, quando passou de Ediciones Braille Ver para Waldrättung). Dois projetos da Waldrettung – um dos quais está ativo e outro que acabou não se concretizando – criaram divisões dentro das comunidades indígenas em Vaupés e Guaviare, conforme relatado nas duas investigações jornalísticas. No Gran Resguardo del Vaupés, o segundo maior da Colômbia, vários líderes de associações indígenas denunciaram, em meados de 2022, não terem sido informados sobre a proposta do projeto antes de seu início; a empresa se defendeu garantindo que celebrou o contrato com o representante legal da terra indígena como a unidade jurídica que os agrupa a todos, que obteve o consentimento de sua assembleia e que possui formulários de consentimento assinados por 3.237 das 4.156 famílias que vivem lá. Ela liderou pelo menos 13 projetos Redd+ na Colômbia, dos quais dois foram certificados.',
  },
  {
    id_empresa: '901487433-4',
    id_empresa_carbono: 'COL0075EM',
    nombre_empresa: 'WeAct Colombia S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2330VER', 'CO2356VER'],
    perfil_es:
      'Empresa registrada en 2021, propiedad de la empresa australiana WeAct Pty Ltd. Registrada en el estado australiano de Victoria, WeAct Pty tiene proyectos en Fiji, Sudáfrica y Madagascar. Es dirigida por el financista australiano Vivek Dugar y en Colombia, donde ha impulsado dos proyectos que no han sido certificados, por el economista Andrés Guillermo Molina Liévano.',
    perfil_en:
      'Registered in 2021, owned by Australian company WeAct Pty Ltd. Registered in the Australian state of Victoria, WeAct Pty has projects in Fiji, South Africa and Madagascar. It is managed by Australian financier Vivek Dugar and in Colombia, where it has promoted two projects that have not been certified, by economist Andrés Guillermo Molina Liévano.',
    perfil_pt:
      'Empresa registrada em 2021, propriedade da empresa australiana WeAct Pty Ltd. Registrada no estado australiano de Victoria, a WeAct Pty tem projetos em Fiji, África do Sul e Madagascar. É dirigida pelo financista australiano Vivek Dugar e, na Colômbia, onde impulsionou dois projetos que não foram certificados, pelo economista Andrés Guillermo Molina Liévano.',
  },
  {
    id_empresa: '901187524-9',
    id_empresa_carbono: 'COL0054EM',
    nombre_empresa: 'Wildlife Works Colombia S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO019NA',
      'CO030NA',
      'CO032NA',
      'CO033NA',
      'CO3218VER',
      'CO3475VER',
    ],
    perfil_es:
      'Empresa registrada en 2018 para desarrollar proyectos ambientales y del mercado de carbono, cuya accionista única es la empresa estadounidense Wildlife Works Carbon LLC -registrada en el estado de Pensilvania- que ha operado proyectos Redd+ en países como Kenia (Kasigau Corridor y Chyulu Hills), República Democrática del Congo (Mai Ndombe) o Camboya (Tumring y Southern Cardamoms). Las decisiones de la filial en Colombia usualmente han sido tomadas por el fundador y presidente de Wildlife Works Carbon, el ingeniero químico canadiense Mike Korchinsky, su director regional latinoamericano y administrador de empresas panameño Lider Sucre y su director global de calidad y prácticas Jeffrey William Hayward. En la filial colombiana Hayward fue gerente entre 2018 y 2021, siendo sucedido por el ingeniero industrial Enrique Díaz González, que venía de trabajar en la ong Fondo Acción y anteriormente lo había hecho en Parques Nacionales Naturales. A octubre de 2024 tenía 6 proyectos en Colombia, aunque ninguno de ellos ya certificado. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      "Company registered in 2018 to develop environmental and carbon market projects, whose sole shareholder is the US company Wildlife Works Carbon LLC -registered in the state of Pennsylvania- which has operated Redd+ projects in countries such as Kenya (Kasigau Corridor and Chyulu Hills), Democratic Republic of Congo (Mai Ndombe) or Cambodia (Tumring and Southern Cardamoms). Decisions in the Colombian subsidiary have usually been made by Wildlife Works Carbon's founder and president, Canadian chemical engineer Mike Korchinsky, its Latin American regional director and Panamanian business administrator Lider Sucre and its global director of quality and practices Jeffrey William Hayward. In the Colombian subsidiary Hayward was manager between 2018 and 2021, being succeeded by industrial engineer Enrique Díaz González, who came from working in the ngo Fondo Acción and had previously worked in Parques Nacionales Naturales. As of October 2024, he had 6 projects in Colombia, although none of them were already certified. It is a member of Asocarbono, the guild of carbon market actors in Colombia.",
    perfil_pt:
      'Empresa registrada em 2018 para desenvolver projetos ambientais e do mercado de carbono, cuja única acionista é a empresa norte-americana Wildlife Works Carbon LLC - registrada no estado da Pensilvânia - que operou projetos Redd+ em países como Quênia (Kasigau Corridor e Chyulu Hills), República Democrática do Congo (Mai Ndombe) ou Camboja (Tumring e Southern Cardamoms). As decisões da filial na Colômbia geralmente são tomadas pelo fundador e presidente da Wildlife Works Carbon, o engenheiro químico canadense Mike Korchinsky, seu diretor regional para a América Latina e administrador de empresas panamenho Lider Sucre e seu diretor global de qualidade e práticas Jeffrey William Hayward. Na filial colombiana, Hayward foi gerente entre 2018 e 2021, sendo sucedido pelo engenheiro industrial Enrique Díaz González, que vinha trabalhando na ONG Fondo Acción e anteriormente havia trabalhado em Parques Nacionales Naturales. Em outubro de 2024, tinha seis projetos na Colômbia, embora nenhum deles já tivesse sido certificado. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '901246509-1',
    id_empresa_carbono: 'COL0061EM',
    nombre_empresa: 'Yauto S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO024BIO',
      'CO031BIO',
      'CO035BIO',
      'CO036BIO',
      'CO052BIO',
      'BR4761VER',
    ],
    perfil_es:
      'Empresa creada en enero de 2019 en Bogotá, que toma su nombre de un bastón de mando indígena, con el objetivo de impulsar ""proyectos sociales con enfoque pluriétnico y multicultural"" con énfasis en lo ambiental. Forma parte de la alianza Community Redd con otras tres empresas, cada una encargándose de una tarea distinta en sus proyectos del mercado voluntario de carbono: Carbo Sostenible S.A.S. formula los documentos técnicos, Terra Commodities comercializa los bonos, Visso Consultores S.A.S. se ocupa de la parte financiera y Yauto de la social. A mayo de 2023, Yauto tenía dos accionistas, cada uno con el 50%: las empresas Jayma Holdings S.A.S. (propiedad en un 100% a noviembre de 2022 de Alicia Micolta Cabrera) y Aguia Holdings S.A.S. (propiedad en un 100% de Pedro Santiago Posada Arango). Ellos dos, son a su vez, las caras visibles de Yauto y habían sido a diciembre de 2022 sus accionistas cada uno con el 50%. Posada, director de desarrollo de negocios de Yauto, es un abogado antioqueño que fue director de asuntos indígenas del Ministerio del Interior durante ocho años en los gobiernos de Álvaro Uribe y Juan Manuel Santos y luego defensor delegado de indígenas y minorías étnicas en la Defensoría del Pueblo entre 2016 y 2018. Alicia Micolta, ex representante legal de Yauto, fue gerente de comunidades y predios de otra empresa desarrolladora de carbono de la que también era accionista CIProgress (su esposo, el empresario de restaurantes Gustavo Enrique Ardila Gómez, fue socio fundador de Yauto hasta que transfirió sus acciones a Micolta en marzo de 2022 y es representante legal suplente de Jayma Holdings, y figuró también como gerente y representante legal de la empresa Mineral Resources Pacific S.A.S., a la que el Ministerio de Ambiente abrió en noviembre de 2020 un procedimiento sancionatorio por presuntos daños ambientales). Yauto aparece vinculada a al menos 4 proyectos Redd+ en Colombia, más proyectos en formulación en Brasil y Perú. En dos de sus proyectos, esta alianza periodística ha documentado problemas. Por un lado, CLIP encontró que dos comunidades de las seis que históricamente han formado parte del resguardo de Monochoa y su zona de vigilancia y control, llamadas Aménani y Monochoa, fueron inicialmente excluidas de los proyectos (Monochoa y CRIMA Predio Putumayo) llevados a cabo allí mientras su territorio sí era incluido (situación que fue corregida posterior a la publicación). Por otro lado, Infoamazonia encontró que la alianza Community Redd+ intentó impulsar proyectos en el Alto Solimões, en Brasil, a pesar de las recomendaciones contrarias del órgano indigenista estatal Funai.',
    perfil_en:
      'Company created in January 2019 in Bogota, which takes its name from an indigenous staff of command, with the objective of promoting ""social projects with a multiethnic and multicultural approach"" with an emphasis on the environment. It is part of the Community Redd alliance with three other companies, each in charge of a different task in their voluntary carbon market projects: Carbo Sostenible S.A.S. formulates the technical documents, Terra Commodities markets the credits, Visso Consultores S.A.S. is in charge of the financial part, and Yauto is in charge of the social part. As of May 2023, Yauto had two shareholders, each with 50%: the companies Jayma Holdings S.A.S. (100% owned as of November 2022 by Alicia Micolta Cabrera) and Aguia Holdings S.A.S. (100% owned by Pedro Santiago Posada Arango). These two, in turn, are the visible faces of Yauto and had been its 50% shareholders each as of December 2022. Posada, Yauto\'s business development director, is an Antioquian lawyer who was director of indigenous affairs at the Ministry of the Interior for eight years in the governments of Álvaro Uribe and Juan Manuel Santos and then delegated defender of indigenous and ethnic minorities at the Ombudsman\'s Office between 2016 and 2018. Alicia Micolta, former legal representative of Yauto, was manager of communities and lands of another carbon developing company of which CIProgress was also a shareholder (her husband, restaurant businessman Gustavo Enrique Ardila Gómez, was a founding partner of Yauto until he transferred his shares to Micolta in March 2022 and is alternate legal representative of Jayma Holdings, and also appeared as manager and legal representative of the company Mineral Resources Pacific S.A.S., to which the Ministry of Environment opened in November 2020 a sanctioning procedure for alleged environmental damages). Yauto is linked to at least 4 Redd+ projects in Colombia, plus projects under formulation in Brazil and Peru. In two of its projects, this journalistic alliance has documented problems. On the one hand, CLIP found that two of the six communities that have historically formed part of the Monochoa reservation and its surveillance and control zone, called Aménani and Monochoa, were initially excluded from the projects (Monochoa and CRIMA Predio Putumayo) carried out there while their territory was included (a situation that was corrected after publication). On the other hand, Infoamazonia found that the alliance Community Redd+ tried to promote projects in Alto Solimões, in Brazil, despite the contrary recommendations of the state indigenous organization Funai.',
    perfil_pt:
      'Empresa criada em janeiro de 2019 em Bogotá, que leva o nome de um bastão de comando indígena, com o objetivo de promover “projetos sociais com enfoque multiétnico e multicultural”, com ênfase no meio ambiente. Faz parte da aliança Community Redd com outras três empresas, cada uma responsável por uma tarefa diferente em seus projetos do mercado voluntário de carbono: Carbo Sostenible S.A.S. formula os documentos técnicos, Terra Commodities comercializa os créditos, Visso Consultores S.A.S. cuida da parte financeira e Yauto da parte social. Em maio de 2023, a Yauto tinha dois acionistas, cada um com 50%: as empresas Jayma Holdings S.A.S. (propriedade de 100% em novembro de 2022 de Alicia Micolta Cabrera) e Aguia Holdings S.A.S. (propriedade de 100% de Pedro Santiago Posada Arango). Os dois são, por sua vez, os rostos visíveis da Yauto e, em dezembro de 2022, eram seus acionistas, cada um com 50%. Posada, diretor de desenvolvimento de negócios da Yauto, é um advogado de Antioquia que foi diretor de assuntos indígenas do Ministério do Interior durante oito anos nos governos de Álvaro Uribe e Juan Manuel Santos e, posteriormente, defensor delegado dos indígenas e das minorias étnicas na Defensoria do Povo entre 2016 e 2018. Alicia Micolta, ex-representante legal da Yauto, foi gerente de comunidades e propriedades de outra empresa desenvolvedora de carbono da qual também era acionista a CIProgress (seu marido, o empresário de restaurantes Gustavo Enrique Ardila Gómez, foi sócio fundador da Yauto até transferir suas ações para Micolta em março de 2022 e é representante legal suplente da Jayma Holdings, e também apareceu como gerente e representante legal da empresa Mineral Resources Pacific S.A.S., contra a qual o Ministério do Meio Ambiente abriu em novembro de 2020 um processo sancionatório por supostos danos ambientais). A Yauto aparece vinculada a pelo menos quatro projetos Redd+ na Colômbia, além de outros projetos em fase de formulação no Brasil e no Peru. Em dois de seus projetos, esta aliança jornalística documentou problemas. Por um lado, a CLIP descobriu que duas das seis comunidades que historicamente fazem parte da terra indígena de Monochoa e sua zona de vigilância e controle, chamadas Aménani e Monochoa, foram inicialmente excluídas dos projetos (Monochoa e CRIMA Predio Putumayo) realizados lá, enquanto seu território foi incluído (situação que foi corrigida após a publicação). Por outro lado, a Infoamazonia descobriu que a aliança Community Redd+ tentou impulsionar projetos no Alto Solimões, no Brasil, apesar das recomendações contrárias do órgão indigenista estatal Funai.',
  },
  {
    id_empresa: '900284160-3',
    id_empresa_carbono: 'COL0032EM',
    nombre_empresa: 'Anthrotect S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO0856VER'],
    perfil_es:
      'Fundada en 2009 por el antropólogo estadounidense Brodie Ferguson, es quizás la empresa pionera en proyectos Redd+ en Colombia. A diciembre de 2021 contaba con tres accionistas: su representante legal Brodie David Ferguson (con 94% de las acciones), su directora de desarrollo de negocio Emily Roynestad (con 5% de las acciones) y Armando García García (con 1% de las acciones). En el país opera el proyecto Corredor de Conservación Chocó-Darién en el norte del Chocó, que protege un área costera del tapón del Darién en asociación con el consejo comunitario de Cocomasur y que, según Mongabay, fue el primer proyecto de origen comunitario que emitió créditos de carbonos por conservación en el mundo. Anthrotect también lidera el proyecto Oriximiná Quilombola con una comunidad afro en la Amazonia central de Brasil. Ferguson -quien es doctor en antropología de Stanford- también fundó la empresa EcoLens, una plataforma ambiental de análisis de datos para monitorear ecosistemas y entender riesgos climáticos, y es integrante de la junta directiva del medio ambiental Mongabay.',
    perfil_en:
      "Founded in 2009 by U.S. anthropologist Brodie Ferguson, it is perhaps the pioneer in Redd+ projects in Colombia. As of December 2021 it had three shareholders: its legal representative Brodie David Ferguson (with 94% of the shares), its business development director Emily Roynestad (with 5% of the shares) and Armando García García (with 1% of the shares). In the country it operates the Chocó-Darién Conservation Corridor project in northern Chocó, which protects a coastal area of the Darién plug in partnership with the Cocomasur community council and, according to Mongabay, was the first community-based project to issue carbon credits for conservation in the world. Anthrotect also leads the Oriximiná Quilombola project with an Afro community in Brazil's central Amazon. Ferguson - who holds a PhD in anthropology from Stanford - also founded EcoLens, an environmental data analytics platform for monitoring ecosystems and understanding climate risks, and is a board member of the environmental media company Mongabay.",
    perfil_pt:
      'Fundada em 2009 pelo antropólogo norte-americano Brodie Ferguson, é talvez a empresa pioneira em projetos Redd+ na Colômbia. Em dezembro de 2021, contava com três acionistas: seu representante legal Brodie David Ferguson (com 94% das ações), sua diretora de desenvolvimento de negócios Emily Roynestad (com 5% das ações) e Armando García García (com 1% das ações). No país, opera o projeto Corredor de Conservação Chocó-Darién, no norte do Chocó, que protege uma área costeira do Tapão do Darién em parceria com o conselho comunitário de Cocomasur e que, segundo a Mongabay, foi o primeiro projeto de origem comunitária a emitir créditos de carbono por conservação no mundo. A Anthrotect também lidera o projeto Oriximiná Quilombola com uma comunidade afro na Amazônia central do Brasil. Ferguson, que é doutor em antropologia pela Universidade de Stanford, também fundou a empresa EcoLens, uma plataforma ambiental de análise de dados para monitorar ecossistemas e compreender os riscos climáticos, e é membro do conselho de administração da organização ambiental Mongabay.',
  },
  {
    id_empresa: '900066300-3',
    id_empresa_carbono: 'COL0027EM',
    nombre_empresa: 'Biotrade S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO066BIO', 'CO3145VER', 'CO4480VER'],
    perfil_es:
      'Empresa registrada en abril de 2021 en Bogotá para prestar servicios de consultoría en temas ambientales y agropecuarios, en lugar de una empresa de nombre similar -Biotrade Ltda- que había sido creada y disuelta anteriormente. Su accionista única a enero de 2022 era Ruby Acosta Bastidas, una ingenieria agrónoma que ha trabajado desde hace más de una década en temas ligados al mercado de carbono, incluyendo como auditora de proyectos Redd+ para la empresa española Aenor y como consultora en la ong Fondo Patrimonio Natural. La empresa, que no tiene página web, aparece como desarrolladora de tres proyectos Redd+, dos de los cuales aparecen como en fase de formulación y uno de ellos retirado.',
    perfil_en:
      'Company registered in April 2021 in Bogotá to provide consulting services on environmental and agricultural issues, replacing a similarly named company -Biotrade Ltda- that had been created and dissolved earlier. Its sole shareholder as of January 2022 was Ruby Acosta Bastidas, an agricultural engineer who has worked for more than a decade on carbon market issues, including as an auditor of Redd+ projects for the Spanish company Aenor and as a consultant for the NGO Fondo Patrimonio Natural. The company, which does not have a website, is listed as a developer of three Redd+ projects, two of which are listed as in the formulation phase and one of which is withdrawn.',
    perfil_pt:
      'Empresa registrada em abril de 2021 em Bogotá para prestar serviços de consultoria em temas ambientais e agropecuários, em substituição a uma empresa de nome semelhante - Biotrade Ltda - que havia sido criada e dissolvida anteriormente. Sua única acionista em janeiro de 2022 era Ruby Acosta Bastidas, uma engenheira agrônoma que trabalha há mais de uma década em temas relacionados ao mercado de carbono, incluindo como auditora de projetos Redd+ para a empresa espanhola Aenor e como consultora na ONG Fondo Patrimonio Natural. A empresa, que não possui página na internet, aparece como desenvolvedora de três projetos Redd+, dois dos quais aparecem em fase de formulação e um deles retirado.',
  },
  {
    id_empresa: '901244103-6',
    id_empresa_carbono: 'COL0059EM',
    nombre_empresa: 'Visso Consultores S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO024BIO', 'CO031BIO', 'CO035BIO', 'CO036BIO'],
    perfil_es:
      'Empresa creada en 2019 con el objeto de proporcionar consultorías y estructurar financieramente proyectos e inversiones en el sector ambiental. Sus socios accionistas al momento de su fundación eran los administradores de empresas Jorge Eduardo Girón Leuro (que fue vicepresidente del Instituto de Fomento Industrial y presidente de la empresa de muebles y carpintería Pizano S.A.) y Amparo Gavito Pineda (quien también fue gerente en el Instituto de Fomento Industrial y en la Corporación Financiera Colombiana), cada uno con el 50% de las acciones, según consta en registros de cámara de comercio. Forma parte de tres proyectos de la alianza Community Redd con otras cuatro empresas, cada una encargándose de una tarea distinta en varios proyectos del mercado voluntario de carbono: Carbo Sostenible S.A.S. formula los documentos técnicos, Terra Commodities comercializa los bonos, Visso Consultores S.A.S. se ocupa de la parte financiera y Yauto de la social. En dos de sus proyectos, esta alianza periodística ha documentado problemas. Por un lado, CLIP encontró que dos comunidades de las seis que históricamente han formado parte del resguardo de Monochoa y su zona de vigilancia y control, llamadas Aménani y Monochoa, fueron inicialmente excluidas de los proyectos (Monochoa y CRIMA Predio Putumayo) llevados a cabo allí mientras su territorio sí era incluido (situación que fue corregida posterior a la publicación). Por otro lado, Infoamazonia encontró que la alianza Community Redd+ intentó impulsar proyectos en el Alto Solimões, en Brasil, a pesar de las recomendaciones contrarias del órgano indigenista estatal Funai. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'Company created in 2019 with the purpose of providing consultancies and financially structuring projects and investments in the environmental sector. Its shareholding partners at the time of its foundation were business administrators Jorge Eduardo Girón Leuro (who was vice president of the Instituto de Fomento Industrial and president of the furniture and carpentry company Pizano S.A.) and Amparo Gavito Pineda (who was also a manager at the Instituto de Fomento Industrial and the Corporación Financiera Colombiana), each with 50% of the shares, as recorded in chamber of commerce records. He is part of three projects of the Community Redd alliance with four other companies, each in charge of a different task in several voluntary carbon market projects: Carbo Sostenible S.A.S. formulates the technical documents, Terra Commodities markets the credits, Visso Consultores S.A.S. is in charge of the financial part, and Yauto is in charge of the social part. In two of its projects, this journalistic alliance has documented problems. On the one hand, CLIP found that two of the six communities that have historically formed part of the Monochoa reservation and its surveillance and control zone, called Aménani and Monochoa, were initially excluded from the projects (Monochoa and CRIMA Predio Putumayo) carried out there while their territory was included (a situation that was corrected after publication). On the other hand, Infoamazonia found that the Community Redd+ alliance tried to promote projects in Alto Solimões, in Brazil, despite recommendations to the contrary from the state indigenous organization Funai. It is a member of Asocarbono, the guild of carbon market actors in Colombia.',
    perfil_pt:
      'Empresa criada em 2019 com o objetivo de prestar consultoria e estruturar financeiramente projetos e investimentos no setor ambiental. Seus sócios acionistas na época da fundação eram os administradores de empresas Jorge Eduardo Girón Leuro (que foi vice-presidente do Instituto de Fomento Industrial e presidente da empresa de móveis e marcenaria Pizano S.A.) e Amparo Gavito Pineda (que também foi gerente do Instituto de Fomento Industrial e da Corporación Financiera Colombiana), cada um com 50% das ações, conforme consta nos registros da Câmara de Comércio. Faz parte de três projetos da aliança Community Redd com outras quatro empresas, cada uma responsável por uma tarefa diferente em vários projetos do mercado voluntário de carbono: a Carbo Sostenible S.A.S. elabora os documentos técnicos, a Terra Commodities comercializa os créditos, a Visso Consultores S.A.S. cuida da parte financeira e a Yauto da parte social. Em dois de seus projetos, esta aliança jornalística documentou problemas. Por um lado, o CLIP descobriu que duas das seis comunidades que historicamente fazem parte da terra indígena de Monochoa e sua zona de vigilância e controle, chamadas Aménani e Monochoa, foram inicialmente excluídas dos projetos (Monochoa e CRIMA Predio Putumayo) realizados lá, enquanto seu território foi incluído (situação que foi corrigida após a publicação). Por outro lado, a Infoamazonia descobriu que a aliança Community Redd+ tentou impulsionar projetos no Alto Solimões, no Brasil, apesar das recomendações contrárias do órgão indigenista estatal Funai. Ela é membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '901510475-1',
    id_empresa_carbono: 'COL0076EM',
    nombre_empresa: 'Oxigreen S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO089BIO'],
    perfil_es:
      'Empresa creada en 2021 en Bogotá con el objeto de impulsar proyectos Redd+. A 2021 tenía accionistas: Juan Eduardo García Trejos (con 25% de las acciones), María Paula Alonso Gamboa (38%) y Henry Alejandro Silva Pérez (37%). Su gerente general y representante legal desde su fundación es Henry Silva Meche, un veterano político que ocupó varios cargos públicos en los departamentos de Vichada y Casanare y cuyo hijo Henry Alejandro Silva Pérez es uno de los accionistas. Como contó una investigación del CLIP publicada en enero de 2023, la Contraloría General de la República halló a Silva Meche responsable de detrimento patrimonial en 2018 por no haber vigilado un contrato una década atrás mientras era funcionario de la Gobernación de Casanare. A raíz de esa sanción por mal manejo administrativo, la Procuraduría General de la Nación le impuso inhabilidades de 5 años para desempeñar cargos públicos y para contratar con el Estado, que finalizaron en agosto de 2023. La empresa no tiene página web.',
    perfil_en:
      "Company created in 2021 in Bogota with the purpose of promoting Redd+ projects. As of 2021 it had shareholders: Juan Eduardo García Trejos (with 25% of the shares), María Paula Alonso Gamboa (38%) and Henry Alejandro Silva Pérez (37%). Its general manager and legal representative since its foundation is Henry Silva Meche, a veteran politician who held several public positions in the departments of Vichada and Casanare and whose son Henry Alejandro Silva Pérez is one of the shareholders. As a CLIP investigation published in January 2023 recounted, the Comptroller General's Office found Silva Meche responsible for patrimonial detriment in 2018 for failing to monitor a contract a decade earlier while he was an official of the Governor's Office of Casanare. As a result of that sanction for administrative mismanagement, the Inspector General's Office imposed 5-year disqualifications to hold public office and to contract with the State, which ended in August 2023. The company does not have a website.",
    perfil_pt:
      'Empresa criada em 2021 em Bogotá com o objetivo de promover projetos Redd+. Em 2021, tinha os seguintes acionistas: Juan Eduardo García Trejos (com 25% das ações), María Paula Alonso Gamboa (38%) e Henry Alejandro Silva Pérez (37%). Seu gerente geral e representante legal desde a fundação é Henry Silva Meche, um político veterano que ocupou vários cargos públicos nos departamentos de Vichada e Casanare e cujo filho, Henry Alejandro Silva Pérez, é um dos acionistas. Conforme relatado em uma investigação do CLIP publicada em janeiro de 2023, a Controladoria Geral da República considerou Silva Meche responsável por prejuízo patrimonial em 2018 por não ter supervisionado um contrato uma década atrás, enquanto era funcionário do Governo de Casanare. Em consequência dessa sanção por má gestão administrativa, a Procuradoria-Geral da Nação impôs-lhe uma inabilitação de cinco anos para exercer cargos públicos e para contratar com o Estado, que terminou em agosto de 2023. A empresa não tem página web.',
  },
  {
    id_empresa: '901390691-1',
    id_empresa_carbono: 'COL0071EM',
    nombre_empresa: 'Soluciones Proambiente S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: [
      'CO052CER',
      'CO053CER',
      'CO055CER',
      'CO056CER',
      'CO100CER',
      'CO118CER',
      'CO155CER',
    ],
    perfil_es:
      'Empresa consultora registrada en Itagüí en junio de 2020 que se dedica -según su página web- a la ""formulación e implementación de proyectos REDD+ en colaboración con comunidades nativas"". Ha participado en la formulación de al menos cinco proyectos Redd+ liderados por la Corporación Masbosques, una entidad sin ánimo de lucro antioqueña, incluyendo los de Baka Rokarire y Makaro Ap+ro en Vaupés. En su acta de fundación figuraba como fundador y único accionista Mauricio Fernández Posada, quien a abril de 2023 aparecía como el presidente de su asamblea de accionistas y también fue su representante legal. Diego Fernández Posada, quien fue representante legal suplente, figuraba en abril de 2023 como secretario de su asamblea de accionistas. A noviembre de 2024 figuraba como representante legal la empresa Angel Múnera S.A.S. Al menos dos proyectos de Masbosques han tenido problemas: la Corte Constitucional determinó que el proyecto Baka Rokarire en el Pirá Paraná en Vaupés vulneró los derechos fundamentales de los indígenas, puesto que sus desarrolladores ""no obtuvieron el consentimiento libre, previo e informado mediante un diálogo genuino y de buena fe"", después de que la propuesta nunca fue llevada a la máxima instancia de gobierno interno del territorio y que quien suscribió el contrato era un líder que ya no era representante legal en el momento de la firma, según reveló una investigación del CLIP y aliados publicada en 2022. Masbosques argumentó que acordó el proyecto con las legítimas autoridades del territorio reconocidas por el Gobierno nacional y que siempre actuó “conforme a la realidad jurídica del momento”, con varias de las comunidades del Pirá Paraná respaldando su iniciativa, lo que subraya la fuerte fractura social allí. Sobre Masbosques, la Corte Constitucional dijo que “una organización con presencia permanente en la Amazonia tendría o se inferiría debería tener algún conocimiento sobre pretensiones de las comunidades asociadas al funcionamiento de territorios indígenas”. Fernández Posada dijo que no se pronunciaría sobre la acción judicial, explicando que su visión como empresa “es y será el respeto por la ley, la autonomía y la integridad cultural de las comunidades indígenas y sus autoridades tradicionales”. Otro proyecto, Jocu Bucuro Apuro, incluyó -según otra investigación del CLIP de 2023- un resguardo indígena que ya había sido incluido dentro de otro proyecto activo y que había vendido bonos, en lo que pudo constituir un caso de doble contabilidad. ',
    perfil_en:
      'Consulting firm registered in Itagüí in June 2020 that is dedicated - according to its website - to the ""formulation and implementation of REDD+ projects in collaboration with native communities"". It has participated in the formulation of at least five REDD+ projects led by Corporación Masbosques, an Antioquian non-profit entity, including those of Baka Rokarire and Makaro Ap+ro in Vaupés. In its founding charter, Mauricio Fernández Posada was listed as founder and sole shareholder, who as of April 2023 appeared as the president of its shareholders\' meeting and was also its legal representative. Diego Fernández Posada, who was the alternate legal representative, was listed in April 2023 as secretary of its shareholders\' meeting. As of November 2024, the company Angel Múnera S.A.S. was listed as legal representative. At least two Masbosques projects have had problems: the Constitutional Court ruled that the Baka Rokarire project in Pirá Paraná in Vaupés violated the fundamental rights of the indigenous people, since its developers ""did not obtain free, prior and informed consent through genuine dialogue and in good faith"", after the proposal was never taken to the highest instance of internal governance of the territory and the person who signed the contract was a leader who was no longer a legal representative at the time of signing, as revealed by an investigation by CLIP and allies published in 2022. Masbosques argued that it agreed the project with the legitimate authorities of the territory recognized by the national government and that it always acted ""according to the legal reality of the moment"", with several of the Pirá Paraná communities backing its initiative, which underlines the strong social fracture there. Regarding Masbosques, the Constitutional Court said that ""an organization with a permanent presence in the Amazon would have or it would be inferred should have some knowledge of the communities\' claims associated with the operation of indigenous territories"". Fernández Posada said it would not rule on the legal action, explaining that its vision as a company ""is and will be respect for the law, the autonomy and cultural integrity of the indigenous communities and their traditional authorities"". Another project, Jocu Bucuro Apuro, included - according to another CLIP investigation in 2023 - an indigenous reservation that had already been included within another active project and had sold credits, in what may have constituted a case of double counting.',
    perfil_pt:
      'Empresa de consultoria registrada em Itagüí em junho de 2020 que se dedica, segundo seu site, à ""formulação e implementação de projetos REDD+ em colaboração com comunidades nativas"". Participou na formulação de pelo menos cinco projetos Redd+ liderados pela Corporação Masbosques, uma entidade sem fins lucrativos de Antioquia, incluindo os de Baka Rokarire e Makaro Ap+ro em Vaupés. Em sua escritura de fundação, figurava como fundador e único acionista Mauricio Fernández Posada, que em abril de 2023 aparecia como presidente da assembleia de acionistas e também era seu representante legal. Diego Fernández Posada, que era representante legal suplente, figurava em abril de 2023 como secretário da assembleia de acionistas. Em novembro de 2024, figurava como representante legal a empresa Angel Múnera S.A.S. Pelo menos dois projetos da Masbosques tiveram problemas: o Tribunal Constitucional determinou que o projeto Baka Rokarire em Pirá Paraná, em Vaupés, violou os direitos fundamentais dos indígenas, uma vez que seus desenvolvedores “não obtiveram o consentimento livre, prévio e informado por meio de um diálogo genuíno e de boa fé”, depois que a proposta nunca foi levada à instância máxima do governo interno do território e que quem assinou o contrato era um líder que já não era representante legal no momento da assinatura, conforme revelou uma investigação do CLIP e aliados publicada em 2022. A Masbosques argumentou que acordou o projeto com as autoridades legítimas do território reconhecidas pelo governo nacional e que sempre agiu “de acordo com a realidade jurídica do momento”, com várias das comunidades do Pirá Paraná apoiando sua iniciativa, o que ressalta a forte fratura social na região. Sobre a Masbosques, o Tribunal Constitucional afirmou que “uma organização com presença permanente na Amazônia teria ou se inferiria que deveria ter algum conhecimento sobre as pretensões das comunidades associadas ao funcionamento dos territórios indígenas”. Fernández Posada disse que não se pronunciaria sobre a ação judicial, explicando que sua visão como empresa “é e será o respeito pela lei, a autonomia e a integridade cultural das comunidades indígenas e suas autoridades tradicionais”. Outro projeto, Jocu Bucuro Apuro, incluiu – segundo outra investigação do CLIP de 2023 – uma terra indígena que já havia sido incluída em outro projeto ativo e que havia vendido créditos, no que poderia ter constituido um caso de dupla contabilidade.',
  },
  {
    id_empresa: '900016874-5',
    id_empresa_carbono: 'COL0024EM',
    nombre_empresa: 'Fundación BioDiversa Colombia (FBC) ',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO230CER', 'CO3564VER'],
    perfil_es:
      'Fundación constituida en 2005 y registrada en Bogotá con el ánimo de promover y desarrollar actividades de investigación y conservación. A septiembre de 2016 contaba -según un acta de cámara de comercio- con 25 asociados: su representante legal Fernando Arbeláez Escalante, su representante legal suplente Andrés Fernando Almonacid Sánchez, Adela Roa Varón, Aída Marcela Vasco Palacios, Catalina Arias Agudelo, Dafna Camila Ángel, Daniel Job van der Post, Juan David Sánchez Londoño, Paula Caicedo Rosales, Natalia Góngora, Juan Fernando Phillips Bernal, Hernán Javier Díaz Perdomo, Paola Jiménez, Juan Fernando Millán, Andrea Polanco, María Catalina Giraldo Pastrana, Eunice Santos, Natalia Norden, María Teresa Gámez Pardo, Mario Vargas Ramírez, Diana Susana Rodríguez Buriticá, Jorjany Botero, Alba Lucía Morales Jiménez, Andrés Felipe Aponte Gutiérrez y Antoine Escalas. Lidera un proyecto Redd+ en el Magdalena Medio que apareció como ""retirado"" en la plataforma de Verra a finales de 2024. Su página web aparece inactiva.',
    perfil_en:
      'Foundation established in 2005 and registered in Bogota with the aim of promoting and developing research and conservation activities. As of September 2016 it had -according to a chamber of commerce act- 25 associates: its legal representative Fernando Arbeláez Escalante, its alternate legal representative Andrés Fernando Almonacid Sánchez, Adela Roa Varón, Aída Marcela Vasco Palacios, Catalina Arias Agudelo, Dafna Camila Ángel, Daniel Job van der Post, Juan David Sánchez Londoño, Paula Caicedo Rosales, Natalia Góngora, Juan Fernando Phillips Bernal, Hernán Javier Díaz Perdomo, Paola Jiménez, Juan Fernando Millán, Andrea Polanco, María Catalina Giraldo Pastrana, Eunice Santos, Natalia Norden, María Teresa Gámez Pardo, Mario Vargas Ramírez, Diana Susana Rodríguez Buriticá, Jorjany Botero, Alba Lucía Morales Jiménez, Andrés Felipe Aponte Gutiérrez and Antoine Escalas. Leads a Redd+ project in Magdalena Medio that appeared as ""withdrawn"" in Verra\'s platform at the end of 2024. Its website appears inactive.',
    perfil_pt:
      'Fundação constituída em 2005 e registrada em Bogotá com o objetivo de promover e desenvolver atividades de pesquisa e conservação. Em setembro de 2016, contava, segundo um registro da Câmara de Comércio, com 25 associados: seu representante legal Fernando Arbeláez Escalante, seu representante legal suplente Andrés Fernando Almonacid Sánchez, Adela Roa Varón, Aída Marcela Vasco Palacios, Catalina Arias Agudelo, Dafna Camila Ángel, Daniel Job van der Post, Juan David Sánchez Londoño, Paula Caicedo Rosales, Natalia Góngora, Juan Fernando Phillips Bernal, Hernán Javier Díaz Perdomo, Paola Jiménez, Juan Fernando Millán, Andrea Polanco, María Catalina Giraldo Pastrana, Eunice Santos, Natalia Norden, María Teresa Gámez Pardo, Mario Vargas Ramírez, Diana Susana Rodríguez Buriticá, Jorjany Botero, Alba Lucía Morales Jiménez, Andrés Felipe Aponte Gutiérrez e Antoine Escalas. Lidera um projeto Redd+ no Magdalena Médio que apareceu como “retirado” na plataforma da Verra no final de 2024. Seu site aparece inativo.',
  },
  {
    id_empresa: '901040305-0',
    id_empresa_carbono: 'COL0051EM',
    nombre_empresa: 'Fundación Magnolios',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2317VER'],
    perfil_es:
      "Fundación constituida en 2016 por la colombiana Angie Hernández y su esposo alemán Christian Danneker para impulsar proyectos ligadas a la investigación en biodiversidad, la conservación y la mitigación del cambio climático. Su nombre alude a la familia de árboles, las magnoliáceas, de las que Colombia cuenta con 37 especies, varias de las cuales son endémicas y están amenazadas (como la Magnolia polyhypsophylla o 'almanegra de ventanas' y la Magnolia guatapensis o 'almanegra de Guatapé', ambas encontradas únicamente en Antioquia y en peligro crítico). A noviembre de 2024 su socio único y representante legal era Dannecker, quien también es accionista fundador y fue director ejecutivo de proyectos globales de South Pole, con quien la fundación desarrolló el proyecto Redd+ Magnolios de Yarumal.",
    perfil_en:
      "Foundation established in 2016 by Colombian Angie Hernández and her German husband Christian Danneker to promote projects linked to biodiversity research, conservation and climate change mitigation. Its name alludes to the tree family, the Magnoliaceae, of which Colombia has 37 species, several of which are endemic and threatened (such as Magnolia polyhypsophylla or 'almanegra de ventanas' and Magnolia guatapensis or 'almanegra de Guatapé', both found only in Antioquia and critically endangered). As of November 2024 its sole partner and legal representative was Dannecker, who is also a founding shareholder and was executive director of global projects at South Pole, with whom the foundation developed the Redd+ Magnolios de Yarumal project.",
    perfil_pt:
      'Fundação constituída em 2016 pela colombiana Angie Hernández e seu marido alemão Christian Danneker para promover projetos ligados à pesquisa em biodiversidade, conservação e mitigação das mudanças climáticas. Seu nome faz referência à família de árvores magnoliáceas, da qual a Colômbia possui 37 espécies, várias das quais são endêmicas e estão ameaçadas (como a Magnolia polyhypsophylla ou “almanegra de ventanas” e a Magnolia guatapensis ou “almanegra de Guatapé”, ambas encontradas apenas em Antioquia e em perigo crítico). Em novembro de 2024, seu único sócio e representante legal era Dannecker, que também é acionista fundador e foi diretor executivo de projetos globais da South Pole, com quem a fundação desenvolveu o projeto Redd+ Magnolios de Yarumal.',
  },
  {
    id_empresa: '900936131-9',
    id_empresa_carbono: 'COL0047EM',
    nombre_empresa: 'Corporación Salvamontes Colombia',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2317VER'],
    perfil_es:
      'Fundación creada en 2007 y registrada en Medellín, con el ánimo -según su página web- de ""conservar especies en peligro crítico y sus hábitats mediante la creación de reservas naturales y la investigación científica"". A marzo de 2024 contaba -según un acta de cámara de comercio- con 20 miembros, muchos de ellos biólogos y/o profesionales del sector ambiental: su actual representante legal Carlos Sebastián Vieira Uribe, Mauricio Rivera Correa, Gloria Astrid Moreno Gómez, Tomás Hinestroza Koppel, Samuel Monsalve Correa, Saúl Ernesto Hoyos Gómez, Leidy Marcela Jojoa Unigarro, Lina Betancur, Carlos Mauricio Mazo, Luisa Fernanda Mejía Duque, Angélica Díaz, Juan Lázaro Toro, Juan Camilo Clavijo, Valentina Hoyos Ramírez, Natalia Uribe Macías, Amalia María Cano Castaño, Nora Londoño, Alvaro Cogollo Pacheco, Yovany Ochoa y Norberto López Alvarez. Forma parte de un proyecto Redd+ en el norte de Antioquia.',
    perfil_en:
      'Foundation created in 2007 and registered in Medellín, with the aim - according to its website - of ""conserving critically endangered species and their habitats through the creation of natural reserves and scientific research"". As of March 2024, according to a chamber of commerce certificate, it had 20 members, many of them biologists and/or professionals in the environmental sector: its current legal representative Carlos Sebastián Vieira Uribe, Mauricio Rivera Correa, Gloria Astrid Moreno Gómez, Tomás Hinestroza Koppel, Samuel Monsalve Correa, Saúl Ernesto Hoyos Gómez, Leidy Marcela Jojoa Unigarro, Lina Betancur, Carlos Mauricio Mazo, Luisa Fernanda Mejía Duque, Angélica Díaz, Juan Lázaro Toro, Juan Camilo Clavijo, Valentina Hoyos Ramírez, Natalia Uribe Macías, Amalia María Cano Castaño, Nora Londoño, Alvaro Cogollo Pacheco, Yovany Ochoa and Norberto López Alvarez. It is part of a Redd+ project in northern Antioquia.',
    perfil_pt:
      'Fundação criada em 2007 e registrada em Medellín, com o objetivo, segundo seu site, de “conservar espécies em perigo crítico e seus habitats por meio da criação de reservas naturais e da pesquisa científica”. Em março de 2024, contava, segundo um registro da Câmara de Comércio, com 20 membros, muitos deles biólogos e/ou profissionais do setor ambiental: seu atual representante legal Carlos Sebastián Vieira Uribe, Mauricio Rivera Correa, Gloria Astrid Moreno Gómez, Tomás Hinestroza Koppel, Samuel Monsalve Correa, Saúl Ernesto Hoyos Gómez, Leidy Marcela Jojoa Unigarro, Lina Betancur, Carlos Mauricio Mazo, Luisa Fernanda Mejía Duque, Angélica Díaz, Juan Lázaro Toro, Juan Camilo Clavijo, Valentina Hoyos Ramírez, Natalia Uribe Macías, Amalia María Cano Castaño, Nora Londoño, Alvaro Cogollo Pacheco, Yovany Ochoa e Norberto López Alvarez. Faz parte de um projeto Redd+ no norte de Antioquia.',
  },
  {
    id_empresa: '900174471-7',
    id_empresa_carbono: 'COL0029EM',
    nombre_empresa: 'Fundación Guanacas Bosque de Niebla',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2317VER'],
    perfil_es:
      'Fundación creada en 2007 y registrada en Medellín, con el ánimo -según su página web- de ""generar y asegurar servicios ecosistémicos a través de la conservación de bosques de niebla"" alrededor de un predio en Santa Rosa de Osos (Antioquia) que está constituido como reserva natural de la sociedad civil. A agosto de 2024 contaba -según un acta de cámara de comercio- con un consejo directivo de 5 integrantes: su directora de proyectos y actual representante legal Isabel Cristina Montoya Sánchez, María Alejandra Moreno Vásquez, Juan Pablo Montoya Sánchez, Jorge Eliécer Montoya Ceballos y Blanca Nubia Sánchez de Montoya. Anteriormente fue presidente y miembro fundador José Rodrigo Castaño Díaz. Forma parte de un proyecto Redd+ en el norte de Antioquia.',
    perfil_en:
      'The foundation was created in 2007 and registered in Medellín, with the aim, according to its website, of ""generating and ensuring ecosystem services through the conservation of cloud forests"" around a property in Santa Rosa de Osos (Antioquia) that is constituted as a natural reserve of civil society. As of August 2024, according to a chamber of commerce certificate, it had a 5-member board of directors: its project director and current legal representative Isabel Cristina Montoya Sánchez, María Alejandra Moreno Vásquez, Juan Pablo Montoya Sánchez, Jorge Eliécer Montoya Ceballos and Blanca Nubia Sánchez de Montoya. José Rodrigo Castaño Díaz was previously president and founding member. It is part of a Redd+ project in northern Antioquia.',
    perfil_pt:
      'Fundação criada em 2007 e registrada em Medellín, com o objetivo — de acordo com seu site — de “gerar e garantir serviços ecossistêmicos por meio da conservação de florestas nebulosas” em torno de uma propriedade em Santa Rosa de Osos (Antioquia) que é constituída como reserva natural da sociedade civil. Em agosto de 2024, contava, segundo uma ata da câmara de comércio, com um conselho diretor de cinco membros: sua diretora de projetos e atual representante legal, Isabel Cristina Montoya Sánchez, María Alejandra Moreno Vásquez, Juan Pablo Montoya Sánchez, Jorge Eliécer Montoya Ceballos e Blanca Nubia Sánchez de Montoya. Anteriormente, José Rodrigo Castaño Díaz foi presidente e membro fundador. Faz parte de um projeto Redd+ no norte de Antioquia.',
  },
  {
    id_empresa: '901256544-2',
    id_empresa_carbono: 'COL0062EM',
    nombre_empresa: 'Fundación Alto de Ventanas',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2317VER'],
    perfil_es:
      'Fundación creada en 2019 por 65 habitantes y propietarios de terrenos en Yarumal. Forma parte de un proyecto Redd+ en el norte de Antioquia.',
    perfil_en:
      'Foundation created in 2019 by 65 inhabitants and landowners in Yarumal. It is part of a Redd+ project in northern Antioquia.',
    perfil_pt:
      'Fundação criada em 2019 por 65 moradores e proprietários de terras em Yarumal. Faz parte de um projeto Redd+ no norte de Antioquia.',
  },
  {
    id_empresa: '900358626-2',
    id_empresa_carbono: 'COL0034EM',
    nombre_empresa: 'Fundación Proyecto Primates',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO3564VER'],
    perfil_es:
      'Fundación constituida en 2010 y registrada en Bogotá con el ánimo de promover la investigación y conservación de primates neotropicales y sus ecosistemas. A febrero de 2014 contaba -según un acta de cámara de comercio- con dos socios fundadores: su actual representante legal, el biológo y profesor de la Universidad de los Andes, Andrés Link Ospina, y su representante legal suplente, la bióloga de conservación Ana Gabriela de Luna Uribe. Lidera un proyecto Redd+ en el Magdalena Medio que apareció como ""retirado"" en la plataforma de Verra a finales de 2024. ',
    perfil_en:
      'Foundation established in 2010 and registered in Bogotá with the aim of promoting research and conservation of neotropical primates and their ecosystems. As of February 2014 it had -according to a chamber of commerce certificate- two founding partners: its current legal representative, biologist and professor at the Universidad de los Andes, Andrés Link Ospina, and its alternate legal representative, conservation biologist Ana Gabriela de Luna Uribe. He leads a Redd+ project in Magdalena Medio that appeared as ""withdrawn"" in Verra\'s platform at the end of 2024.',
    perfil_pt:
      'Fundação constituída em 2010 e registrada em Bogotá com o objetivo de promover a pesquisa e conservação de primatas neotropicais e seus ecossistemas. Em fevereiro de 2014, contava, de acordo com uma ata da Câmara de Comércio, com dois sócios fundadores: seu atual representante legal, o biólogo e professor da Universidade dos Andes, Andrés Link Ospina, e sua representante legal suplente, a bióloga conservacionista Ana Gabriela de Luna Uribe. Lidera um projeto Redd+ no Magdalena Médio que apareceu como ""retirado"" na plataforma da Verra no final de 2024.',
  },
  {
    id_empresa: '829000127-4',
    id_empresa_carbono: 'COL0010EM',
    nombre_empresa:
      'Corporación Autónoma Regional del Río Grande de la Magdalena (Cormagdalena)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'agencia_estaod',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1765VER'],
    perfil_es:
      'Entidad pública que ejerce como autoridad ambiental regional que tiene como misión la recuperación de la navegación del rio Magdalena, el más importante de la región andina del país, con sede en Barrancabermeja y jurisdicción en los municipios rivereños del río Magdalena y Canal del Dique, desde su nacimiento en el Macizo Colombiano entre Huila y Cauca hasta su desembocadura en Barranquilla y Cartagena. Lidera un proyecto Redd+ en Huila con su par, la Corporación Autónoma Regional del Alto Magdalena (CAM).',
    perfil_en:
      'Public entity that acts as a regional environmental authority whose mission is to recover the navigation of the Magdalena River, the most important river in the Andean region of the country, with headquarters in Barrancabermeja and jurisdiction in the river municipalities of the Magdalena River and Canal del Dique, from its source in the Colombian Massif between Huila and Cauca to its mouth in Barranquilla and Cartagena. Leads a Redd+ project in Huila with its partner, the Corporación Autónoma Regional del Alto Magdalena (CAM).',
    perfil_pt:
      'Entidade pública que atua como autoridade ambiental regional com a missão de recuperar a navegação do rio Magdalena, o mais importante da região andina do país, com sede em Barrancabermeja e jurisdição nos municípios ribeirinhos do rio Magdalena e Canal del Dique, desde sua nascente no Maciço Colombiano, entre Huila e Cauca, até sua foz em Barranquilla e Cartagena. Lidera um projeto Redd+ em Huila com sua contraparte, a Corporação Autônoma Regional do Alto Magdalena (CAM).',
  },
  {
    id_empresa: '800252037-5',
    id_empresa_carbono: 'COL0004EM',
    nombre_empresa: 'Corporación Autónoma Regional de Chivor (Corpochivor)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'agencia_estaod',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1695VER'],
    perfil_es:
      'Entidad pública que ejerce como autoridad ambiental regional con sede en Garagoa y jurisdicción en el sur del departamento de Boyacá. Lidera un proyecto Redd+ en el suroriente de Boyacá.',
    perfil_en:
      'Public entity that acts as a regional environmental authority with headquarters in Garagoa and jurisdiction in the south of the department of Boyacá. Leads a Redd+ project in southeastern Boyacá.',
    perfil_pt:
      'Entidade pública que atua como autoridade ambiental regional com sede em Garagoa e jurisdição no sul do departamento de Boyacá. Lidera um projeto Redd+ no sudeste de Boyacá.',
  },
  {
    id_empresa: '890904996-1',
    id_empresa_carbono: 'COL0020EM',
    nombre_empresa: 'Empresas Públicas de Medellín (EPM)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO036NA'],
    perfil_es:
      "Una de las empresas más conocidas de Colombia, es una empresa pública bajo la figura de 'empresa industrial y comercial del Estado' que es propiedad en un 100% del Distrito de Medellín. Contempló crear un proyecto de carbono en torno a los bosques alrededor de los embalses de cuatro proyectos hidroeléctricos de su propiedad en el nororiente antioqueño. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.",
    perfil_en:
      "One of the best known companies in Colombia, it is a public company under the figure of 'industrial and commercial enterprise of the State' that is 100% owned by the District of Medellín. It contemplated creating a carbon project around the forests surrounding the reservoirs of four hydroelectric projects it owns in northeastern Antioquia. It is a member of Asocarbono, the guild of actors in the carbon market in Colombia.",
    perfil_pt:
      'Uma das empresas mais conhecidas da Colômbia, é uma empresa pública sob a figura de ""empresa industrial e comercial do Estado"", 100% propriedade do Distrito de Medellín. Ela contemplou a criação de um projeto de carbono em torno das florestas ao redor dos reservatórios de quatro projetos hidrelétricos de sua propriedade no nordeste de Antioquia. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '830136799-1',
    id_empresa_carbono: 'COL0014EM',
    nombre_empresa: 'Biomax Biocombustibles S.A.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO001PLA'],
    perfil_es:
      'Empresa distribuidora de combustibles y biocombustibles comúnmente conocida como Biomax, con una red de estaciones de servicio por toda Colombia. Aparece en documentos como proponente del proyecto Flor de Inírida desarrollado con la empresa Compensation International Progress S.A. (CIProgress Greenlife), que originalmente figuraba en el registro del certificador Verra (primero como \'en pausa\' y desde octubre de 2024 como retirado) pero que aparece como registrado por la página de una certificadora nueva llamada PlanetAI Nature Space. Biomax lo describe en su página web como un proyecto ""con sentido social (...) beneficiando de forma directa a 48 comunidades y 668 familias indígenas"".',
    perfil_en:
      'Fuel and biofuel distribution company commonly known as Biomax, with a network of service stations throughout Colombia. It appears in documents as a proponent of the Flor de Inírida project developed with the company Compensation International Progress S.A. (CIProgress Greenlife), which originally appeared in the registry of the certifier Verra (first as \'in pause\' and since October 2024 as withdrawn) but which appears as registered by the page of a new certifier called PlanetAI Nature Space. Biomax describes it on its website as a project ""with social sense (...) directly benefiting 48 communities and 668 indigenous families"".',
    perfil_pt:
      'Empresa distribuidora de combustíveis e biocombustíveis comumente conhecida como Biomax, com uma rede de postos de serviço em toda a Colômbia. Aparece em documentos como proponente do projeto Flor de Inírida, desenvolvido com a empresa Compensation International Progress S.A. (CIProgress Greenlife), que originalmente constava no registro da certificadora Verra (primeiro como “em pausa” e, desde outubro de 2024, como retirado), mas que aparece como registrado pela página de uma nova certificadora chamada PlanetAI Nature Space. A Biomax o descreve em seu site como um projeto “com sentido social (...) beneficiando diretamente 48 comunidades e 668 famílias indígenas”.',
  },
  {
    id_empresa: '816002020-7',
    id_empresa_carbono: 'COL0009EM',
    nombre_empresa:
      'Empresa de Acueducto y Alcantarillado de Pereira S.A.S. E.S.P. (Aguas & Aguas de Pereira)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2392VER'],
    perfil_es:
      'Empresa de naturaleza mixta prestadora de servicios domiciliarios de acueducto y alcantarillado en Pereira, propiedad en casi un 99% del Municipio de Pereira, con un 1.25% en manos del Instituto Municipal de Tránsito de Pereira y un 0.01% en manos de la Empresa de Energía de Pereira S.A. E.S.P. Lidera un proyecto Redd+ en torno a predios de su propiedad en la cuenca del río Otún.',
    perfil_en:
      'A mixed company that provides water and sewage services in Pereira, almost 99% owned by the Municipality of Pereira, with a 1.25% stake in the company, with 1.25% in the hands of the Instituto Municipal de Tránsito de Pereira and 0.01% in the hands of Empresa de Energía de Pereira S.A. E.S.P. It leads a Redd+ project on land it owns in the Otún River basin.',
    perfil_pt:
      'Empresa de natureza mista prestadora de serviços domiciliares de aqueduto e esgoto em Pereira, propriedade em quase 99% do Município de Pereira, com 1,25% nas mãos do Instituto Municipal de Trânsito de Pereira e 0,01% nas mãos da Empresa de Energia de Pereira S.A. E.S.P. Lidera um projeto Redd+ em torno de propriedades na bacia do rio Otún.',
  },
  {
    id_empresa: '899999094-1',
    id_empresa_carbono: 'COL0022EM',
    nombre_empresa: 'Empresa de Acueducto y Alcantarillado Bogotá (EEAB)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO081BIO'],
    perfil_es:
      "Empresa pública prestadora de servicios domiciliarios de acueducto y alcantarillado en Bogotá, bajo la figura de 'empresa industrial y comercial del Distrito' y vinculada a la Secretaría Distrital del Hábitat de Bogotá. Lidera un proyecto Redd+ en torno a predios de su propiedad o administrados por la empresa.",
    perfil_en:
      "Public company providing water and sewage services in Bogota, under the figure of 'industrial and commercial company of the District' and linked to the District Secretariat of Habitat of Bogota. It leads a Redd+ project around properties owned or managed by the company.",
    perfil_pt:
      'Empresa pública prestadora de serviços domiciliares de água e esgoto em Bogotá, sob a figura de ""empresa industrial e comercial do Distrito"" e vinculada à Secretaria Distrital do Habitat de Bogotá. Lidera um projeto Redd+ em torno de terrenos de sua propriedade ou administrados pela empresa.',
  },
  {
    id_empresa: '901345861-4',
    id_empresa_carbono: 'COL0069EM',
    nombre_empresa: 'CB Carbonconsulting S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2262VER'],
    perfil_es:
      'Empresa creada en 2021 en Bogotá con el objeto de prestar asesorías y consultorías en temas ambientales. Su accionista único era la ingeniera forestal María Catalina Becerra Leal, quien ha trabajado en el Banco Mundial en monitoreo, reporte y verificación (MRV) de cambio climático, en desarrollador suizo de proyectos South Pole y en el auditor colombiano Icontec y en 2020 publicó un estudio académico en la revista Forests sobre la comparación de la integridad ambiental de la reducción de emisiones de programas REDD+ con los de energías renovables. Aparece como desarrolladora de un proyecto de carbono en Colombia en alianza con Cuesta & Asociados S.A.S., que figura como retirado de la plataforma del certificador Verra. Su página web menciona además otra iniciativa Redd+ en Guatemala.',
    perfil_en:
      "Company created in 2021 in Bogota with the purpose of providing advisory and consulting services on environmental issues. Its sole shareholder was forestry engineer María Catalina Becerra Leal, who has worked at the World Bank in monitoring, reporting and verification (MRV) of climate change, at Swiss project developer South Pole and at the Colombian auditor Icontec and in 2020 published an academic study in the journal Forests on the comparison of the environmental integrity of emissions reductions from REDD+ programs with those from renewable energies. It is listed as the developer of a carbon project in Colombia in alliance with Cuesta & Asociados S.A.S., which is listed as withdrawn from the Verra certifier's platform. Its website also mentions another Redd+ initiative in Guatemala.",
    perfil_pt:
      'Empresa criada em 2021 em Bogotá com o objetivo de prestar assessoria e consultoria em questões ambientais. Sua única acionista era a engenheira florestal María Catalina Becerra Leal, que trabalhou no Banco Mundial em monitoramento, relatório e verificação (MRV) de mudanças climáticas, na desenvolvedora suíça de projetos South Pole e na auditora colombiana Icontec. Em 2020, publicou um estudo acadêmico na revista Forests sobre a comparação da integridade ambiental da redução de emissões dos programas REDD+ com os de energias renováveis. Ela aparece como desenvolvedora de um projeto de carbono na Colômbia em parceria com a Cuesta & Asociados S.A.S., que figura como retirada da plataforma da certificadora Verra. Seu site também menciona outra iniciativa Redd+ na Guatemala.',
  },
  {
    id_empresa: '901211139-9',
    id_empresa_carbono: 'COL0056EM',
    nombre_empresa: 'Fundación Agro Impulso (F.A.I.M.)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO007BIO', 'CO089CER', 'CO114CER'],
    perfil_es:
      'Fundación creada en 2015 y registrada en Cali con el ánimo, según su página web, de ""promover el desarrollo ambiental, agrícola, ecológico, social y empresarial"". A abril de 2024, contaba -según un acta de cámara de comercio- con siete socios e integrantes de su junta directiva: su presidenta Danna Gabriela Aguirre Cornejo, su vicepresidenta Francis Elena Cornejo Naranjo, Leandro Valentín Buenaventura Ibargüen, Ferley Arroyo Rosero, Andrés Leonardo Cornejo Escallón, Laura Marcela Cornejo Escallón, Daniel Esteban Aguirre Cornejo. Entre sus socios anteriormente figuraron Hernán Olmedo Volverás Chilatra, Simón Fernel Lozano Ruiz y Yessica Antonia Valdés Cornejo. Lidera dos proyectos Redd+ en el Pacífico en alianza con CO2Cero y participó en la estructuración de otro más.',
    perfil_en:
      'Foundation created in 2015 and registered in Cali with the aim, according to its website, of ""promoting environmental, agricultural, ecological, social and business development"". As of April 2024, it had - according to a chamber of commerce act - seven partners and members of its board of directors: its president Danna Gabriela Aguirre Cornejo, its vice president Francis Elena Cornejo Naranjo, Leandro Valentín Buenaventura Ibargüen, Ferley Arroyo Rosero, Andrés Leonardo Cornejo Escallón, Laura Marcela Cornejo Escallón, Daniel Esteban Aguirre Cornejo. Previous partners include Hernán Olmedo Volverás Chilatra, Simón Fernel Lozano Ruiz and Yessica Antonia Valdés Cornejo. It leads two Redd+ projects in the Pacific in alliance with CO2Cero and participated in the structuring of another one.',
    perfil_pt:
      'Fundação criada em 2015 e registrada em Cali com o objetivo, de acordo com seu site, de “promover o desenvolvimento ambiental, agrícola, ecológico, social e empresarial”. Em abril de 2024, contava, de acordo com uma ata da Câmara de Comércio, com sete sócios e membros de seu conselho diretor: sua presidente Danna Gabriela Aguirre Cornejo, sua vice-presidente Francis Elena Cornejo Naranjo, Leandro Valentín Buenaventura Ibargüen, Ferley Arroyo Rosero, Andrés Leonardo Cornejo Escallón, Laura Marcela Cornejo Escallón e Daniel Esteban Aguirre Cornejo. Entre seus sócios anteriores figuravam Hernán Olmedo Volverás Chilatra, Simón Fernel Lozano Ruiz e Yessica Antonia Valdés Cornejo. Lidera dois projetos Redd+ no Pacífico em parceria com a CO2Cero e participou da estruturação de outro.',
  },
  {
    id_empresa: '800075616-0',
    id_empresa_carbono: 'COL0003EM',
    nombre_empresa: 'Cuesta & Asociados S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO2262VER'],
    perfil_es:
      'Firma legal constituida en 1988 en Bogotá y especializada en derecho comercial, también conocida como Cuesta Lawyers. A marzo de 2024 su accionista único era el abogado Juan Carlos Cuesta Quintero, que ha sido árbitro de la Cámara de Comercio de Bogotá. Aparece como desarrolladora de un proyecto de carbono en Colombia en alianza con CB Carbonconsulting, que figura como retirado de la plataforma del certificador Verra.',
    perfil_en:
      "Law firm incorporated in 1988 in Bogota and specialized in commercial law, also known as Cuesta Lawyers. As of March 2024 its sole shareholder was attorney Juan Carlos Cuesta Quintero, who has been an arbitrator for the Bogotá Chamber of Commerce. It is listed as developer of a carbon project in Colombia in alliance with CB Carbonconsulting, which is listed as withdrawn from certifier Verra's platform.",
    perfil_pt:
      'Escritório de advocacia constituído em 1988 em Bogotá e especializado em direito comercial, também conhecido como Cuesta Lawyers. Em março de 2024, seu único acionista era o advogado Juan Carlos Cuesta Quintero, que foi árbitro da Câmara de Comércio de Bogotá. Aparece como desenvolvedora de um projeto de carbono na Colômbia em parceria com a CB Carbonconsulting, que consta como retirada da plataforma do certificador Verra.',
  },
  {
    id_empresa: '559094',
    id_empresa_carbono: 'MEX0001EM',
    nombre_empresa: 'Global Consulting and Assessment Services S.A. de C.V.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'mexico',
    relacion_proyecto: ['CO034COL', 'CO035COL'],
    perfil_es:
      'Empresa registrada en México en 2016, que a su constitución tenía dos accionistas: Mónica Lara Escoto (con 4.950 acciones) y Yolanda Escoto Torales (con 50), según actas del registro mercantil mexicano. Su gerente es la auditora mexicana Bárbara Lara Escoto. Global Consulting era a su vez, a agosto de 2022, la accionista única de la empresa colombiana SPV Business S.A.S., que también interviene en el mercado de carbono y cuya representante legal es Lara Escoto. Dos proyectos desarrollados por Global Consulting han tenido problemas: primero, una investigación del CLIP de junio de 2023 reveló que el proyecto Pachamama Cumbal desarrollado junto con su filial SPV Business se ha realizado de espaldas a la comunidad indígena pasto del Resguardo de Cumbal en Nariño. Un grupo de indígenas de ese resguardo presentó una acción de tutela contra el proyecto por considerar que vulneraba sus derechos fundamentales y jueces de primera y segunda instancia les dieron la razón, suspendiendo el proyecto hasta que no resolviera su situación de consulta previa y rindiera cuentas a los indígenas sobre las ganancias. Además de ser la gerente de Global Consulting y representante legal de SPV Business, Lara Escoto fue también accionista fundadora de la auditora Deutsche Certification Body, que auditó el proyecto de Pachamama Cumbal, con lo cual no era independiente de los desarrolladores y se constituyó un posible conflicto de interés. A pesar de los fallos judiciales adversos, en 2024 el proyecto continuó transando bonos en el mercado. Una segunda investigación de mayo de 2025 reveló que el proyecto Conservando la Vida del Mundo, Mowíchina arü Maü, Ríos Cotuhé y Putumayo tiene problemas similares: además de la auditoría de que también fue auditado por Deutsche Certification Body, seis líderes indígenas del resguardo Cotuhé Putumayo denuncian no tener acceso a los documentos del proyecto ni a la rendición de cuentas de sus ingresos. Uno de ellos interpuso una acción de tutela solicitando protección de su derecho fundamental de petición; un juez le dio la razón, ordenando a Global Consulting “emitir una respuesta de fondo, clara, concreta y congruente a la petición” pues “no le asiste razón (…) al negarse a responder” las solicitudes de información. Sin embargo, Global Consulting denegó la solicitud de información argumentando que una respuesta a un derecho de petición puede ser negativa si explica las razones para ello y que la información solicitada “reúne las condiciones para ser considerada un secreto empresarial” y “tiene un valor comercial derivado de su confidencialidad”.  A mayo de 2025, los documentos de Pachamama y los de Cotuhe Putumayo seguían sin estar disponibles. ',
    perfil_en:
      'Company registered in Mexico in 2016, which at its incorporation had two shareholders: Monica Lara Escoto (with 4,950 shares) and Yolanda Escoto Torales (with 50), according to minutes of the Mexican commercial registry. Its manager is the Mexican auditor Bárbara Lara Escoto. Global Consulting was also, as of August 2022, the sole shareholder of the Colombian company SPV Business S.A.S., which is also involved in the carbon market and whose legal representative is Lara Escoto. Two projects developed by Global Consulting have had problems: first, a June 2023 CLIP investigation revealed that the Pachamama Cumbal project developed together with its subsidiary SPV Business has been carried out behind the back of the indigenous pasture community of the Cumbal reservation in Nariño. A group of indigenous people from that reservation filed a protection action against the project on the grounds that it violated their fundamental rights, and judges of first and second instance ruled in their favor, suspending the project until it resolved its prior consultation situation and accounted to the indigenous people for the profits. In addition to being the manager of Global Consulting and legal representative of SPV Business, Lara Escoto was also a founding shareholder of the audit firm Deutsche Certification Body, which audited the Pachamama Cumbal project, which meant it was not independent of the developers and constituted a possible conflict of interest. Despite the adverse court rulings, in 2024 the project continued to trade credits in the market. A second investigation in May 2025 revealed that the Conservando la Vida del Mundo, Mowíchina arü Maü, Ríos Cotuhé y Putumayo project has similar problems: in addition to the audit that was also audited by Deutsche Certification Body, six indigenous leaders of the Cotuhé Putumayo resguardo denounce not having access to project documents and accountability of their income. One of them filed a protection action requesting protection of his fundamental right to petition; a judge agreed with him, ordering Global Consulting to ""issue a substantive, clear, concrete and congruent response to the petition"" because ""it was not justified (...) in refusing to respond"" to the requests for information. However, Global Consulting denied the request for information arguing that a response to an information request can be negative if it explains the reasons for it and that the requested information ""meets the conditions to be considered a business secret"" and ""has a commercial value derived from its confidentiality"". As of May 2025, Pachamama\'s documents and those of Cotuhe Putumayo remained unavailable.',
    perfil_pt:
      'Empresa registrada no México em 2016, que na sua constituição tinha duas acionistas: Mónica Lara Escoto (com 4.950 ações) e Yolanda Escoto Torales (com 50), de acordo com as atas do registro mercantil mexicano. Sua gerente é a auditora mexicana Bárbara Lara Escoto. A Global Consulting era, em agosto de 2022, a única acionista da empresa colombiana SPV Business S.A.S., que também atua no mercado de carbono e cuja representante legal é Lara Escoto. Dois projetos desenvolvidos pela Global Consulting tiveram problemas: primeiro, uma investigação do CLIP em junho de 2023 revelou que o projeto Pachamama Cumbal, desenvolvido em conjunto com sua filial SPV Business, foi realizado às escondidas da comunidade indígena pasto da terra indígena de Cumbal, em Nariño. Um grupo de indígenas dessa terra indígena apresentou uma ação judicial contra o projeto por considerar que violava seus direitos fundamentais e os juízes de primeira e segunda instância lhes deram razão, suspendendo o projeto até que fosse resolvida a situação de consulta prévia e prestassem contas aos indígenas sobre os lucros. Além de ser gerente da Global Consulting e representante legal da SPV Business, Lara Escoto também era acionista fundadora da auditora Deutsche Certification Body, que auditou o projeto Pachamama Cumbal, o que a tornava não independente dos desenvolvedores e constituía um possível conflito de interesses. Apesar das decisões judiciais adversas, em 2024 o projeto continuou negociando créditos no mercado. Uma segunda investigação em maio de 2025 revelou que o projeto Conservando a Vida do Mundo, Mowíchina arü Maü, Ríos Cotuhé e Putumayo tem problemas semelhantes: além da auditoria da Deutsche Certification Body, seis líderes indígenas da terra indígena Cotuhé Putumayo denunciam não ter acesso aos documentos do projeto nem à prestação de contas de seus rendimentos. Um deles entrou com uma ação judicial solicitando a proteção de seu direito fundamental de petição; um juiz lhe deu razão, ordenando à Global Consulting “emitir uma resposta substantiva, clara, concreta e coerente à petição”, pois “não há razão (...) para se recusar a responder” aos pedidos de informação. No entanto, a Global Consulting negou o pedido de informação, argumentando que uma resposta a um pedido de informações pode ser negativa se explicar as razões para tal e que a informação solicitada “reúne as condições para ser considerada um segredo comercial” e “tem um valor comercial derivado da sua confidencialidade”. Em maio de 2025, os documentos da Pachamama e da Cotuhe Putumayo continuavam indisponíveis.',
  },
  {
    id_empresa: '901219191-9',
    id_empresa_carbono: 'COL0057EM',
    nombre_empresa: 'Tángara Forest S.A.S. Zomac',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO011BIO'],
    perfil_es:
      'Empresa creada en 2018 para promover actividades ambientales y turísticas, incluyendo proyectos Redd+. Sus tres socios fundadores fueron Óscar Javier Peláez González (con 51% de las acciones), Óscar Ricardo Peláez Herrera (con 24,5%) y Andrés Jordán Herrera (con 24,5%). Peláez González es un empresario del sector turístico, que ha sido gerente del Hotel Suites House Juanambú de Cali e integrante de la junta directiva del Zoológico y del Jardín Botánico de esa ciudad, además de postulante al cargo de Procurador General de la Nación en 2016. Peláez Herrera es un ingeniero industrial que lleva más de una década trabajando en la empresa de autopartes Fanalca, siendo hoy su vicepresidente de inversiones. Jordán es directivo en la caja de compensación Comfandi. Un proyecto de Tángara Forest ha estado envuelto en controversias: el proyecto Tángara REDD+ figura como desarrollado en predios privados, pero -como contó una investigación de CLIP y Rutas del Conflicto publicada en marzo de 2025- mapas oficiales muestran que incluye tierras del consejo comunitario Mayorquín y Papayal e incluso se podría traslapar con las tierras de dos más (Raposo y Bracitos y Amazonas). Dos de esas comunidades dicen haber sido excluidas de la iniciativa que tiene lugar parcialmente en su territorio. La empresa desarrolladora Tángara Forest insiste en que los documentos legales acreditan su propiedad de esos predios y que la cadena de posesión privada de esos terrenos se remonta al siglo XIX, argumentando que múltiples entidades públicas así lo han indicado, incluyendo el Ministerio del Interior que certificó, según la interpretación de la empresa, que en dichos predios no había presencia alguna de comunidades étnicas (aunque en realidad éste solo indicó que en su visión, el proyecto no requería consulta previa, libre e informada por tratarse de una iniciativa ambiental, pero no entraba a determinar si allí había comunidades étnicas). El conflicto entre la empresa y las comunidades locales que dicen no haberse beneficiado del proyecto ya llegó a manos de un juez de restitución de tierras.',
    perfil_en:
      "Company created in 2018 to promote environmental and tourism activities, including Redd+ projects. Its three founding partners were Óscar Javier Peláez González (with 51% of the shares), Óscar Ricardo Peláez Herrera (with 24.5%) and Andrés Jordán Herrera (with 24.5%). Peláez González is a businessman in the tourism sector, who has been manager of the Hotel Suites House Juanambú in Cali and member of the board of directors of the Zoo and the Botanical Garden of that city, as well as a candidate for the position of Attorney General of the Nation in 2016. Peláez Herrera is an industrial engineer who has been working for more than a decade in the auto parts company Fanalca, being today its vice president of investments. Jordán is a director at the Comfandi compensation fund. One Tángara Forest project has been mired in controversy: the Tángara REDD+ project is listed as being developed on private land, but - as a CLIP and Rutas del Conflicto investigation published in March 2025 reported - official maps show that it includes lands belonging to the Mayorquín and Papayal community councils and may even overlap with the lands of two others (Raposo and Bracitos y Amazonas). Two of these communities say they have been excluded from the initiative, which is partially taking place in their territory. The developer Tángara Forest insists that legal documents accredit its ownership of these lands and that the chain of private possession of these lands dates back to the 19th century, arguing that multiple public entities have so indicated, including the Ministry of the Interior, which certified, according to the company's interpretation, that there was no presence of ethnic communities on these lands (although in reality it only indicated that in its view, the project did not require free, prior and informed consultation because it was an environmental initiative, but did not determine whether there were ethnic communities there). The conflict between the company and the local communities that claim not to have benefited from the project has already reached the hands of a land restitution judge.",
    perfil_pt:
      'Empresa criada em 2018 para promover atividades ambientais e turísticas, incluindo projetos Redd+. Seus três sócios fundadores foram Óscar Javier Peláez González (com 51% das ações), Óscar Ricardo Peláez Herrera (com 24,5%) e Andrés Jordán Herrera (com 24,5%). Peláez González é um empresário do setor turístico, que foi gerente do Hotel Suites House Juanambú de Cali e membro do conselho de administração do Zoológico e do Jardim Botânico daquela cidade, além de candidato ao cargo de Procurador-Geral da Nação em 2016. Peláez Herrera é engenheiro industrial e trabalha há mais de uma década na empresa de autopeças Fanalca, sendo hoje seu vice-presidente de investimentos. Jordán é diretor da caixa de compensação Comfandi. Um projeto da Tángara Forest tem estado envolvido em controvérsias: o projeto Tángara REDD+ figura como desenvolvido em terrenos privados, mas, conforme revelou uma investigação do CLIP e do Rutas del Conflicto publicada em março de 2025, mapas oficiais mostram que ele inclui terras do conselho comunitário de Mayorquín e Papayal e pode até se sobrepor às terras de mais duas comunidades (Raposo e Bracitos e Amazonas). Duas dessas comunidades afirmam ter sido excluídas da iniciativa que ocorre parcialmente em seu território. A empresa desenvolvedora Tángara Forest insiste que os documentos legais comprovam sua propriedade dessas terras e que a cadeia de posse privada desses terrenos remonta ao século XIX, argumentando que várias entidades públicas assim o indicaram, incluindo o Ministério do Interior, que certificou, segundo a interpretação da empresa, que nesses terrenos não havia presença de comunidades étnicas (embora, na verdade, ele apenas indicasse que, em sua visão, o projeto não exigia consulta prévia, livre e informada por se tratar de uma iniciativa ambiental, mas não determinava se havia comunidades étnicas no local). O conflito entre a empresa e as comunidades locais que afirmam não ter se beneficiado do projeto já chegou às mãos de um juiz de restituição de terras.',
  },
  {
    id_empresa: '901418237-2',
    id_empresa_carbono: 'COL0072EM',
    nombre_empresa: 'SPV Business S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO035COL'],
    perfil_es:
      'Empresa creada en septiembre de 2020. Desde agosto de 2022 lista, según documentos de cámara de comercio, a la empresa mexicana Global Consulting and Assessment Services S.A. de C.V. como su accionista única y desde marzo de 2021 lista como representante legal a la ciudadana mexicana Bárbara Lara Escoto, gerente de Global Consulting. Junto con Global Consulting, SPV Business es la desarrolladora involucrada en el proyecto Pachamama Cumbal que -como contó una investigación del CLIP- fue desarrollado a espaldas de la comunidad indígena pasto del Resguardo de Cumbal en Nariño. Un grupo de indígenas de ese resguardo presentó una acción de tutela contra el proyecto por considerar que vulneraba sus derechos fundamentales y jueces de primera y segunda instancia les dieron la razón, suspendiendo el proyecto hasta que no resolviera su situación de consulta previa y rindiera cuentas a los indígenas sobre las ganancias. Además de ser la cabeza visible del proyecto, Lara Escoto fue también accionista fundadora de la auditora Deutsche Certification Body, que auditó el proyecto de Pachamama Cumbal, con lo cual no era independiente de los desarrolladores y se constituyó un posible conflicto de interés. Adicionalmente, Diana Carolina Avella Ostos —quien figuró como representante legal suplente de SPV Business entre marzo de 2021 y noviembre de 2023— ocupó también ese mismo cargo en Deutsche Certification Body entre marzo de 2021 y marzo de 2022, según consta en actas de cámara de comercio, con lo cual podría haber un segundo conflicto de interés. A pesar de los fallos judiciales adversos, en 2024 el proyecto continuó transando bonos en el mercado.',
    perfil_en:
      'Company created in September 2020. Since August 2022 it lists, according to chamber of commerce documents, the Mexican company Global Consulting and Assessment Services S.A. de C.V. as its sole shareholder and since March 2021 it lists Mexican citizen Barbara Lara Escoto, manager of Global Consulting, as its legal representative. Together with Global Consulting, SPV Business is the developer involved in the Pachamama Cumbal project, which, as a CLIP investigation has shown, was developed behind the back of the indigenous pasture community of the Cumbal reservation in Nariño. A group of indigenous people from that reservation filed a protection action against the project on the grounds that it violated their fundamental rights, and judges of first and second instance ruled in their favor, suspending the project until it resolved its prior consultation situation and accounted to the indigenous people for the profits. In addition to being the visible head of the project, Lara Escoto was also a founding shareholder of the audit firm Deutsche Certification Body, which audited the Pachamama Cumbal project, which meant that it was not independent from the developers and constituted a possible conflict of interest. Additionally, Diana Carolina Avella Ostos -who appeared as alternate legal representative of SPV Business between March 2021 and November 2023- also held the same position in Deutsche Certification Body between March 2021 and March 2022, according to the minutes of the Chamber of Commerce, so there could be a second conflict of interest. Despite the adverse court rulings, in 2024 the project continued to trade credits in the market.',
    perfil_pt:
      'Empresa criada em setembro de 2020. Desde agosto de 2022, segundo documentos da Câmara de Comércio, a empresa mexicana Global Consulting and Assessment Services S.A. de C.V. figura como sua única acionista e, desde março de 2021, a cidadã mexicana Bárbara Lara Escoto, gerente da Global Consulting, figura como sua representante legal. Juntamente com a Global Consulting, a SPV Business é a empresa desenvolvedora envolvida no projeto Pachamama Cumbal que, conforme revelou uma investigação do CLIP, foi desenvolvido às escondidas da comunidade indígena pasto da terra indígena de Cumbal, em Nariño. Um grupo de indígenas dessa terra indígena apresentou uma ação judicial contra o projeto por considerar que violava seus direitos fundamentais e os juízes de primeira e segunda instância lhes deram razão, suspendendo o projeto até que fosse resolvida a situação de consulta prévia e prestassem contas aos indígenas sobre os lucros. Além de ser a cabeça visível do projeto, Lara Escoto também era acionista fundadora da auditora Deutsche Certification Body, que auditou o projeto Pachamama Cumbal, o que a tornava não independente dos desenvolvedores e constituía um possível conflito de interesses. Além disso, Diana Carolina Avella Ostos — que atuou como representante legal suplente da SPV Business entre março de 2021 e novembro de 2023 — também ocupou o mesmo cargo na Deutsche Certification Body entre março de 2021 e março de 2022, conforme consta nas atas da Câmara de Comércio, o que poderia constituir um segundo conflito de interesses. Apesar das decisões judiciais adversas, em 2024 o projeto continuou negociando créditos no mercado.',
  },
  {
    id_empresa: '900035226-3',
    id_empresa_carbono: 'COL0025EM',
    nombre_empresa: 'Corporación Territorio y Ambiente',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO042COL'],
    perfil_es:
      'Fundación creada en 2013 y registrada en Cali con el ánimo, según su página web, de ""promover el manejo planificado y monitoreado de los recursos naturales"". A enero de 2022, contaba -según un acta de cámara de comercio- con cinco asociados: su director ejecutivo César Andrés Paz Suárez, Edwin Arango Muñoz, Henry Rodríguez García, Laura Oliva Sánchez Nupan y Adolfo León Martínez Astudillo. Anteriormente figuraron en su junta Carlos Acosta Pinzón, Gabriel Jhon Tabón Quintero, Lucidia Ramírez Giraldo, Lina Fernanda González Higuera y Ruth Amparo Eraso Caicedo. Lidera dos proyectos Redd+ en Guainía.',
    perfil_en:
      'Foundation created in 2013 and registered in Cali with the aim, according to its website, of ""promoting the planned and monitored management of natural resources"". As of January 2022, it had - according to a chamber of commerce act - five associates: its executive director César Andrés Paz Suárez, Edwin Arango Muñoz, Henry Rodríguez García, Laura Oliva Sánchez Nupan and Adolfo León Martínez Astudillo. Previous board members include Carlos Acosta Pinzón, Gabriel Jhon Tabón Quintero, Lucidia Ramírez Giraldo, Lina Fernanda González Higuera and Ruth Amparo Eraso Caicedo. It leads two Redd+ projects in Guainía.',
    perfil_pt:
      'Fundação criada em 2013 e registrada em Cali com o objetivo, segundo seu site, de “promover o manejo planejado e monitorado dos recursos naturais”. Em janeiro de 2022, contava, segundo uma ata da Câmara de Comércio, com cinco associados: seu diretor executivo César Andrés Paz Suárez, Edwin Arango Muñoz, Henry Rodríguez García, Laura Oliva Sánchez Nupan e Adolfo León Martínez Astudillo. Anteriormente, faziam parte do seu conselho Carlos Acosta Pinzón, Gabriel Jhon Tabón Quintero, Lucidia Ramírez Giraldo, Lina Fernanda González Higuera e Ruth Amparo Eraso Caicedo. Lidera dois projetos Redd+ em Guainía.',
  },
  {
    id_empresa: '900980314-6',
    id_empresa_carbono: 'COL0049EM',
    nombre_empresa: 'Oviedo S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO152CER', 'CO156CER'],
    perfil_es:
      'Empresa creada en 2016, que se describe en su página web como una ""compañía familiar con más de 7 años de experiencia en servicios ambientales, especializados en consultoría e ingeniería"". Contaba con tres accionistas a marzo de 2021: su actual representante legal Miguel Ángel Colmenares Oviedo, Juan Camilo Colmenares Oviedo y Heidy Daniela Colmenares Oviedo, cada uno con 33% de las acciones (después de que una cuarta socia fundadora y actual coordinadora de proyectos, Sandra Helena Oviedo Marroquín, les cediera sus acciones), según actas de cámara de comercio. Tiene un proyecto activo en Guainía. Es integrante de Asocarbono, el gremio de actores del mercado de carbono en Colombia.',
    perfil_en:
      'A company created in 2016, which describes itself on its website as a ""family company with more than 7 years of experience in environmental services, specializing in consulting and engineering."" It had three shareholders as of March 2021: its current legal representative Miguel Ángel Colmenares Oviedo, Juan Camilo Colmenares Oviedo and Heidy Daniela Colmenares Oviedo, each with 33% of the shares (after a fourth founding partner and current project coordinator, Sandra Helena Oviedo Marroquín, ceded her shares to them), according to chamber of commerce minutes. It has an active project in Guainía. It is a member of Asocarbono, the guild of actors in the carbon market in Colombia.',
    perfil_pt:
      'Empresa criada em 2016, que se descreve em seu site como uma “empresa familiar com mais de 7 anos de experiência em serviços ambientais, especializada em consultoria e engenharia”. Em março de 2021, contava com três acionistas: seu atual representante legal Miguel Ángel Colmenares Oviedo, Juan Camilo Colmenares Oviedo e Heidy Daniela Colmenares Oviedo, cada um com 33% das ações (depois que uma quarta sócia fundadora e atual coordenadora de projetos, Sandra Helena Oviedo Marroquín, cedeu suas ações), de acordo com os registros da Câmara de Comércio. Tem um projeto ativo em Guainía. É membro da Asocarbono, a associação comercial dos atores do mercado de carbono na Colômbia.',
  },
  {
    id_empresa: '901476564-3',
    id_empresa_carbono: 'COL0073EM',
    nombre_empresa: 'Fuinssaenq S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO102BIO', 'CO4419VER'],
    perfil_es:
      'Empresa creada en abril de 2021 con el objeto de impulsar proyectos ambientales y del mercado de carbono. A octubre de 2024 contaba con dos empresas socias: ENQ S.A.S. con el 57,5% de las acciones (tras haber sido la accionista única al momento de la constitución) y Stags Business S.A.S. (representada por Steward Alexis García Solano) con un 42,5%. ENQ S.A.S. fue constituida en 2012 y, a abril de 2013, sus socios accionistas eran Olbany Fernando Muñoz Delgado (quien también es el representante legal de Fuinssaenq) y Myriam Rocío Melgarejo Prieto. Por su parte, Anteriormente tuvo otras dos empresas como socias: Depósito y Construcciones Ingeniería S.A.S. (también conocida como DYC Ingeniería) representada por Videhicy Solano Herrera y Fundación Internacional para la Sostenibilidad Socio Ambiental (Fuinssa), cuyo número tributario está asociado a la empresa Fuinssa Colombia Limited. Esta última era la filial colombiana de otra empresa británica del mismo nombre, creada para comercializar los servicios de una fintech con enfoque ambiental llamada Quayambaya Fintech Ecosystem & BNHE Concept, y tenía como representante legal en Colombia a Juan Eduardo García Trejos, un ex candidato a diputado en la asamblea departamental de Vichada en 2015 quye también ha sido representante legal y accionista de otra empresa ambiental llamada Kilama Consultoría S.A.S. y que -como contó una investigación del CLIP- es socio de la también desarrolladora de proyectos de carbono Oxigreen, que buscaba formular un proyecto Redd+ en el resguardo Nonuya de Villazul y era liderada a enero de 2023 por un político llamado Henry Silva Meche que fue sancionado por mal manejo administrativo y estuvo inhabilitado por cinco años para ejercer funciones públicas y contratar con el Estado. Fuinssaenq no tiene página web.',
    perfil_en:
      'Company created in April 2021 with the aim of promoting environmental and carbon market projects. As of October 2024, it had two partner companies: ENQ S.A.S. with 57.5% of the shares (having been the sole shareholder at the time of incorporation) and Stags Business S.A.S. (represented by Steward Alexis García Solano) with 42.5%. ENQ S.A.S. was incorporated in 2012 and, as of April 2013, its shareholder partners were Olbany Fernando Muñoz Delgado (who is also the legal representative of Fuinssaenq) and Myriam Rocío Melgarejo Prieto. Previously, it had two other companies as partners: Depósito y Construcciones Ingeniería S.A.S. (also known as DYC Ingeniería) represented by Videhicy Solano Herrera and Fundación Internacional para la Sostenibilidad Socio Ambiental (Fuinssa), whose tax number is associated with the company Fuinssa Colombia Limited. The latter was the Colombian subsidiary of another British company of the same name, created to market the services of a fintech with an environmental focus called Quayambaya Fintech Ecosystem & BNHE Concept, and had as its legal representative in Colombia Juan Eduardo García Trejos, a former candidate for deputy in the departmental assembly of Vichada in 2015 who has also been legal representative and shareholder of another environmental company called Kilama Consultoría S.A.S. and who - as a CLIP investigation told - is a partner of the also carbon project developer Oxigreen, which sought to formulate a Redd+ project in the Nonuya de Villazul reservation and was led as of January 2023 by a politician named Henry Silva Meche who was sanctioned for administrative mismanagement and was disqualified for five years to exercise public functions and contract with the State. Fuinssaenq does not have a website.',
    perfil_pt:
      'Empresa criada em abril de 2021 com o objetivo de promover projetos ambientais e do mercado de carbono. Em outubro de 2024, contava com duas empresas parceiras: ENQ S.A.S., com 57,5% das ações (após ter sido a única acionista no momento da constituição) e Stags Business S.A.S. (representada por Steward Alexis García Solano), com 42,5%. A ENQ S.A.S. foi constituída em 2012 e, em abril de 2013, seus acionistas eram Olbany Fernando Muñoz Delgado (que também é o representante legal da Fuinssaenq) e Myriam Rocío Melgarejo Prieto. Por sua vez, anteriormente tinha outras duas empresas como sócias: Depósito y Construcciones Ingeniería S.A.S. (também conhecida como DYC Ingeniería), representada por Videhicy Solano Herrera, e Fundación Internacional para la Sostenibilidad Socio Ambiental (Fuinssa), cujo número fiscal está associado à empresa Fuinssa Colombia Limited. Esta última era a filial colombiana de outra empresa britânica com o mesmo nome, criada para comercializar os serviços de uma fintech com foco ambiental chamada Quayambaya Fintech Ecosystem & BNHE Concept, e tinha como representante legal na Colômbia Juan Eduardo García Trejos, um ex-candidato a deputado na assembleia departamental de Vichada em 2015, que também foi representante legal e acionista de outra empresa ambiental chamada Kilama Consultoría S.A.S. e que - conforme revelou uma investigação do CLIP - é sócio da Oxigreen, também desenvolvedora de projetos de carbono, que buscava formular um projeto Redd+ na terra indígena Nonuya de Villazul e era liderada, em janeiro de 2023, por um político chamado Henry Silva Meche, que foi punido por má gestão administrativa e ficou inabilitado por cinco anos para exercer funções públicas e contratar com o Estado. Fuinssaenq não possui página na internet.',
  },
  {
    id_empresa: '901485384-2',
    id_empresa_carbono: 'COL0074EM',
    nombre_empresa: 'Pronatura Ventures S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO046COL', 'CO053COL', 'CO054COL'],
    perfil_es:
      'Empresa constituida en Bogotá en 2021 con el nombre Empresa de Movilidad de Bogotá Consultores S.A.S. (EMB Consultores S.A.S.), pero que en febrero de 2022 pasó a llamarse Pronatura Ventures S.A.S.. Su accionista único a febrero de 2022 era su representante legal Emerson Leonardo Durán Vargas, cuya trayectoria ha estado sobre todo en el sector de infraestructura como gerente financiero de la Agencia Nacional de Infraestructura (ANI) y como gerente de proyectos especiales en la Empresa de Energía de Bogotá. A raíz de su paso por la ANI, Durán aparece mencionado en la investigación de la Fiscalía General de la Nación sobre el escándalo de corrupción protagonizado por la corrupta multinacional brasilera Odebrecht. Fue formalizada una acusación en contra suyo en febrero de 2025, sin que haya aún una decisión judicial. Durán también figura como representante legal de la empresa CO2 Index Colombia. Pronatura Venturas aparece desarrollando tres proyectos Redd+, todos en Guainía, aunque apenas uno de ellos aparecía a agosto de 2024 como en fase de formulación y los otros dos figuraban como retirados.',
    perfil_en:
      "Company incorporated in Bogotá in 2021 under the name Empresa de Movilidad de Bogotá Consultores S.A.S. (EMB Consultores S.A.S.), but renamed Pronatura Ventures S.A.S. in February 2022. Its sole shareholder as of February 2022 was its legal representative Emerson Leonardo Durán Vargas, whose career has been mainly in the infrastructure sector as financial manager of the National Infrastructure Agency (ANI) and as manager of special projects at Empresa de Energía de Bogotá. As a result of his time at ANI, Durán is mentioned in the investigation of the Attorney General's Office into the corruption scandal involving the corrupt Brazilian multinational Odebrecht. He was formally charged in February 2025, without there being a court decision yet. Durán is also listed as the legal representative of the company CO2 Index Colombia. Pronatura Venturas is listed as developing three Redd+ projects, all in Guainía, although only one of them appeared as of August 2024 as being in the formulation phase and the other two were listed as withdrawn.",
    perfil_pt:
      'Empresa constituída em Bogotá em 2021 com o nome Empresa de Movilidad de Bogotá Consultores S.A.S. (EMB Consultores S.A.S.), mas que em fevereiro de 2022 passou a se chamar Pronatura Ventures S.A.S.. Seu único acionista em fevereiro de 2022 era seu representante legal Emerson Leonardo Durán Vargas, cuja trajetória se desenvolveu principalmente no setor de infraestrutura como gerente financeiro da Agência Nacional de Infraestrutura (ANI) e como gerente de projetos especiais na Empresa de Energia de Bogotá. Devido ao seu passagem pela ANI, Durán é mencionado na investigação do Ministério Público Federal sobre o escândalo de corrupção envolvendo a multinacional brasileira Odebrecht. Uma acusação formal contra ele foi apresentada em fevereiro de 2025, sem que ainda haja uma decisão judicial. Durán também figura como representante legal da empresa CO2 Index Colombia. A Pronatura Venturas aparece desenvolvendo três projetos Redd+, todos em Guainía, embora apenas um deles aparecesse em agosto de 2024 como em fase de formulação e os outros dois constassem como retirados.',
  },
  {
    id_empresa: '901527918-7',
    id_empresa_carbono: 'COL0078EM',
    nombre_empresa: 'ACT America Carbon Trading S.A.S. (Bioact)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO047COL'],
    perfil_es:
      'Empresa constituida en Bogotá en octubre de 2021 para, según su página web, ""proyectos que actúen en favor de las comunidades y su relación con las emisiones y captura de dióxido de carbono"". Fue fundada, según su acta de creación, por cuatro socios accionistas: Jimmy Alexander Ruiz Vásquez y Carlos Julio Benavides Sabogal, cada uno con un 37% de las acciones, así como Jacinto Fonseca Pedreros y Oscar Yesid Florián Caro, cada uno con un 13%. En febrero de 2023, hubo un ligero cambio en su composición accionaria: Carlos Julio Benavides Sabogal mantuvo un 37%, Jimmy Alexander Ruiz Vásquez pasó a tener 33%, Oscar Yesid Florián Caro quedó con 10% y entró como accionista con un 20% la empresa Q&Q Legal S.A.S. (también conocida como Quintero y Quintero Abogados S.A.S., cuyos accionistas a marzo de 2022 eran a su vez Maritza del Socorro Quintero Jiménez con 60% de las acciones y Luis Alejandro Quintero Sáenz con 40% de las acciones).',
    perfil_en:
      'Company incorporated in Bogota in October 2021 for, according to its website, ""projects that act in favor of communities and their relationship with carbon dioxide emissions and sequestration"". It was founded, according to its articles of incorporation, by four shareholder partners: Jimmy Alexander Ruiz Vásquez and Carlos Julio Benavides Sabogal, each with 37% of the shares, as well as Jacinto Fonseca Pedreros and Oscar Yesid Florián Caro, each with 13%. In February 2023, there was a slight change in its shareholder composition: Carlos Julio Benavides Sabogal maintained 37%, Jimmy Alexander Ruiz Vásquez became 33%, Oscar Yesid Florián Caro remained with 10% and the company Q&Q Legal S.A.S. (also known as Quintero y Quintero Abogados S.A.S.) entered as a shareholder with 20%, whose shareholders as of March 2022 were in turn Maritza del Socorro Quintero Jiménez with 60% of the shares and Luis Alejandro Quintero Sáenz with 40% of the shares).',
    perfil_pt:
      'Empresa constituída em Bogotá em outubro de 2021 para, segundo seu site, “projetos que atuem em favor das comunidades e sua relação com as emissões e captura de dióxido de carbono”. Foi fundada, de acordo com sua escritura de constituição, por quatro sócios acionistas: Jimmy Alexander Ruiz Vásquez e Carlos Julio Benavides Sabogal, cada um com 37% das ações, bem como Jacinto Fonseca Pedreros e Oscar Yesid Florián Caro, cada um com 13%. Em fevereiro de 2023, houve uma ligeira alteração na sua composição acionista: Carlos Julio Benavides Sabogal manteve 37%, Jimmy Alexander Ruiz Vásquez passou a ter 33%, Oscar Yesid Florián Caro ficou com 10% e entrou como acionista com 20% a empresa Q&Q Legal S.A.S. (também conhecida como Quintero y Quintero Abogados S.A.S., cujos acionistas em março de 2022 eram Maritza del Socorro Quintero Jiménez, com 60% das ações, e Luis Alejandro Quintero Sáenz, com 40% das ações).',
  },
  {
    id_empresa: '901703511-8',
    id_empresa_carbono: 'COL0085EM',
    nombre_empresa: 'CO2 Sostenible S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO089BIO'],
    perfil_es:
      'Empresa creada en 2023 en Bogotá con el objeto de promover actividades de conservación y administración de recursos naturales. Su accionista único al momento de su constitución era su gerente y representante leal Luz Ángela Palacios Campuzano, quien ha estado vinculada a un proyecto Redd+ con problemas: la iniciativa Bosque Galilea Amé desarrollado por la Fundación Amé en alianza con la Universidad del Tolima, de la que -como reveló una investigación del CLIP y Rutas del Conflicto publicada en febrero de 2024- una veintena campesinos que han vivido en esta zona forestal desde la década de 1950 dicen haber quedado por fuera y cuyas preguntas motivaron que la Contraloría Departamental del Tolima convocara una audiencia pública en febrero de 2023. Palacios ha estado vinculada a varias de las entidades que participan en dicho proyecto, incluyendo como ex representante legal y ex vicepresidenta de Amé, representante legal y accionista de Ecocarbono S.A.S. Zomac (encargada de desarrollar los proyectos y actividades de conservación), gerente y miembro suplente de la junta directiva de Grupo Seratta (grupo de restaurantes que fueron los primeres compradores de bonos de carbono del proyecto Galilea) y subgerente e integrante de la junta directiva de El Cielo Construcciones S.A.S. (que representa el fondo fiduciario al que pertenecen los propietarios de 139 predios firmaron acuerdos de conservación con la Fundación Amé). Al menos dos personas que también han estado vinculadas a entidades en Bosque Galilea Amé figuran en los documentos de CO2 Sostenible S.A.S.: su representante legal suplente Luz Marina Campuzano Jaramillo era la representante legal suplente a agosto de 2024 de la Fundación Amé, así como accionista y representante legal de Ecocarbono S.A.S. Zomac, mientras el abogado que recibió un poder de Palacios Campuzano para actuaciones ligadas a la empresa, Pedro Jahaziel Amaya Medina, fue cofundador y era el representante legal a agosto de 2024 de la Fundación Amé. CO2 Sostenible aparece como desarrolladora del proyecto REDD+ Nunuya de Villa Azul Amenanae en alianza con la empresa Oxigreen, cuyo gerente y representante legal Henry Silva Meche fue -según encontró una investigación del CLIP- hallado por la Contraloría General de la República responsable de detrimento patrimonial en 2018 por no haber vigilado un contrato una década atrás mientras era funcionario de la Gobernación de Casanare y, como consecuencia de ello, inhabilitado por la Procuraduría General de la Nación por 5 años para desempeñar cargos públicos y para contratar con el Estado, que finalizaron en agosto de 2023. La empresa no tiene página web.',
    perfil_en:
      "Company created in 2023 in Bogota with the purpose of promoting conservation and natural resource management activities. Its sole shareholder at the time of its incorporation was its manager and loyal representative Luz Ángela Palacios Campuzano, who has been linked to a troubled Redd+ project: The Galilea Amé Forest initiative developed by the Amé Foundation in alliance with the University of Tolima, from which - as revealed in an investigation by CLIP and Rutas del Conflicto published in February 2024 - a group of small-scale farmers who have lived in this forest area since the 1950s claim to have been left out and whose questions prompted the Tolima Departmental Comptroller's Office to convene a public hearing in February 2023. Palacios has been linked to several of the entities involved in the project, including as former legal representative and former vice-president of Amé, legal representative and shareholder of Ecocarbono S.A.S. Zomac (in charge of developing the conservation projects and activities), manager and alternate board member of Grupo Seratta (a group of restaurants that were the first buyers of carbon credits from the Galilea project) and assistant manager and board member of El Cielo Construcciones S.A.S. (which represents the trust fund to which the owners of 139 properties signed conservation agreements with the Amé Foundation belong). At least two people who have also been linked to entities in Bosque Galilea Amé appear in the documents of CO2 Sostenible S.A.S.: its alternate legal representative Luz Marina Campuzano Jaramillo was the alternate legal representative as of August 2024 of Fundación Amé, as well as shareholder and legal representative of Ecocarbono S.A.S. Zomac, while the lawyer who received a power of attorney from Palacios Campuzano for actions related to the company, Pedro Jahaziel Amaya Medina, was co-founder and legal representative as of August 2024 of Fundación Amé. CO2 Sostenible appears as developer of the REDD+ Nunuya de Villa Azul Amenanae project in alliance with the company Oxigreen, whose manager and legal representative Henry Silva Meche was -according to a CLIP investigation- found by the Comptroller General of the Republic responsible for patrimonial detriment in 2018 for not having monitored a contract a decade ago while he was an official of the Governor's Office of Casanare and, as a consequence, disqualified by the Procuraduría General de la Nación for 5 years to hold public office and to contract with the State, which ended in August 2023. The company does not have a website.",
    perfil_pt:
      'Empresa criada em 2023 em Bogotá com o objetivo de promover atividades de conservação e gestão de recursos naturais. Sua única acionista no momento da constituição era sua gerente e representante leal Luz Ángela Palacios Campuzano, que esteve ligada a um projeto Redd+ com problemas: a iniciativa Bosque Galilea Amé, desenvolvida pela Fundação Amé em parceria com a Universidade do Tolima, da qual - como revelou uma investigação do CLIP e Rutas del Conflicto publicada em fevereiro de 2024 - cerca de vinte pequenos agricultores que vivem nesta zona florestal desde a década de 1950 afirmam ter sido excluídos e cujas perguntas motivaram a Contraloria Departamental de Tolima a convocar uma audiência pública em fevereiro de 2023. Palacios esteve ligada a várias das entidades que participam do projeto, incluindo como ex-representante legal e ex-vice-presidente da Amé, representante legal e acionista da Ecocarbono S.A.S. Zomac (responsável pelo desenvolvimento dos projetos e atividades de conservação), gerente e membro suplente do conselho de administração do Grupo Seratta (grupo de restaurantes que foram os primeiros compradores de bonos de carbono do projeto Galilea) e subgerente e membro do conselho de administração da El Cielo Construcciones S.A.S. (que representa o fundo fiduciário ao qual pertencem os proprietários de 139 terrenos que assinaram acordos de conservação com a Fundação Amé). Pelo menos duas pessoas que também estiveram ligadas a entidades em Bosque Galilea Amé constam nos documentos da CO2 Sostenible S.A.S.: sua representante legal suplente, Luz Marina Campuzano Jaramillo, era a representante legal suplente até agosto de 2024 da Fundação Amé, bem como acionista e representante legal da Ecocarbono S.A.S. Zomac, enquanto o advogado que recebeu uma procuração de Palacios Campuzano para atuar em nome da empresa, Pedro Jahaziel Amaya Medina, foi cofundador e era o representante legal até agosto de 2024 da Fundação Amé. A CO2 Sostenible aparece como desenvolvedora do projeto REDD+ Nunuya de Villa Azul Amenanae em parceria com a empresa Oxigreen, cujo gerente e representante legal, Henry Silva Meche, foi - segundo uma investigação do CLIP, responsável por prejuízo patrimonial em 2018 por não ter fiscalizado um contrato uma década atrás, enquanto era funcionário da Prefeitura de Casanare e, como consequência, foi inabilitado pela Procuradoria Geral da Nação por 5 anos para exercer cargos públicos e contratar com o Estado, que terminaram em agosto de 2023. A empresa não possui página na internet.',
  },
  {
    id_empresa: '901739577-9',
    id_empresa_carbono: 'COL0086EM',
    nombre_empresa: 'Quye Wyna S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO089BIO'],
    perfil_es:
      'Empresa creada en 2023 en Bogotá con el objeto de promover actividades de conservación y manejo sostenible de recursos naturales. Su accionista único al momento de su constitución era su gerente y representante leal Carlos Eduardo Abondano Leal, quien trabajó con dos entidades estatales del sector ambiental, Parques Nacionales Naturales y el Instituto Amazónico de Investigaciones Científicas Sinchi. Quye Wyna aparece como desarrolladora del proyecto REDD+ Nunuya de Villa Azul Amenanae en alianza con la empresa Oxigreen, cuyo gerente y representante legal Henry Silva Meche fue -según encontró una investigación del CLIP- hallado por la Contraloría General de la República responsable de detrimento patrimonial en 2018 por no haber vigilado un contrato una década atrás mientras era funcionario de la Gobernación de Casanare y, como consecuencia de ello, inhabilitado por la Procuraduría General de la Nación por 5 años para desempeñar cargos públicos y para contratar con el Estado, que finalizaron en agosto de 2023. La empresa no tiene página web.',
    perfil_en:
      "Company created in 2023 in Bogotá with the purpose of promoting conservation activities and sustainable management of natural resources. Its sole shareholder at the time of its incorporation was its manager and loyal representative Carlos Eduardo Abondano Leal, who worked with two state entities in the environmental sector, Parques Nacionales Naturales and Instituto Amazónico de Investigaciones Científicas Sinchi. Quye Wyna appears as developer of the REDD+ Nunuya de Villa Azul Amenanae project in alliance with the company Oxigreen, whose manager and legal representative Henry Silva Meche was -according to a CLIP investigation- found by the Comptroller General of the Republic responsible for patrimonial detriment in 2018 for not having monitored a contract a decade ago while he was an official of the Governor's Office of Casanare and, as a consequence, disqualified by the Procuraduría General de la Nación for 5 years to hold public office and to contract with the State, which ended in August 2023. The company does not have a website.",
    perfil_pt:
      'Empresa criada em 2023 em Bogotá com o objetivo de promover atividades de conservação e gestão sustentável dos recursos naturais. Seu único acionista na época da constituição era seu gerente e representante legal Carlos Eduardo Abondano Leal, que trabalhou com duas entidades estatais do setor ambiental, Parques Nacionais Naturais e o Instituto Amazônico de Pesquisas Científicas Sinchi. Quye Wyna aparece como desenvolvedora do projeto REDD+ Nunuya de Villa Azul Amenanae em parceria com a empresa Oxigreen, cujo gerente e representante legal, Henry Silva Meche, foi - segundo uma investigação do CLIP, responsável por prejuízo patrimonial em 2018 por não ter fiscalizado um contrato uma década atrás, enquanto era funcionário da Prefeitura de Casanare e, como consequência, inabilitado pela Procuradoria Geral da Nação por 5 anos para exercer cargos públicos e para contratar com o Estado, que terminaram em agosto de 2023. A empresa não possui página na internet.',
  },
  {
    id_empresa: '900064749-7',
    id_empresa_carbono: 'COL0026EM',
    nombre_empresa:
      'Patrimonio Natural – Fondo para la Biodiversidad y las Áreas Protegidas (Fondo Patrimonio Natural)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1806VER'],
    perfil_es:
      'Organización sin ánimo de lucro ambiental fundada en 2006 con el ánimo de ""fortalecer la sostenibilidad financiera del Sistema Nacional de Áreas Protegidas (SINAP) y otras estrategias de ordenamiento ambiental del territorio, bajo esquemas de gobernanza pública, privada y comunitaria"". Liderada por su director ejecutivo, el economista ambiental Francisco Alberto Galán, y su subdirectora técnica, la antropóloga Inés Cavelier.\n',
    perfil_en:
      'Environmental non-profit organization founded in 2006 with the aim of ""strengthening the financial sustainability of the National System of Protected Areas (SINAP) and other strategies for environmental management of the territory, under public, private and community governance schemes"". It is led by its executive director, environmental economist Francisco Alberto Galán, and its technical deputy director, anthropologist Inés Cavelier.',
    perfil_pt:
      'Organização ambiental sem fins lucrativos fundada em 2006 com o objetivo de “fortalecer a sustentabilidade financeira do Sistema Nacional de Áreas Protegidas (SINAP) e outras estratégias de ordenamento ambiental do território, sob esquemas de governança pública, privada e comunitária”. Liderada por seu diretor executivo, o economista ambiental Francisco Alberto Galán, e sua subdiretora técnica, a antropóloga Inés Cavelier.',
  },
  {
    id_empresa: '900792408-3',
    id_empresa_carbono: 'COL0042EM',
    nombre_empresa:
      'The Interchurch Organization for Development Cooperation (ICCO Cooperation)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO1806VER'],
    perfil_es:
      'Oficina en Colombia de la organización sin ánimo de lucro holandesa del mismo nombre. Desde 2021, ICCO se unió a otra organización sin ánimo de lucro holandesa de origen cristiano, Cordaid, para trabajar juntas bajo el nombre de la segunda. Tienen su sede central en La Haya y oficinas regionales en Colombia, Bolivia y Nicaragua, en América Latina.',
    perfil_en:
      "Colombia office of the Dutch non-profit organization of the same name. Since 2021, ICCO has joined with another Dutch non-profit organization of Christian origin, Cordaid, to work together under the latter's name. They are headquartered in The Hague and have regional offices in Colombia, Bolivia and Nicaragua in Latin America.",
    perfil_pt:
      'Escritório na Colômbia da organização sem fins lucrativos holandesa de mesmo nome. Desde 2021, a ICCO se uniu a outra organização sem fins lucrativos holandesa de origem cristã, a Cordaid, para trabalhar em conjunto sob o nome desta última. Tem sede em Haia e escritórios regionais na Colômbia, Bolívia e Nicarágua, na América Latina.',
  },
  {
    id_empresa: '901695837-8',
    id_empresa_carbono: 'COL0084EM',
    nombre_empresa: 'Maguares Zomac S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO052BIO'],
    perfil_es:
      'Empresa creada en 2023 y registrada en Florencia, con el objeto de ""la preservación y conservación (...) de recursos naturales"" y la ""venta de bonos de carbono"". A abril de 2023 contaba con un accionista único: su fundador y representante legal inicial Carlos Eduardo Abondano Leal. A noviembre de 2024, su representante legal era Luz Angela Palacios Campuzano y su representante legal suplente Pedro Jahaziel Amaya Medina, ambos vinculados a la Fundación Amé que desarrolla el proyecto Bosque Galilea - Amé en Tolima, que como reveló una investigación de CLIP y Rutas del Conflicto publicada en febrero de 2024, una veintena campesinos que han vivido en la zona del proyecto Bosque Galilea-Amé desde la década de 1950 dicen haber quedado por fuera del proyecto y sus preguntas motivaron que la Contraloría Departamental del Tolima convocara una audiencia pública en febrero de 2023',
    perfil_en:
      'Company created in 2023 and registered in Florencia, with the purpose of ""the preservation and conservation (...) of natural resources"" and the ""sale of carbon credits"". As of April 2023 it had a sole shareholder: its founder and initial legal representative Carlos Eduardo Abondano Leal. As of November 2024, its legal representative was Luz Angela Palacios Campuzano and its alternate legal representative Pedro Jahaziel Amaya Medina, both linked to the Amé Foundation that develops the Bosque Galilea - Amé project in Tolima, which as revealed in an investigation by CLIP and Rutas del Conflicto published in February 2024, some twenty peasants who have lived in the area of the Bosque Galilea-Amé project since the 1950s say they have been left out of the project and their questions prompted the Tolima Departmental Comptroller\'s Office to call a public hearing in February 2023.',
    perfil_pt:
      'Empresa criada em 2023 e registrada em Florencia, com o objetivo de “preservar e conservar (...) recursos naturais” e “vender créditos de carbono”. Em abril de 2023, tinha um único acionista: seu fundador e representante legal inicial, Carlos Eduardo Abondano Leal. Em novembro de 2024, sua representante legal era Luz Angela Palacios Campuzano e seu representante legal suplente Pedro Jahaziel Amaya Medina, ambos ligados à Fundação Amé, que desenvolve o projeto Bosque Galilea - Amé em Tolima, que, como revelou uma investigação do CLIP e Rutas del Conflicto publicada em fevereiro de 2024, cerca de vinte pequenos agricultores que vivem na zona do projeto Bosque Galilea-Amé desde a década de 1950 afirmam ter sido excluídos do projeto e suas perguntas motivaram a Contraloria Departamental de Tolima a convocar uma audiência pública em fevereiro de 2023',
  },
  {
    id_empresa: '890904475-4',
    id_empresa_carbono: 'COL0019EM',
    nombre_empresa: 'Compañía Agrícola San Bartolo S.A.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO230CER'],
    perfil_es:
      'Empresa creada en 1972 dedicada a la comercialización de flores a través de su marca Silvestres. A abril de 2024, contaba con cuatro socios accionistas: su representante legal María Adelaida de Bedout de Mejía, Adriana de Bedout Guerra y Martín de Bedout Guerra, cada uno con 29% de las acciones, y la empresa Flores Silvestres S.A. (representada por Cristian Siegert Castañeda) con el restante 4%.',
    perfil_en:
      'Company created in 1972 dedicated to the commercialization of flowers through its Silvestres brand. As of April 2024, it had four shareholders: its legal representative María Adelaida de Bedout de Mejía, Adriana de Bedout Guerra and Martín de Bedout Guerra, each with 29% of the shares, and the company Flores Silvestres S.A. (represented by Cristian Siegert Castañeda) with the remaining 4%.',
    perfil_pt:
      'Empresa criada em 1972 dedicada à comercialização de flores através da sua marca Silvestres. Em abril de 2024, contava com quatro sócios acionistas: sua representante legal María Adelaida de Bedout de Mejía, Adriana de Bedout Guerra e Martín de Bedout Guerra, cada um com 29% das ações, e a empresa Flores Silvestres S.A. (representada por Cristian Siegert Castañeda) com os 4% restantes.',
  },
  {
    id_empresa: '890917521-1',
    id_empresa_carbono: 'COL0021EM',
    nombre_empresa: 'Agroganadera Montenegro S.A.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO230CER'],
    perfil_es:
      'Empresa creada en 1976. A diciembre de 2006, contaba con cinco socios accionistas, incluyendo su representante legal Isabel Cristina Ramírez y su representante legal suplente Francisco Javier Botero Pineda.',
    perfil_en:
      'Company created in 1976. As of December 2006, it had five shareholders, including its legal representative Isabel Cristina Ramírez and its alternate legal representative Francisco Javier Botero Pineda.',
    perfil_pt:
      'Empresa criada em 1976. Em dezembro de 2006, contava com cinco sócios acionistas, incluindo sua representante legal Isabel Cristina Ramírez e seu representante legal suplente Francisco Javier Botero Pineda.',
  },
  {
    id_empresa: '890700640-7',
    id_empresa_carbono: 'COL0018EM',
    nombre_empresa: 'Universidad del Tolima',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'colombia',
    relacion_proyecto: ['CO008BIO', 'CO034BIO'],
    perfil_es:
      'Universidad pública del departamento del Tolima. Aparece como participante en dos proyectos del mercado de carbono, a través de su facultad de ingeniería forestal. Uno de éstos ha sido motivo de controversia: en el proyecto del Bosque de Galilea, que se desarrolla en predios parcialmente propiedad de la universidad, una veintena campesinos que han vivido en esta zona forestal desde la década de 1950 dicen haber quedado por fuera del proyecto y sus preguntas motivaron que la Contraloría Departamental del Tolima convocara una audiencia pública en febrero de 2023, según reveló una investigación de CLIP y Rutas del Conflicto publicada en febrero de 2024. Hay múltiples vasos comunicantes entre la Fundación Amé que lo desarrolla y la Universidad del Tolima que opera con recursos públicos, incluyendo que dos de los fundadores de la primera fueron decanos de ingeniería forestal de la segunda. La Universidad del Tolima afirmaba a febrero de 2024 no haber recibido ningún recurso del proyecto.',
    perfil_en:
      'Public university of the department of Tolima. It appears as a participant in two carbon market projects, through its forestry engineering faculty. One of these has been a source of controversy: in the Bosque de Galilea project, which is being developed on land partially owned by the university, a group of small-scale farmers who have lived in this forest area since the 1950s claim to have been left out of the project and their questions prompted the Tolima Departmental Comptroller to call a public hearing in February 2023, as revealed in an investigation by CLIP and Rutas del Conflicto published in February 2024. There are multiple communicating vessels between the Amé Foundation that develops it and the University of Tolima that operates with public resources, including that two of the founders of the former were deans of forestry engineering at the latter. The University of Tolima claimed as of February 2024 that it had not received any resources from the project.',
    perfil_pt:
      'Universidade pública do departamento de Tolima. Aparece como participante em dois projetos do mercado de carbono, através da sua faculdade de engenharia florestal. Um deles tem sido motivo de controvérsia: no projeto Bosque de Galilea, que se desenvolve em terrenos parcialmente pertencentes à universidade, cerca de vinte pequenos agricultores que vivem nesta zona florestal desde a década de 1950 afirmam ter sido excluídos do projeto e suas perguntas motivaram a Controladoria Departamental de Tolima a convocar uma audiência pública em fevereiro de 2023, segundo revelou uma investigação do CLIP e Rutas del Conflicto publicada em fevereiro de 2024. Existem múltiplas ligações entre a Fundação Amé, que desenvolve o projeto, e a Universidade de Tolima, que opera com recursos públicos, incluindo o fato de que dois dos fundadores da primeira foram reitores de engenharia florestal da segunda. A Universidade de Tolima afirmava, em fevereiro de 2024, não ter recebido nenhum recurso do projeto.',
  },
  {
    id_empresa: '901575298-3',
    id_empresa_carbono: 'COL0082EM',
    nombre_empresa: 'BioEsferas CO2 S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO034BIO'],
    perfil_es:
      'Empresa creada en 2022. A marzo de 2025 contaba con nueve accionistas: su representante legal Patricia del Carmen Albarán Castro, Ariel Klop, Jairo Alfonso Viña Patiño, Miguel Esteban Oviedo Acosta, Laura Dyann Albarán Zamora, Gustavo Andrés Albarán Perdomo, Nelson Javier Albarán Castro y Carlos Orlando Díaz Albarán, además de las Corporación Bioesferas, según consta en la información registrada en cámara de comercio. Está vinculada a un proyecto en la Orinoquia que figura como ""rechazado"".',
    perfil_en:
      'Company created in 2022. As of March 2025 it had nine shareholders: its legal representative Patricia del Carmen Albarán Castro, Ariel Klop, Jairo Alfonso Viña Patiño, Miguel Esteban Oviedo Acosta, Laura Dyann Albarán Zamora, Gustavo Andrés Albarán Perdomo, Nelson Javier Albarán Castro and Carlos Orlando Díaz Albarán, in addition to Corporación Bioesferas, according to information registered in the chamber of commerce. It is linked to a project in the Orinoquia that is listed as ""rejected"".',
    perfil_pt:
      'Empresa criada em 2022. Em março de 2025, contava com nove acionistas: sua representante legal Patricia del Carmen Albarán Castro, Ariel Klop, Jairo Alfonso Viña Patiño, Miguel Esteban Oviedo Acosta, Laura Dyann Albarán Zamora, Gustavo Andrés Albarán Perdomo, Nelson Javier Albarán Castro e Carlos Orlando Díaz Albarán, além da Corporación Bioesferas, conforme consta nas informações registradas na Câmara de Comércio. Está vinculada a um projeto na Orinoquia que figura como ""rejeitado"".',
  },
  {
    id_empresa: '901562028-5',
    id_empresa_carbono: 'COL0081EM',
    nombre_empresa: 'AFCO2 y Sustinere Colombia S.A.S.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['CO034BIO'],
    perfil_es:
      'Empresa creada en 2022 para prestar servicios forestales, por el canadiense Andrei Stoica y el ecuatoriano Lauro Rodrigo Álvarez Torres, que eran sus representantes legales a marzo de 2025. Está vinculada a un proyecto en la Orinoquia que figura como ""rechazado"".',
    perfil_en:
      'Company created in 2022 to provide forestry services, by Canadian Andrei Stoica and Ecuadorian Lauro Rodrigo Álvarez Torres, who were its legal representatives as of March 2025. It is linked to a project in the Orinoquia that is listed as ""rejected"".',
    perfil_pt:
      'Empresa criada em 2022 para prestar serviços florestais, pelo canadense Andrei Stoica e pelo equatoriano Lauro Rodrigo Álvarez Torres, que eram seus representantes legais em março de 2025. Está vinculada a um projeto na Orinoquia que figura como “rejeitado”.',
  },
  {
    id_empresa: '832000171-1',
    id_empresa_carbono: 'COL0015EM',
    nombre_empresa: 'Corporación Autónoma Regional del Guavio (Corpoguavio)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'agencia_estaod',
    id_pais: 'colombia',
    relacion_proyecto: ['CO025NA'],
    perfil_es:
      'Entidad pública que ejerce como autoridad ambiental regional con sede en Gachalá y jurisdicción en el oriente departamento del Cundinamarca. Lidera un proyecto llamado REDD+ Corpoguavio que no ha sido registrado en ninguna certificadora.',
    perfil_en:
      'Public entity that acts as a regional environmental authority with headquarters in Gachalá and jurisdiction in the eastern department of Cundinamarca. Leads a project called REDD+ Corpoguavio that has not been registered with any certifier.',
    perfil_pt:
      'Entidade pública que atua como autoridade ambiental regional com sede em Gachalá e jurisdição no departamento oriental de Cundinamarca. Lidera um projeto chamado REDD+ Corpoguavio que não foi registrado em nenhuma certificadora.',
  },
]

const empresasPE: IEmpresas[] = [
  {
    id_empresa: '20141502698',
    id_empresa_carbono: 'PER0002EM',
    nombre_empresa: 'Yacumama S.R. Ltda.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE1133VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20197543672',
    id_empresa_carbono: 'PER0003EM',
    nombre_empresa:
      'Asociación para la Investigación y Desarrollo Integral (AIDER)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'peru',
    relacion_proyecto: [
      'PE1067VER',
      'PE1218VER',
      'PE1360VER',
      'PE1455VER',
      'PE1799VER',
      'PE3179VER',
      'PE4429VER',
      'PE4854VER',
    ],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20258679637',
    id_empresa_carbono: 'PER0004EM',
    nombre_empresa:
      'Conservation International Foundation (Conservación Internacional Perú)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'peru',
    relacion_proyecto: ['PE4749VER', 'PE4750VER', 'PE944VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20393341786',
    id_empresa_carbono: 'PER0005EM',
    nombre_empresa: 'Bosques Amazónicos S.A.C. (BAM)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE3344VER', 'PE3726VER', 'PE868VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20504794394',
    id_empresa_carbono: 'PER0007EM',
    nombre_empresa:
      'Centro de Conservación, Investigación y Manejo de Areas Naturales – Cordillera Azul (CIMA-Cordillera Azul)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'peru',
    relacion_proyecto: ['PE985VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20527030421',
    id_empresa_carbono: 'PER0009EM',
    nombre_empresa: 'Maderera Río Acre S.A.C. (Maderacre)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE2502VER', 'PE844VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20527030693',
    id_empresa_carbono: 'PER0010EM',
    nombre_empresa: 'Maderera Río Yaverija S.A.C. (Maderyja)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE844VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20527047669',
    id_empresa_carbono: 'PER0011EM',
    nombre_empresa:
      'Consolidado Forestal Otorongo SAC (antes Inversiones Forestales Chullachaqui SAC)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE2278VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20531549211',
    id_empresa_carbono: 'PER0013EM',
    nombre_empresa: 'Asociación Amazónicos por la Amazonía (AMPA)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'peru',
    relacion_proyecto: ['PE1882VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '901516367-1',
    id_empresa_carbono: 'COL0077EM',
    nombre_empresa: 'Concepto Carbono S.A.S',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'colombia',
    relacion_proyecto: ['PE001NA', 'PE5077VER', 'PER4773VER', 'BR4761VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '',
    id_empresa_carbono: 'URU0001EM',
    nombre_empresa: 'Greenoxx NGO',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'uruguay',
    relacion_proyecto: ['PE2278VER', 'PE844VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '502 303 803',
    id_empresa_carbono: 'FRA0001EM',
    nombre_empresa: 'The Pure Project SARL (PUR Projet)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'franca',
    relacion_proyecto: ['PE958VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20542209799',
    id_empresa_carbono: 'PER0014EM',
    nombre_empresa: 'Fundación Amazonia Viva (Fundavi)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'entidad_sin_animo',
    id_pais: 'peru',
    relacion_proyecto: ['PE958VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '983 615 881',
    id_empresa_carbono: 'FRA0002EM',
    nombre_empresa: 'Ama Pacha SASU',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'franca',
    relacion_proyecto: ['PER5369VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20610464913',
    id_empresa_carbono: 'PER0019EM',
    nombre_empresa: 'Fronterra S.A.C.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PER5369VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20517473724',
    id_empresa_carbono: 'PER0008EM',
    nombre_empresa: 'Corporación Mercantil Recife S.A.C.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PER5290VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20527276773',
    id_empresa_carbono: 'PER0012EM',
    nombre_empresa: 'Federación de Concesionarios de Madre de Dios (FECOMAD)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE3726VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20611287373',
    id_empresa_carbono: 'PER0020EM',
    nombre_empresa: 'Dismart Amazon Carbon S.A.C.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PER101BIO'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20601862141',
    id_empresa_carbono: 'PER0015EM',
    nombre_empresa: 'eGreen S.A.C.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PER101BIO'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20100371741',
    id_empresa_carbono: 'PER0001EM',
    nombre_empresa: 'Maderera Bozovich SAC (Grupo Bozovich)',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE2278VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20606251247',
    id_empresa_carbono: 'PER0018EM',
    nombre_empresa: 'Paskay S.A.C.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE3344VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '1167248658',
    id_empresa_carbono: 'CAN0002EM',
    nombre_empresa: 'Société de Gestion de Projets Ecotierra Inc.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'canada',
    relacion_proyecto: ['PE4674VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '20603219211',
    id_empresa_carbono: 'PER0017EM',
    nombre_empresa: 'Café Selva Norte SAC',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'peru',
    relacion_proyecto: ['PE4674VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
  {
    id_empresa: '1174453713',
    id_empresa_carbono: 'CAN0003EM',
    nombre_empresa: 'Projet Café Selva Norte Eleva Finca Inc.',
    id_rol: 'desarrollador',
    id_tipo_empresa: 'empresa',
    id_pais: 'canada',
    relacion_proyecto: ['PE4674VER'],
    perfil_es: '',
    perfil_en: '',
    perfil_pt: '',
  },
]

export const Empresas: IEmpresas[] = [
  ...empresasBR,
  ...empresasCO,
  ...empresasPE,
]
